import React from 'react';
import classNames from 'classnames';

import css from './ExtraIcons.module.css';

export const ALL_CATEGORIES = 'allCategories';
export const EDIBLE_BOUQUETS = 'edibleBouquets';
export const FRESH_FLOWERS = 'freshFlowers';
export const BAKED_GOODS = 'bakedGoods';
export const CANDY_AND_SWEETS = 'candyAndSweets';
export const INDOOR_PLANTS = 'indoorPlants';
export const BEAUTY = 'beauty';
export const TEA_COFFEE = 'teaCoffee';
export const BALLOONS = 'balloons';
export const PARTY_DECOR = 'partyDecor';
export const GOURMET_SETS = 'gourmetSets';
export const HOME_DECOR = 'homeDecor';
export const TABLEWARE = 'tableware';
export const SEASONAL_GIFTS = 'seasonalGifts';
export const CUSTOM_GIFTS = 'customGifts';
export const GIFT_SETS = 'giftSets';
export const PLAY_ICON = 'playIcon';

/**
 * Payment card icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {'heart' | 'heartIcon' | 'heartOutline' | 'playIcon' | 'cross'} props.icon
 * @returns {JSX.Element} SVG icon
 */
const ExtraIcons = props => {
  const { className, rootClassName, icon = 'default', strokeColor = '#CC0007', style = {} } = props;
  const classes = classNames(rootClassName || css.root, className);

  switch (icon) {
    case PLAY_ICON:
      return (
        <svg
          width="80px"
          height="80px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="11" fill="grey" strokeWidth="1.5" />
          <path
            d="M9 17V7L17 12L9 17Z"
            fill="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case GIFT_SETS:
      return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <g fill="none" stroke-width="2">
            <path
              stroke="#ff7d2b"
              d="M193.51 77.46q-1.43 1.38-3.55 2.25"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f2441c"
              d="M189.96 79.71c1.17-2.56 3.41-5.65 3.09-8.5a2.31 2.2-65.5 0 0-.32-.92q-2.47-4-7.35-5.45-13.44-4.02-28.17-2.33c-9.49 1.09-16.37 2.27-23.75 4.89a.44.44 0 0 1-.58-.34q-.19-1.19.18-2.81"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#fa4b1f"
              d="M133.06 64.25q7.32-5.12 12.72-6.98 6.33-2.18 12.19-5.31c3.1-1.65 7.47-4.67 4.27-8.78a1.8 1.79 69.9 0 0-1.5-.7q-3.72.17-6.29 1.16-7.55 2.9-12.61 6.25-4.96 3.29-9.75 7.02"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f2441c"
              d="M132.09 56.91q-2.12-5.31-5.32-9.58a.43.42-45.8 0 1 0-.51q3.14-4.29 5.91-8.6c2.05-3.18 6.62-8.01 8.76-13.15"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ff9c23"
              d="M215.96 82.93q.02 1.05-.19 1.6a.29.27 21.8 0 1-.38.15q-.21-.09-.43.04-.5.28-.59.31-16.29 4.38-32.5 8.89"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ff7d2b"
              d="m181.87 93.92-27.15-12.04"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#ed3e14" d="m132.09 56.91.97 7.34" vector-effect="non-scaling-stroke" />
            <path
              stroke="#f2701f"
              d="M189.96 79.71q-9.56 5.19-20.72 4.12-6.9-.66-14.52-1.95"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f2441c"
              d="m154.72 81.88-11.04-2.31"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#bd3012"
              d="m143.68 79.57-11.34-4.3a2.69 2.68 35.5 0 0-2.66.44l-.31.25a.96.96 0 0 0 .36 1.67q11.37 3.79 20.52 11.04"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ed3e14"
              d="m150.25 88.67-3.15-.26a4.96 4.74 58.4 0 1-1.6-.42c-2.67-1.21-5.31-2.85-8.13-3.68q-4.76-1.39-10.66-4.2a1.86 1.84 50.7 0 0-1.22-.13q-3.57.83-6.49 2.93"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f2701f"
              d="M119 82.91q-5.4-.72-9.57.78"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f2441c"
              d="M109.43 83.69q-.57.1-.83-.68a.92.9 87.4 0 0-.64-.6l-6.56-1.74a1.41 1.37-19.3 0 1-.39-.18l-3.51-2.46a1.49 1.48-34.2 0 0-1.23-.23l-26.29 6.78"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f2701f"
              d="M69.98 84.58q-9.4 1.15-18.11 1.77-9.96.7-19.16-2.77"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#ed3e14" d="m91.68 64.25 1.18-6.4" vector-effect="non-scaling-stroke" />
            <path stroke="#ff701f" d="m181.87 93.92.31 19.86" vector-effect="non-scaling-stroke" />
            <path
              stroke="#ff9058"
              d="M182.18 113.78q-2.72 1.65-6.6 2.47"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#fa8612"
              d="M213.88 118.33q-5.72 1.96-11.89 2.11"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffaf50"
              d="M201.99 120.44q-4.35-3.4-8.82-6.84-2.44-1.87-5.17-1.38-1.34.24-5.82 1.56"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ed3e14"
              d="M125.2 46.49q6.96 9.94 4.35 21.44c-1.36 5.97-4.24 9.26-9.94 10.87-8.36 2.37-18.85.61-23.02-7.69-1.48-2.96-1.34-11.53-.78-14.27q.45-2.18 3.55-8.83"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ff7d2b"
              d="m109.43 83.69-25.48 17.83"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#fa4b1f"
              d="M83.95 101.52q-17.23-1.13-32.89-7.93"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#ff7d2b" d="m51.06 93.59 18.92-9.01" vector-effect="non-scaling-stroke" />
            <path
              stroke="#ca3d1e"
              d="M143.68 79.57c12.4 7.63 23.11 17.52 29.18 30.99q1.3 2.88 2.72 5.69"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ca7b4e"
              d="m175.58 116.25 3.57 9.85"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#c53616"
              d="m179.15 126.1.36 1.76a1.25 1.25 0 0 1-.23.98q-.9 1.19-2.34.85a1.15 1.14 84.6 0 1-.78-.65q-.35-.82-.98-1.38"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ca7b4e"
              d="M175.18 127.66q.46-.71.34-1.17-1.05-3.88-3.72-9.37"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#c53616"
              d="M171.8 117.12q-.41-.72-.83-1.68-7.03-16-20.72-26.77"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#fa7723" d="m51.06 93.59-2.44 2.1" vector-effect="non-scaling-stroke" />
            <path
              stroke="#ffa42a"
              d="M48.62 95.69c-8.01-3.08-16.5-4.72-24.8-6.77q-5.73-1.41-9.58-4.41"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ff9c23"
              d="M153.29 101.66q-13.69 1.96-26.67 6.2-2.8.91-8.91 1.83"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffa42a"
              d="M117.71 109.69q-11.89-2.4-23.48-5.21-5.16-1.25-10.85-1.53"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#fa7723" d="m83.38 102.95.57-1.43" vector-effect="non-scaling-stroke" />
            <path
              stroke="#fa4b1f"
              d="M75.37 17.91c3.39 5.33 8.58 8.32 12.37 13.48q.92 1.25 4.07 4.79 4.23 4.74 7.55 11.83"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f2441c"
              d="M99.36 48.01c-3.19 2.22-4.78 6.24-6.5 9.84"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#fa4b1f"
              d="M92.86 57.85q-12.5-10.08-27.62-13.97c-3.4-.88-6.81-1.47-7.83 2.18a1.56 1.53-49.4 0 0 .07 1.01q1.57 3.68 4.93 4.99 6.11 2.39 14.78 5.27 6.51 2.16 14.49 6.92"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f2441c"
              d="M91.68 64.25q1.1 1.71.58 3.1a.55.55 0 0 1-.67.33q-13.16-3.98-28.56-4.81-14.32-.77-27.7 4.15-5.22 1.93-7.55 7.13a1.81 1.74-37.8 0 0-.14.97q.39 2.72 1.13 3.37 2.5 2.21 3.94 5.09"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ff7d2b"
              d="M32.71 83.58c-1.96-.6-3-2.18-5.46-2.74"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#fa8950"
              d="m171.8 117.12-9.79 3.6a4.47 4.44-89.9 0 0-2.67 2.68l-6.76 18.71"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#f56112" d="m152.58 142.11.21-7.58" vector-effect="non-scaling-stroke" />
            <path stroke="#fa6a17" d="m152.79 134.53.5-32.87" vector-effect="non-scaling-stroke" />
            <path
              stroke="#fa7723"
              d="M153.29 101.66q-.43-1.1-2.26-2.12-15.63-8.7-32.03-16.63"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#faa64a"
              d="m201.99 120.44 6.94 5.78a3.89 3.84-82.7 0 1 1.06 1.39l3.83 8.42"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffaf50"
              d="m212.58 198.55-31.15 10.79"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f2834c"
              d="m181.43 209.34-5.78 1.56a3.01 2.99-26.4 0 1-3.15-1.05q-.85-1.09-1.42-2.66-4.23-11.63-10.47-31.55c-1.56-4.98-3.54-10.15-5.11-15.16q-1.07-3.4-3.05-7.21"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#faa64a"
              d="m152.45 153.27-1.02-4.51a1.94 1.91 44.6 0 1-.01-.8l1.16-5.85"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#fa8950"
              d="M175.18 127.66c-4.91 5.45 3.28 10.96 7.33 6.13 2.71-3.24.96-7.32-3.36-7.69"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#fa721f" d="m83.38 102.95-.2 32.69" vector-effect="non-scaling-stroke" />
            <path
              stroke="#ed3e14"
              d="m83.18 135.64-34.08-7.18"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f56112"
              d="M49.1 128.46q-.17.54-.53-.68"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#fa721f" d="m48.62 95.69-.05 32.09" vector-effect="non-scaling-stroke" />
            <path
              stroke="#fa8e19"
              d="M48.57 127.78q-.22.94-1 .7c-5.53-1.66-10.64-3.27-16.59-4.54q-7.22-1.54-14.23-3.65"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#fa8612"
              d="m152.79 134.53-33.57 9.32"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ff971f"
              d="M119.22 143.85q-.33-3.59-.6-6.76-.25-3.05-.26-6.8-.01-10.3-.65-20.6"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#fa8e19"
              d="m119.22 143.85-35.79-7.38"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#f26b1b" d="m83.43 136.47-.25-.83" vector-effect="non-scaling-stroke" />
            <path
              stroke="#ed5a0e"
              d="M152.45 153.27q-.11 3.37.91 6.51.3.96-.61 3.4"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#fa8612"
              d="M152.75 163.18c-3.04-7.3-4.58-12.68-1.73-19.54a.59.59 0 0 0-.7-.79l-31.58 8.53"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#fa8e19"
              d="m118.74 151.38-35.19-8.8a.06.06 0 0 1-.04-.04q-.07-.1-.13-.21"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f26314"
              d="M181.43 209.34q.48.83-.23 1.82"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ed3e14"
              d="m181.2 211.16-10.64 3.63a2.12 2.11 62.5 0 1-2.4-.76q-1.55-2.17-2.69-5.22-1.83-4.94-5.84-20.42-2.12-8.17-6.31-15.58"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#ed5a0e" d="m83.43 136.47-.05 5.86" vector-effect="non-scaling-stroke" />
            <path
              stroke="#f26b1b"
              d="M83.38 142.33q-.03.33-.33.59"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f2441c"
              d="M83.05 142.92q-3.96-1.47-8-2.32-12.78-2.68-25.84-5.66"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#ed5a0e" d="m49.1 128.46-.06 5.79" vector-effect="non-scaling-stroke" />
            <path
              stroke="#fa8e19"
              d="M49.04 134.25q-14.07-2.86-27.92-6.4-.91-.24-4.2-.3"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#f26314" d="m152.75 163.18.57 9.63" vector-effect="non-scaling-stroke" />
            <path
              stroke="#fa6a17"
              d="m153.32 172.81-.38 52.12"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ff971f"
              d="M118.74 151.38q-.33 5.96-.33 8.1-.11 32.7.16 65.39.02 2.8-.46 4.93-.5 2.23-1.3 4.78"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#fa6a17" d="m181.2 211.16.69 4.67" vector-effect="non-scaling-stroke" />
            <path
              stroke="#f26b1b"
              d="M49.04 134.25q.05.48.17.69"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ff7827"
              d="m49.21 134.94.04 80.53M83.05 142.92l.17 82.44"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ff9058"
              d="M186.8 154.07c-4.87-4.47-14.71-4.31-16.12 3.67-2.21 12.45 16.04 20.07 25.14 22.68a.74.73-61.4 0 0 .76-.23q7.79-8.97 9.62-19.45c1.01-5.78.01-12.13-5.5-14.73-5.5-2.59-11.35 2.57-13.1 7.85a.49.49 0 0 1-.8.21"
              vector-effect="non-scaling-stroke"
            />
          </g>
          <path
            fill="#ff5127"
            d="M193.51 77.46q-1.43 1.38-3.55 2.25c1.17-2.56 3.41-5.65 3.09-8.5a2.31 2.2-65.5 0 0-.32-.92q-2.47-4-7.35-5.45-13.44-4.02-28.17-2.33c-9.49 1.09-16.37 2.27-23.75 4.89a.44.44 0 0 1-.58-.34q-.19-1.19.18-2.81 7.32-5.12 12.72-6.98 6.33-2.18 12.19-5.31c3.1-1.65 7.47-4.67 4.27-8.78a1.8 1.79 69.9 0 0-1.5-.7q-3.72.17-6.29 1.16-7.55 2.9-12.61 6.25-4.96 3.29-9.75 7.02-2.12-5.31-5.32-9.58a.43.42-45.8 0 1 0-.51q3.14-4.29 5.91-8.6c2.05-3.18 6.62-8.01 8.76-13.15q7.54-7.44 13.07-11.29 9-6.25 19.41-8.09 2.99-.53 7.17.49 4.64 1.13 11.12 6.54a4.72 4.54-86.2 0 1 1.06 1.26q3.89 6.77 4.73 12.26 3.51 22.89-1.29 45.65-.35 1.64-3.2 5.57M75.37 17.91c3.39 5.33 8.58 8.32 12.37 13.48q.92 1.25 4.07 4.79 4.23 4.74 7.55 11.83c-3.19 2.22-4.78 6.24-6.5 9.84q-12.5-10.08-27.62-13.97c-3.4-.88-6.81-1.47-7.83 2.18a1.56 1.53-49.4 0 0 .07 1.01q1.57 3.68 4.93 4.99 6.11 2.39 14.78 5.27 6.51 2.16 14.49 6.92 1.1 1.71.58 3.1a.55.55 0 0 1-.67.33q-13.16-3.98-28.56-4.81-14.32-.77-27.7 4.15-5.22 1.93-7.55 7.13a1.81 1.74-37.8 0 0-.14.97q.39 2.72 1.13 3.37 2.5 2.21 3.94 5.09c-1.96-.6-3-2.18-5.46-2.74l-3.62-5.14a1.94 1.88-75.1 0 1-.23-.41q-2.55-6.17-3.55-12.79-3.1-20.6 2.48-40.64.55-1.98 4.02-8.18a1.76 1.74-6.8 0 1 .39-.49l3.48-3.06a2.55 2.37-76.8 0 1 .52-.35q5.55-2.67 7.55-3.26 2.05-.6 7.5-.54 2.81.03 7.37 1.56 2.47.83 7.57 2.25 6.53 1.82 14.64 8.12"
          />
          <path
            fill="#f54417"
            d="M125.2 46.49q6.96 9.94 4.35 21.44c-1.36 5.97-4.24 9.26-9.94 10.87-8.36 2.37-18.85.61-23.02-7.69-1.48-2.96-1.34-11.53-.78-14.27q.45-2.18 3.55-8.83-3.32-7.09-7.55-11.83-3.15-3.54-4.07-4.79c-3.79-5.16-8.98-8.15-12.37-13.48q8.61 6.27 10.87 9.1 4.23 5.3 8.57 10.38c.64.75 1.01 2.05 1.47 2.58q1.7 1.93 3.89 6a.7.7 0 0 0 1.1.17q.77-.74 1.76-1.14 11.65-4.65 22.17 1.49"
          />
          <path
            fill="#e53710"
            d="M141.44 25.07c-2.14 5.14-6.71 9.97-8.76 13.15q-2.77 4.31-5.91 8.6a.43.42-45.8 0 0 0 .51q3.2 4.27 5.32 9.58l.97 7.34q-.37 1.62-.18 2.81a.44.44 0 0 0 .58.34c7.38-2.62 14.26-3.8 23.75-4.89q14.73-1.69 28.17 2.33 4.88 1.45 7.35 5.45a2.31 2.2-65.5 0 1 .32.92c.32 2.85-1.92 5.94-3.09 8.5q-9.56 5.19-20.72 4.12-6.9-.66-14.52-1.95l-11.04-2.31-11.34-4.3a2.69 2.68 35.5 0 0-2.66.44l-.31.25a.96.96 0 0 0 .36 1.67q11.37 3.79 20.52 11.04l-3.15-.26a4.96 4.74 58.4 0 1-1.6-.42c-2.67-1.21-5.31-2.85-8.13-3.68q-4.76-1.39-10.66-4.2a1.86 1.84 50.7 0 0-1.22-.13q-3.57.83-6.49 2.93-5.4-.72-9.57.78-.57.1-.83-.68a.92.9 87.4 0 0-.64-.6l-6.56-1.74a1.41 1.37-19.3 0 1-.39-.18l-3.51-2.46a1.49 1.48-34.2 0 0-1.23-.23l-26.29 6.78q-9.4 1.15-18.11 1.77-9.96.7-19.16-2.77-1.44-2.88-3.94-5.09-.74-.65-1.13-3.37a1.81 1.74-37.8 0 1 .14-.97q2.33-5.2 7.55-7.13 13.38-4.92 27.7-4.15 15.4.83 28.56 4.81a.55.55 0 0 0 .67-.33q.52-1.39-.58-3.1l1.18-6.4c1.72-3.6 3.31-7.62 6.5-9.84q-3.1 6.65-3.55 8.83c-.56 2.74-.7 11.31.78 14.27 4.17 8.3 14.66 10.06 23.02 7.69 5.7-1.61 8.58-4.9 9.94-10.87q2.61-11.5-4.35-21.44 7.25-11.66 16.24-21.42"
          />
          <path
            fill="#f54417"
            d="m133.06 64.25-.97-7.34q4.79-3.73 9.75-7.02 5.06-3.35 12.61-6.25 2.57-.99 6.29-1.16a1.8 1.79 69.9 0 1 1.5.7c3.2 4.11-1.17 7.13-4.27 8.78q-5.86 3.13-12.19 5.31-5.4 1.86-12.72 6.98M92.86 57.85l-1.18 6.4q-7.98-4.76-14.49-6.92-8.67-2.88-14.78-5.27-3.36-1.31-4.93-4.99a1.56 1.53-49.4 0 1-.07-1.01c1.02-3.65 4.43-3.06 7.83-2.18q15.12 3.89 27.62 13.97"
          />
          <path
            fill="#952814"
            d="M143.68 79.57c12.4 7.63 23.11 17.52 29.18 30.99q1.3 2.88 2.72 5.69l3.57 9.85.36 1.76a1.25 1.25 0 0 1-.23.98q-.9 1.19-2.34.85a1.15 1.14 84.6 0 1-.78-.65q-.35-.82-.98-1.38.46-.71.34-1.17-1.05-3.88-3.72-9.37-.41-.72-.83-1.68-7.03-16-20.72-26.77-9.15-7.25-20.52-11.04a.96.96 0 0 1-.36-1.67l.31-.25a2.69 2.68 35.5 0 1 2.66-.44z"
          />
          <path
            fill="#ffa92e"
            d="m193.51 77.46 22.45 5.47q.02 1.05-.19 1.6a.29.27 21.8 0 1-.38.15q-.21-.09-.43.04-.5.28-.59.31-16.29 4.38-32.5 8.89l-27.15-12.04q7.62 1.29 14.52 1.95 11.16 1.07 20.72-4.12 2.12-.87 3.55-2.25"
          />
          <path
            fill="#ff5127"
            d="m109.43 83.69-25.48 17.83q-17.23-1.13-32.89-7.93l18.92-9.01 26.29-6.78a1.49 1.48-34.2 0 1 1.23.23l3.51 2.46a1.41 1.37-19.3 0 0 .39.18l6.56 1.74a.92.9 87.4 0 1 .64.6q.26.78.83.68M154.72 81.88l27.15 12.04.31 19.86q-2.72 1.65-6.6 2.47-1.42-2.81-2.72-5.69c-6.07-13.47-16.78-23.36-29.18-30.99z"
          />
          <path
            fill="#f54417"
            d="M150.25 88.67q13.69 10.77 20.72 26.77.42.96.83 1.68l-9.79 3.6a4.47 4.44-89.9 0 0-2.67 2.68l-6.76 18.71.21-7.58.5-32.87q-.43-1.1-2.26-2.12-15.63-8.7-32.03-16.63 2.92-2.1 6.49-2.93a1.86 1.84 50.7 0 1 1.22.13q5.9 2.81 10.66 4.2c2.82.83 5.46 2.47 8.13 3.68a4.96 4.74 58.4 0 0 1.6.42z"
          />
          <path
            fill="#ffa92e"
            d="M27.25 80.84c2.46.56 3.5 2.14 5.46 2.74q9.2 3.47 19.16 2.77 8.71-.62 18.11-1.77l-18.92 9.01-2.44 2.1c-8.01-3.08-16.5-4.72-24.8-6.77q-5.73-1.41-9.58-4.41zM119 82.91q16.4 7.93 32.03 16.63 1.83 1.02 2.26 2.12-13.69 1.96-26.67 6.2-2.8.91-8.91 1.83-11.89-2.4-23.48-5.21-5.16-1.25-10.85-1.53l.57-1.43 25.48-17.83q4.17-1.5 9.57-.78"
          />
          <path
            fill="#ff8f17"
            d="M213.88 118.33q-5.72 1.96-11.89 2.11-4.35-3.4-8.82-6.84-2.44-1.87-5.17-1.38-1.34.24-5.82 1.56l-.31-19.86q16.21-4.51 32.5-8.89.09-.03.59-.31.22-.13.43-.04a.29.27 21.8 0 0 .38-.15q.21-.55.19-1.6 3.4 1.61 3.42 3.96.09 10.31 0 21.6-.03 4.03-1.1 6.8a1.7 1.67 85.4 0 1-.72.86z"
          />
          <path
            fill="#ff9f26"
            d="M14.24 84.51q3.85 3 9.58 4.41c8.3 2.05 16.79 3.69 24.8 6.77l-.05 32.09q-.22.94-1 .7c-5.53-1.66-10.64-3.27-16.59-4.54q-7.22-1.54-14.23-3.65-.93-.37-1.95-.52c-3.71-.55-4.34-2.92-4.4-6.45q-.13-9.17-.11-23.56 0-4.8 3.95-5.25"
          />
          <path
            fill="#f54417"
            d="M51.06 93.59q15.66 6.8 32.89 7.93l-.57 1.43-.2 32.69-34.08-7.18q-.17.54-.53-.68l.05-32.09z"
          />
          <path
            fill="#ff8f17"
            d="m153.29 101.66-.5 32.87-33.57 9.32q-.33-3.59-.6-6.76-.25-3.05-.26-6.8-.01-10.3-.65-20.6 6.11-.92 8.91-1.83 12.98-4.24 26.67-6.2"
          />
          <path
            fill="#ff9f26"
            d="M117.71 109.69q.64 10.3.65 20.6.01 3.75.26 6.8.27 3.17.6 6.76l-35.79-7.38-.25-.83.2-32.69q5.69.28 10.85 1.53 11.59 2.81 23.48 5.21"
          />
          <path
            fill="#ffce88"
            d="m201.99 120.44 6.94 5.78a3.89 3.84-82.7 0 1 1.06 1.39l3.83 8.42q.07.87.21 2.01.14 1.11.42 1.98 15.51 46.65 15.83 47.68 1 3.27-2.01 4.78-2.39 1.21-4.95 1.95-5.57 1.61-10.74 4.12l-31.15 10.79-5.78 1.56a3.01 2.99-26.4 0 1-3.15-1.05q-.85-1.09-1.42-2.66-4.23-11.63-10.47-31.55c-1.56-4.98-3.54-10.15-5.11-15.16q-1.07-3.4-3.05-7.21l-1.02-4.51a1.94 1.91 44.6 0 1-.01-.8l1.16-5.85 6.76-18.71a4.47 4.44-89.9 0 1 2.67-2.68l9.79-3.6q2.67 5.49 3.72 9.37.12.46-.34 1.17c-4.91 5.45 3.28 10.96 7.33 6.13 2.71-3.24.96-7.32-3.36-7.69l-3.57-9.85q3.88-.82 6.6-2.47 4.48-1.32 5.82-1.56 2.73-.49 5.17 1.38 4.47 3.44 8.82 6.84m-15.19 33.63c-4.87-4.47-14.71-4.31-16.12 3.67-2.21 12.45 16.04 20.07 25.14 22.68a.74.73-61.4 0 0 .76-.23q7.79-8.97 9.62-19.45c1.01-5.78.01-12.13-5.5-14.73-5.5-2.59-11.35 2.57-13.1 7.85a.49.49 0 0 1-.8.21"
          />
          <path
            fill="#f57d0c"
            d="m213.88 118.33-.06 17.7-3.83-8.42a3.89 3.84-82.7 0 0-1.06-1.39l-6.94-5.78q6.17-.15 11.89-2.11M48.57 127.78q.36 1.22.53.68l-.06 5.79q-14.07-2.86-27.92-6.4-.91-.24-4.2-.3l-.17-7.26q7.01 2.11 14.23 3.65c5.95 1.27 11.06 2.88 16.59 4.54q.78.24 1-.7"
          />
          <path
            fill="#f54417"
            d="M175.18 127.66q.63.56.98 1.38a1.15 1.14 84.6 0 0 .78.65q1.44.34 2.34-.85a1.25 1.25 0 0 0 .23-.98l-.36-1.76c4.32.37 6.07 4.45 3.36 7.69-4.05 4.83-12.24-.68-7.33-6.13"
          />
          <path
            fill="#ff9f26"
            d="M49.04 134.25q.05.48.17.69l.04 80.53c-2.23-.66-4.47-1.05-6.64-1.75q-7.69-2.47-15.52-4.86c-4.16-1.27-8.47-2.42-9.46-6.72q-.32-1.41-.34-6.3-.11-34.16-.37-68.29 3.29.06 4.2.3 13.85 3.54 27.92 6.4"
          />
          <path
            fill="#e53710"
            d="m83.18 135.64.25.83-.05 5.86q-.03.33-.33.59-3.96-1.47-8-2.32-12.78-2.68-25.84-5.66-.12-.21-.17-.69l.06-5.79z"
          />
          <path
            fill="#f57d0c"
            d="m152.79 134.53-.21 7.58-1.16 5.85a1.94 1.91 44.6 0 0 .01.8l1.02 4.51q-.11 3.37.91 6.51.3.96-.61 3.4c-3.04-7.3-4.58-12.68-1.73-19.54a.59.59 0 0 0-.7-.79l-31.58 8.53-35.19-8.8a.06.06 0 0 1-.04-.04q-.07-.1-.13-.21l.05-5.86 35.79 7.38z"
          />
          <path
            fill="#ff5127"
            d="m83.05 142.92.17 82.44-33.97-9.89-.04-80.53q13.06 2.98 25.84 5.66 4.04.85 8 2.32"
          />
          <path
            fill="#ff9f26"
            d="M118.74 151.38q-.33 5.96-.33 8.1-.11 32.7.16 65.39.02 2.8-.46 4.93-.5 2.23-1.3 4.78l-33.59-9.22-.17-82.44q.3-.26.33-.59.06.11.13.21a.06.06 0 0 0 .04.04z"
          />
          <path
            fill="#ff8f17"
            d="m152.75 163.18.57 9.63-.38 52.12q-18.22 6.33-36.13 9.65.8-2.55 1.3-4.78.48-2.13.46-4.93-.27-32.69-.16-65.39 0-2.14.33-8.1l31.58-8.53a.59.59 0 0 1 .7.79c-2.85 6.86-1.31 12.24 1.73 19.54"
          />
          <path
            fill="#ff5127"
            d="M186.8 154.07a.49.49 0 0 0 .8-.21c1.75-5.28 7.6-10.44 13.1-7.85 5.51 2.6 6.51 8.95 5.5 14.73q-1.83 10.48-9.62 19.45a.74.73-61.4 0 1-.76.23c-9.1-2.61-27.35-10.23-25.14-22.68 1.41-7.98 11.25-8.14 16.12-3.67"
          />
          <path
            fill="#e53710"
            d="M152.45 153.27q1.98 3.81 3.05 7.21c1.57 5.01 3.55 10.18 5.11 15.16q6.24 19.92 10.47 31.55.57 1.57 1.42 2.66a3.01 2.99-26.4 0 0 3.15 1.05l5.78-1.56q.48.83-.23 1.82l-10.64 3.63a2.12 2.11 62.5 0 1-2.4-.76q-1.55-2.17-2.69-5.22-1.83-4.94-5.84-20.42-2.12-8.17-6.31-15.58l-.57-9.63q.91-2.44.61-3.4-1.02-3.14-.91-6.51"
          />
          <path
            fill="#f54417"
            d="m181.2 211.16.69 4.67-28.95 9.1.38-52.12q4.19 7.41 6.31 15.58 4.01 15.48 5.84 20.42 1.14 3.05 2.69 5.22a2.12 2.11 62.5 0 0 2.4.76z"
          />
          <path
            fill="#ff8f17"
            d="M212.58 198.55q.84 4.63-2.74 7.43a2.99 2.91-74.4 0 1-.74.43q-7.34 2.95-12.09 4.34-1.79.52-2.79 1c-3.8 1.82-8.2 2.97-12.33 4.08l-.69-4.67q.71-.99.23-1.82z"
          />
        </svg>
      );
    case FRESH_FLOWERS:
      return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <g fill="none" stroke-width="2">
            <path
              stroke="#9b6f44"
              d="m130.8 147.97-4.16-7.39a.66.65 44.3 0 0-1.15.01l-4.38 8.32"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#bf4932"
              d="M92.92 93.39a28.61 24.92-179.6 0 0 28.436 25.12 28.61 24.92-179.6 0 0 28.783-24.72 28.61 24.92-179.6 0 0-28.435-25.12 28.61 24.92-179.6 0 0-28.783 24.72"
              vector-effect="non-scaling-stroke"
            />
          </g>
          <path
            fill="#f75836"
            d="m130.8 147.97-4.16-7.39a.66.65 44.3 0 0-1.15.01l-4.38 8.32q-8.14 13.6-19.32 20.88-8.09 5.26-18.31 5.42c-12.23.19-26.48-4.9-34.13-14.73-7.65-9.84-8.46-22.49-.41-32.34 7.28-8.89 18.19-15.47 28.69-19.95a.46.45 29.7 0 0-.24-.87q-20 2.48-38.07-3.09c-8.2-2.53-15.18-8.5-18.19-17.17q-3.82-11.03.51-21.21 7.82-18.35 27.17-19.84c14.65-1.13 31.8 8.44 42.96 18.01a.27.27 0 0 0 .41-.34C81.67 44.45 76.33 15.12 103.4 6.17q14.07-4.65 27.76-1.43c28.29 6.67 24.53 34.69 15.57 54.82a.45.45 0 0 0 .74.5c10.96-11.18 26.5-23.15 42.63-21.82 13.99 1.15 25.3 11.53 29.78 24.62 1.52 4.41 2.47 8.83 1.05 13.64-5.7 19.38-33.03 25.2-50.33 25.48a.42.42 0 0 0-.1.82c14.28 3.9 31.83 13.22 37.45 27.66 4.45 11.43-2.28 24.95-11.15 32.58-22.86 19.68-51.36 7.28-66-15.07ZM92.92 93.39a28.61 24.92-179.6 0 0 28.436 25.12 28.61 24.92-179.6 0 0 28.783-24.72 28.61 24.92-179.6 0 0-28.435-25.12 28.61 24.92-179.6 0 0-28.783 24.72Z"
          />
          <ellipse fill="#873a2e" rx="28.61" ry="24.92" transform="rotate(-179.6 60.928 46.583)" />
          <path
            fill="#3e8551"
            d="M130.8 147.97q-.17 4.69-.22 9.19-.05 5.43-.43 9.17c-2.02 19.69-5.75 40.68-8.82 61.45a.32.32 0 0 0 .56.26q1.96-2.24 2.89-3.74 7.16-11.59 16.2-19.64c14.46-12.88 31.63-18.4 51.03-18.32q5.39.02 11.34 1.39a2.11 2.11 0 0 1 1.51 2.77q-1.55 4.32-4.76 8.36c-10.92 13.69-25.97 24.73-43.42 28.56q-9.34 2.05-15.3 2.66-11.78 1.21-13.99 1.78-3.33.86-6.71 3.93a1.22 1.2-64.3 0 1-.89.32l-9.79-.65a.77.77 0 0 1-.68-.51q-1.95-5.17-7.68-6.08-1.83-.3-10.15-1.86c-11.54-2.16-23.48-7.97-32.56-15q-14.14-10.96-20.3-28.12-.54-1.51-.3-2.52a2.05 2.05 0 0 1 1.83-1.58c14.25-1.18 31.87 5.08 42.53 12.32q12.9 8.77 20.82 21.66 2.95 4.81 6.14 10.62.47.86 1.66 2.14a.42.41-60.5 0 0 .71-.2q8.02-37.85 9.09-77.42l4.38-8.32a.66.65 44.3 0 1 1.15-.01l4.16 7.39Z"
          />
        </svg>
      );
    case EDIBLE_BOUQUETS:
      return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <g fill="none" stroke-width="2">
            <path
              stroke="#bf452b"
              d="M149.89 38.48q-3.98 1.31-6.83 3.34-3.28 2.32-6.01 4.99c-4.88 4.75-8.49 6.88-14.88 4.86a1.41.94-11.3 0 1-.17-.07l-4.41-2.67a8.45 8.4-29 0 0-4.35-1.23c-6.6-.04-10.29-1.67-15.56-6.64q-1.67-1.57-6.03-2.6"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#c3722c"
              d="M136.4 72.46q-4.08-5.89-11.38-8.52c-6.05-2.17-13.9 4.7-17.47 8.93M144.81 84.86q4.33 7.51 7.79 15.81.2.47 1.3 4.89a.48.47 76.2 0 1-.35.58q-6.32 1.53-9.29 4.12-2.58 2.25-7.76 6.96-4.65 4.23-10.69 3.11a3.99 3.67-24.2 0 1-1.02-.34q-3.97-1.99-7.82-4.43c-3.9-2.46-7.97-2.03-11.97-2.55-3.16-.42-5.54-1.89-7.81-4.45q-3.51-3.94-7.65-7.18a.74.73-56.1 0 1-.18-.94l9.85-16.98"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#bd5b4a"
              d="M194.81 110.29q-3.77 2.75-6.57 4.23c-4.31 2.28-10.77 2.63-15.74 2.89q-.58.03-.94.56"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#6e6240"
              d="M171.56 117.97q.13-.33.05-.6-.08-.26-.45-.36-2.64-.68-5.51-.78"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#bd5b4a"
              d="M165.65 116.23q-5.44-3.38-9.77-8.03a.42.42 0 0 0-.7.44q1.66 4.16 1.79 8.16c.3 9.16-.25 16.38-9.52 21.09-7.85 3.98-16.36 4.93-25.08 6.46"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#6e6240"
              d="M122.37 144.35q-2.93-.74-6.26-.37"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#bd5b4a"
              d="M116.11 143.98c-9.39-2.05-17.44-3.59-25.49-9.16-7.67-5.3-7.94-16.64-5.22-24.64a.28.28 0 0 0-.42-.32l-7.43 5.05a.53.45-86.9 0 0-.15.16q-.4.56-.08.89"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#6e6240"
              d="m77.32 115.96-.36-.22a1.18 1.15-32.1 0 0-.79-.17l-5.04.71"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#bd5b4a"
              d="M71.13 116.28q-12.95.61-22.15-5.89"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#bf452b"
              d="M206.09 87.06q-6.62 0-12.81.96-3.09.47-6.21 1.6c-6.8 2.46-13.33 3.71-19.21-1.5q-6.61-5.86-9.56-8.69-1.98-1.9-10.13-5.24"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#a98f71" d="m84.3 140.69-8.06-3.09" vector-effect="non-scaling-stroke" />
            <path
              stroke="#a48164"
              d="M165.65 116.23q-2.85 13.27-7.15 25.74"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f8887b"
              d="M158.5 141.97c-4.54 1.97-9.46 4.03-13.36 6.48-5.91 3.69-12.12 6.89-17.39 11.47q-2.45 2.13-5.22 4.13"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#a48164" d="m122.53 164.05-.16-19.7" vector-effect="non-scaling-stroke" />
            <path
              stroke="#f8887b"
              d="M203.47 120.85q-5.67 6.52-13.66 9.95-11.66 5-23.32 8.02"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#a48164"
              d="m166.49 138.82 5.07-20.85"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#bf452b"
              d="M95.6 73.22q-7.46 2.66-10.53 5.33c-6 5.23-8.29 7.14-13.85 10.5-5.99 3.63-13.06-.05-17.45-1.87-5.63-2.33-11.29-1.85-16.96-2.11"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#a48164"
              d="m71.13 116.28 5.11 21.32"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f8887b"
              d="M76.24 137.6c-.66-.18-1.27-.03-1.9-.25q-7.42-2.57-14.84-5.1-11.26-3.83-19.51-12.4-.41-.42-1.78.02"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#a48164"
              d="m116.11 143.98-.08 18.68"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f8887b"
              d="M116.03 162.66q-15.01-12.09-19.52-15.43-4.94-3.65-12.21-6.54"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#a48164"
              d="M84.3 140.69c-3.27-7.84-5.04-16.5-6.98-24.73"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#a98f71"
              d="M166.49 138.82q-1.48 1.1-3.96 1.92-2.24.75-4.03 1.23M116.03 162.66l3.33 6.25a.39.38-37.4 0 0 .62.08q2.24-2.38 2.55-4.94"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#fa725b"
              d="M159.8 168.71q-1.13 1.43-2.73.91a2.38 2.36-43.9 0 0-1.41-.02l-23.9 6.83a.75.73-45.8 0 1-.36.01q-7.5-1.72-9.86-1.81-3.7-.13-11.55 1.95a1.76 1.74-43.4 0 1-.97-.02l-22.39-6.87"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#a66b45"
              d="M194.53 58.34q-1.05-.29-2.54-1.04-1.41-.73-2.55-.92-2.97-.51-5.37-2.39c-1.43-1.12-3.55-.89-5.13-.66a3.32 3.27 47.7 0 1-1.27-.07q-2.43-.64-4.98-.47M71.89 50.97q-3.12-.66-6.28.28a2.45 2.42-43.1 0 1-1.52-.04q-1.13-.42-2.25-.38a2.57 2.55 29.3 0 0-1.16.32q-3.13 1.72-6.19 2.21a2.71 2.7 21.4 0 0-1.24.54q-1.79 1.39-4.67 2.13"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#fa725b"
              d="M144.58 225.05q-2.32-2.46-3.71-4.93-5.38-9.56-12.23-23.69-.91-1.88-5.64-8.39a1.27 1.26-12.7 0 0-.81-.51q-4.96-.93-6.6 1.96c-2.02 3.55-4.42 6.5-6.38 10.63q-6.74 14.17-7.63 15.96-2.29 4.56-5.81 9.69"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#e44127"
              d="M123.27 10.87a.23.23 0 0 0-.41-.1l-3.16 4.37a.97.97 0 0 0 .79 1.54h4.04a.85.84-16 0 0 .72-1.29q-1.71-2.73-1.98-4.52M113.9 25.24q1.77-1.62 1.42-4.45a.86.85-23.8 0 0-1.41-.54l-2.03 1.74a1.12 1.11 52 0 0-.18 1.49l1.19 1.66a.68.68 0 0 0 1.01.1M130 20.41q-1.88 2.63.87 5.05a.69.69 0 0 0 1.05-.16q1.75-2.83-1.01-5.01a.63.63 0 0 0-.91.12M102.75 29.77q-.05.16.01.28 1.45 2.89 1.55 3.05a.54.54 0 0 0 .79.12q1.22-1 1.59-2.4t-.18-2.87a.54.54 0 0 0-.75-.29q-.16.09-2.87 1.88-.1.06-.14.23M122.5 34.42l2.27-4.02a.81.8-55.5 0 0-.19-1.01q-2.1-1.77-4.25.03a1.01 1.01 0 0 0-.29 1.16l1.58 3.8a.49.49 0 0 0 .88.04M137.71 34.92q1.64-1.28 1.93-3.15a.62.62 0 0 0-.46-.7q-1.1-.28-2.27-1.33a.69.69 0 0 0-1.11.31q-.94 2.93 1.05 4.83a.66.66 0 0 0 .86.04M111.91 41.92l1.52-2.02a.45.45 0 0 0-.09-.63l-.16-.11a2.16 1.7 36.9 0 0-2.74.06l-.02.02a2.16 1.7 36.9 0 0 .71 2.65l.15.12a.45.45 0 0 0 .63-.09M130.12 44.25q.77-.07 1.57-3.09a1.04 1.02 32.6 0 0-.21-.95q-.53-.6-1.76-.49t-1.64.79a1.04 1.02-42.8 0 0-.05.97q1.33 2.84 2.09 2.77M72.567 59.48a2.22 1.15-121.6 0 0 .184 2.493 2.22 1.15-121.6 0 0 2.142 1.288 2.22 1.15-121.6 0 0-.183-2.494 2.22 1.15-121.6 0 0-2.143-1.288M53.191 63.092a2.21 1.34-84 0 0-1.564 2.058 2.21 1.34-84 0 0 1.102 2.338 2.21 1.34-84 0 0 1.564-2.058 2.21 1.34-84 0 0-1.102-2.338M63.65 66.09q-1.25.36-2.01.8a1.06 1.06 0 0 0-.15 1.73l3.34 2.81a.2.17 64.3 0 0 .06.03q.14.01.28-.03.13-.03.24-.12a.2.17 84 0 0 .04-.06l1.37-4.14a1.06 1.06 0 0 0-1.04-1.4q-.88.02-2.13.38M82.12 67.71l2.22 2.55a.49.49 0 0 0 .69.05l.15-.13a3.48 2.15-41.1 0 0 1.21-3.9l-.04-.05a3.48 2.15-41.1 0 0-4.04.67l-.14.12a.49.49 0 0 0-.05.69M45.9 77.1l1.08-3.43a.45.45 0 0 0-.3-.57l-.12-.04a2.56 2.22 17.5 0 0-3.11 1.35l-.02.06a2.56 2.22 17.5 0 0 1.78 2.88l.12.04a.45.45 0 0 0 .57-.29M76.018 74.97a1.79 1.47-48 0 0-2.29.346 1.79 1.47-48 0 0-.106 2.314 1.79 1.47-48 0 0 2.29-.346 1.79 1.47-48 0 0 .106-2.314M58.67 81.33l1.35-1.62a.6.6 0 0 0-.08-.84l-.28-.23a2.64 1.47 39.7 0 0-2.97-.56l-.23.28a2.64 1.47 39.7 0 0 1.09 2.82l.28.23a.6.6 0 0 0 .84-.08M171.577 60.778a2.19 1.32-66.1 0 0-2.094 1.467 2.19 1.32-66.1 0 0 .32 2.537 2.19 1.32-66.1 0 0 2.094-1.467 2.19 1.32-66.1 0 0-.32-2.537M190.246 65.078a2.25.99-94.7 0 0-.803 2.323 2.25.99-94.7 0 0 1.171 2.161 2.25.99-94.7 0 0 .803-2.323 2.25.99-94.7 0 0-1.171-2.161M157.59 68.45l.78 2.22a.66.66 0 0 0 .85.4l.12-.04a2.45 1.84-19.4 0 0 1.7-2.55 2.45 1.84-19.4 0 0-2.92-.92l-.13.04a.66.66 0 0 0-.4.85M176.59 69.19l1.89 3.93a.23.23 0 0 0 .3.11l.14-.06a4.42 2.39-25.6 0 0 2.95-4.07l-.01-.04a4.42 2.39-25.6 0 0-5.02-.24l-.14.06a.23.23 0 0 0-.11.31M197.65 79.72l2.63-2.52a.29.29 0 0 0 .01-.41l-.1-.11a3.46 2.09 46.3 0 0-3.9-1.05l-.03.02a3.46 2.09 46.3 0 0 .88 3.95l.1.11a.29.29 0 0 0 .41.01M167.16 77.07l.36 1.76a.52.52 0 0 0 .61.41l.3-.06a1.99 1.3-11.4 0 0 1.7-1.67l-.05-.24a1.99 1.3-11.4 0 0-2.21-.88l-.3.06a.52.52 0 0 0-.41.62M183.7 82.19a1.68 1.38 63.6 0 0 2.17.98q.97-.64 1.14-.77a.94.94 0 0 0-.13-1.56q-1.2-.67-2.65-.23-.46.15-.6.65-.13.44.07.93"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#eb901f"
              d="M117.99 78.58q4.17 1.61 7.96.43a1.3 1.3 0 0 0 .8-1.79l-3.21-7.03a1.02 1.02 0 0 0-1.73-.21l-.1.13a8.6.49-60.6 0 1-.6 1.05l-3.57 6.15a.89.88-64.5 0 0 .45 1.27M110.46 93.54q2.49-3.15 3.19-6 .54-2.23-1.62-3.55a.85.82-47.7 0 0-.94.06l-5.34 4.18a.14.13-40.6 0 0-.02.19l4.4 5.13a.21.21 0 0 0 .33-.01M134.44 93.34q1.35-1.62 3.27-2.76a1.1 1.09-35.8 0 0 .27-1.66l-2.94-3.43a1.69 1.69 0 0 0-2.94.74q-.77 3.61.86 6.93a.89.89 0 0 0 1.48.18M120.71 106.04l3.16-4.36a.94.94 0 0 0-.08-1.19q-2.2-2.33-4.92-.53a1.18 1.18 0 0 0-.49 1.3l1.32 4.61a.57.57 0 0 0 1.01.17M102.02 105.46l2.06-2.86a1.07 1.07 0 0 0 .06-1.18q-.45-.78-1.97-1.99a.76.76 0 0 0-.89-.04q-1.31.85-1.66 1.49a2.01 2.01 0 0 0 .05 1.97l1.54 2.57a.49.48 47.6 0 0 .81.04M140.785 102.22a3.05 2.26-82 0 0-2.663 2.706 3.05 2.26-82 0 0 1.813 3.334 3.05 2.26-82 0 0 2.663-2.706 3.05 2.26-82 0 0-1.814-3.334"
              vector-effect="non-scaling-stroke"
            />
          </g>
          <path
            fill="#f64d2f"
            d="M149.89 38.48q-3.98 1.31-6.83 3.34-3.28 2.32-6.01 4.99c-4.88 4.75-8.49 6.88-14.88 4.86a1.41.94-11.3 0 1-.17-.07l-4.41-2.67a8.45 8.4-29 0 0-4.35-1.23c-6.6-.04-10.29-1.67-15.56-6.64q-1.67-1.57-6.03-2.6l8.7-15.4a1.32 1.3 2 0 1 .61-.56q1.06-.49 1.29-1.56a1.63 1.62-18.3 0 1 .36-.71q4.94-5.74 8.91-9.2 4.01-3.51 9.35-5.4a4.74 4.74 0 0 1 3.07-.03q4.71 1.55 8.43 5.15 4.72 4.58 7.25 8.12.21.29.46.88a.81.64-83.4 0 0 .13.21q3.14 3.69 5.64 8.95a3.08 3.06-79.4 0 0 .55.81l.49.51a.55.41 22.7 0 1 .1.17q.56 1.98 2.32 5.45c.33.65.37 1.77.58 2.63m-26.62-27.61a.23.23 0 0 0-.41-.1l-3.16 4.37a.97.97 0 0 0 .79 1.54h4.04a.85.84-16 0 0 .72-1.29q-1.71-2.73-1.98-4.52m-9.37 14.37q1.77-1.62 1.42-4.45a.86.85-23.8 0 0-1.41-.54l-2.03 1.74a1.12 1.11 52 0 0-.18 1.49l1.19 1.66a.68.68 0 0 0 1.01.1m16.1-4.83q-1.88 2.63.87 5.05a.69.69 0 0 0 1.05-.16q1.75-2.83-1.01-5.01a.63.63 0 0 0-.91.12m-27.25 9.36q-.05.16.01.28 1.45 2.89 1.55 3.05a.54.54 0 0 0 .79.12q1.22-1 1.59-2.4t-.18-2.87a.54.54 0 0 0-.75-.29q-.16.09-2.87 1.88-.1.06-.14.23m19.75 4.65 2.27-4.02a.81.8-55.5 0 0-.19-1.01q-2.1-1.77-4.25.03a1.01 1.01 0 0 0-.29 1.16l1.58 3.8a.49.49 0 0 0 .88.04m15.21.5q1.64-1.28 1.93-3.15a.62.62 0 0 0-.46-.7q-1.1-.28-2.27-1.33a.69.69 0 0 0-1.11.31q-.94 2.93 1.05 4.83a.66.66 0 0 0 .86.04m-25.8 7 1.52-2.02a.45.45 0 0 0-.09-.63l-.16-.11a2.16 1.7 36.9 0 0-2.74.06l-.02.02a2.16 1.7 36.9 0 0 .71 2.65l.15.12a.45.45 0 0 0 .63-.09m18.21 2.33q.77-.07 1.57-3.09a1.04 1.02 32.6 0 0-.21-.95q-.53-.6-1.76-.49t-1.64.79a1.04 1.02-42.8 0 0-.05.97q1.33 2.84 2.09 2.77"
          />
          <path
            fill="#d1351f"
            d="M123.27 10.87q.27 1.79 1.98 4.52a.85.84-16 0 1-.72 1.29h-4.04a.97.97 0 0 1-.79-1.54l3.16-4.37a.23.23 0 0 1 .41.1M113.9 25.24a.68.68 0 0 1-1.01-.1l-1.19-1.66a1.12 1.11 52 0 1 .18-1.49l2.03-1.74a.86.85-23.8 0 1 1.41.54q.35 2.83-1.42 4.45M130.91 20.29q2.76 2.18 1.01 5.01a.69.69 0 0 1-1.05.16q-2.75-2.42-.87-5.05a.63.63 0 0 1 .91-.12M106.69 30.82q-.37 1.4-1.59 2.4a.54.54 0 0 1-.79-.12q-.1-.16-1.55-3.05-.06-.12-.01-.28.04-.17.14-.23 2.71-1.79 2.87-1.88a.54.54 0 0 1 .75.29q.55 1.47.18 2.87M122.5 34.42a.49.49 0 0 1-.88-.04l-1.58-3.8a1.01 1.01 0 0 1 .29-1.16q2.15-1.8 4.25-.03a.81.8-55.5 0 1 .19 1.01zM136.85 34.88q-1.99-1.9-1.05-4.83a.69.69 0 0 1 1.11-.31q1.17 1.05 2.27 1.33a.62.62 0 0 1 .46.7q-.29 1.87-1.93 3.15a.66.66 0 0 1-.86-.04"
          />
          <path
            fill="#55885a"
            d="M71.89 50.97q-3.12-.66-6.28.28a2.45 2.42-43.1 0 1-1.52-.04q-1.13-.42-2.25-.38a2.57 2.55 29.3 0 0-1.16.32q-3.13 1.72-6.19 2.21a2.71 2.7 21.4 0 0-1.24.54q-1.79 1.39-4.67 2.13-7.64-3.32-10.71-11.81a1.17 1.17 0 0 1 1.42-1.52l10.48 2.93a2.16 1.97 66.1 0 1 .57.25l3.17 1.96a.42.42 0 0 0 .62-.48q-1.94-6.44-.41-13.65.42-2 1.5-3.01a2.28 2.04 56.8 0 1 3.37.9c.64 1.34 1.84 2.24 2.21 3.51 1.09 3.75 3.41 6.52 2.83 10.77a.38.38 0 0 0 .68.27q4.99-6.72 12.23-9.84a1.08 1.07 81.5 0 1 1.49 1.11q-.55 4.97-2.44 9.39c-.33.76-1.1.82-1.57 1.77q-.62 1.28-2.13 2.39M194.53 58.34q-1.05-.29-2.54-1.04-1.41-.73-2.55-.92-2.97-.51-5.37-2.39c-1.43-1.12-3.55-.89-5.13-.66a3.32 3.27 47.7 0 1-1.27-.07q-2.43-.64-4.98-.47-3.11-1.65-4.2-5.5-1.14-4.02-1.61-8.08a1.03 1.03 0 0 1 1.5-1.03q6.42 3.34 10.39 9.51a.69.69 0 0 0 1.26-.29q.94-7.38 6.51-13.69a1.2 1.2 0 0 1 1.81.01l1.01 1.17a.74.69 19.7 0 1 .15.29q2.43 8.18-.41 15.64a.22.22 0 0 0 .3.28l5.8-2.83a1.74 1.6-61.5 0 1 .35-.12l7.97-1.58a1.28 1.27 51.9 0 1 .79.1l1.92.87a.33.32-60.4 0 1 .13.48q-.06.08-.41.13a.91.89-76.1 0 0-.63.39q-2.28 3.42-4.02 5.49-2.28 2.74-6.77 4.31"
          />
          <path
            fill="#873c26"
            d="M136.4 72.46q-4.08-5.89-11.38-8.52c-6.05-2.17-13.9 4.7-17.47 8.93q-6.54-2.53-9.33-4.84-14.37-11.89-6.57-29.57 4.36 1.03 6.03 2.6c5.27 4.97 8.96 6.6 15.56 6.64a8.45 8.4-29 0 1 4.35 1.23L122 51.6a1.41.94-11.3 0 0 .17.07c6.39 2.02 10-.11 14.88-4.86q2.73-2.67 6.01-4.99 2.85-2.03 6.83-3.34.62-.15 1.48.23a1.19 1.16-84.6 0 1 .66.82l1.58 7.39a.89.63 35.5 0 0 .09.26q1.03 2.11.52 4.34-.57 2.46-1.98 7.3a3.96 3.91 69.1 0 1-.39.89q-5.43 8.81-15.45 12.75"
          />
          <path
            fill="#d1351f"
            d="M111.91 41.92a.45.45 0 0 1-.63.09l-.15-.12a2.16 1.7 36.9 0 1-.71-2.65l.02-.02a2.16 1.7 36.9 0 1 2.74-.06l.16.11a.45.45 0 0 1 .09.63zM129.72 39.72q1.23-.11 1.76.49a1.04 1.02 32.6 0 1 .21.95q-.8 3.02-1.57 3.09-.76.07-2.09-2.77a1.04 1.02-42.8 0 1 .05-.97q.41-.68 1.64-.79"
          />
          <path
            fill="#f64d2f"
            d="M71.89 50.97q7.83 2.23 12.24 6.15 6.74 5.98 11.47 16.1-7.46 2.66-10.53 5.33c-6 5.23-8.29 7.14-13.85 10.5-5.99 3.63-13.06-.05-17.45-1.87-5.63-2.33-11.29-1.85-16.96-2.11q-.21-10.45 4.12-19.67a7.61 7.18 79.4 0 1 1.08-1.68l6.57-7.69q2.88-.74 4.67-2.13a2.71 2.7 21.4 0 1 1.24-.54q3.06-.49 6.19-2.21a2.57 2.55 29.3 0 1 1.16-.32q1.12-.04 2.25.38a2.45 2.42-43.1 0 0 1.52.04q3.16-.94 6.28-.28m.677 8.51a2.22 1.15-121.6 0 0 .184 2.493 2.22 1.15-121.6 0 0 2.142 1.288 2.22 1.15-121.6 0 0-.183-2.494 2.22 1.15-121.6 0 0-2.143-1.288M53.19 63.091a2.21 1.34-84 0 0-1.564 2.058 2.21 1.34-84 0 0 1.102 2.338 2.21 1.34-84 0 0 1.564-2.058 2.21 1.34-84 0 0-1.102-2.338M63.65 66.09q-1.25.36-2.01.8a1.06 1.06 0 0 0-.15 1.73l3.34 2.81a.2.17 64.3 0 0 .06.03q.14.01.28-.03.13-.03.24-.12a.2.17 84 0 0 .04-.06l1.37-4.14a1.06 1.06 0 0 0-1.04-1.4q-.88.02-2.13.38m18.47 1.62 2.22 2.55a.49.49 0 0 0 .69.05l.15-.13a3.48 2.15-41.1 0 0 1.21-3.9l-.04-.05a3.48 2.15-41.1 0 0-4.04.67l-.14.12a.49.49 0 0 0-.05.69M45.9 77.1l1.08-3.43a.45.45 0 0 0-.3-.57l-.12-.04a2.56 2.22 17.5 0 0-3.11 1.35l-.02.06a2.56 2.22 17.5 0 0 1.78 2.88l.12.04a.45.45 0 0 0 .57-.29m30.118-2.13a1.79 1.47-48 0 0-2.29.346 1.79 1.47-48 0 0-.106 2.314 1.79 1.47-48 0 0 2.29-.346 1.79 1.47-48 0 0 .106-2.314M58.67 81.33l1.35-1.62a.6.6 0 0 0-.08-.84l-.28-.23a2.64 1.47 39.7 0 0-2.97-.56l-.23.28a2.64 1.47 39.7 0 0 1.09 2.82l.28.23a.6.6 0 0 0 .84-.08M194.53 58.34q4.46 4.48 7.41 9.53c1.52 2.6 1.68 5.27 2.89 7.83a1.72 1.69-61.2 0 1 .16.57l1.1 10.79q-6.62 0-12.81.96-3.09.47-6.21 1.6c-6.8 2.46-13.33 3.71-19.21-1.5q-6.61-5.86-9.56-8.69-1.98-1.9-10.13-5.24 2.64-4.1 5.1-7.75 4.3-6.4 8.8-9.39 4-2.65 10.62-4.26 2.55-.17 4.98.47a3.32 3.27 47.7 0 0 1.27.07c1.58-.23 3.7-.46 5.13.66q2.4 1.88 5.37 2.39 1.14.19 2.55.92 1.49.75 2.54 1.04m-22.953 2.438a2.19 1.32-66.1 0 0-2.094 1.467 2.19 1.32-66.1 0 0 .32 2.537 2.19 1.32-66.1 0 0 2.094-1.467 2.19 1.32-66.1 0 0-.32-2.537m18.669 4.3a2.25.99-94.7 0 0-.803 2.323 2.25.99-94.7 0 0 1.171 2.161 2.25.99-94.7 0 0 .803-2.323 2.25.99-94.7 0 0-1.171-2.161M157.59 68.45l.78 2.22a.66.66 0 0 0 .85.4l.12-.04a2.45 1.84-19.4 0 0 1.7-2.55 2.45 1.84-19.4 0 0-2.92-.92l-.13.04a.66.66 0 0 0-.4.85m19 .74 1.89 3.93a.23.23 0 0 0 .3.11l.14-.06a4.42 2.39-25.6 0 0 2.95-4.07l-.01-.04a4.42 2.39-25.6 0 0-5.02-.24l-.14.06a.23.23 0 0 0-.11.31m21.06 10.53 2.63-2.52a.29.29 0 0 0 .01-.41l-.1-.11a3.46 2.09 46.3 0 0-3.9-1.05l-.03.02a3.46 2.09 46.3 0 0 .88 3.95l.1.11a.29.29 0 0 0 .41.01m-30.49-2.65.36 1.76a.52.52 0 0 0 .61.41l.3-.06a1.99 1.3-11.4 0 0 1.7-1.67l-.05-.24a1.99 1.3-11.4 0 0-2.21-.88l-.3.06a.52.52 0 0 0-.41.62m16.54 5.12a1.68 1.38 63.6 0 0 2.17.98q.97-.64 1.14-.77a.94.94 0 0 0-.13-1.56q-1.2-.67-2.65-.23-.46.15-.6.65-.13.44.07.93"
          />
          <ellipse fill="#d1351f" rx="2.22" ry="1.15" transform="rotate(238.4 54.014 10.082)" />
          <ellipse fill="#d1351f" rx="2.19" ry="1.32" transform="rotate(-66.1 133.59 -99.779)" />
          <ellipse fill="#d1351f" rx="2.21" ry="1.34" transform="rotate(-84 62.736 3.236)" />
          <path
            fill="#ffa731"
            d="M136.4 72.46q1.26 1.92 2.38 3.01a2.79 2.51-87 0 1 .42.52l5.61 8.87q4.33 7.51 7.79 15.81.2.47 1.3 4.89a.48.47 76.2 0 1-.35.58q-6.32 1.53-9.29 4.12-2.58 2.25-7.76 6.96-4.65 4.23-10.69 3.11a3.99 3.67-24.2 0 1-1.02-.34q-3.97-1.99-7.82-4.43c-3.9-2.46-7.97-2.03-11.97-2.55-3.16-.42-5.54-1.89-7.81-4.45q-3.51-3.94-7.65-7.18a.74.73-56.1 0 1-.18-.94l9.85-16.98q2.07-2.33 3.38-4.73a1.94 1.14-86.1 0 1 .15-.22l4.81-5.64c3.57-4.23 11.42-11.1 17.47-8.93q7.3 2.63 11.38 8.52m-18.41 6.12q4.17 1.61 7.96.43a1.3 1.3 0 0 0 .8-1.79l-3.21-7.03a1.02 1.02 0 0 0-1.73-.21l-.1.13a8.6.49-60.6 0 1-.6 1.05l-3.57 6.15a.89.88-64.5 0 0 .45 1.27m-7.53 14.96q2.49-3.15 3.19-6 .54-2.23-1.62-3.55a.85.82-47.7 0 0-.94.06l-5.34 4.18a.14.13-40.6 0 0-.02.19l4.4 5.13a.21.21 0 0 0 .33-.01m23.98-.2q1.35-1.62 3.27-2.76a1.1 1.09-35.8 0 0 .27-1.66l-2.94-3.43a1.69 1.69 0 0 0-2.94.74q-.77 3.61.86 6.93a.89.89 0 0 0 1.48.18m-13.73 12.7 3.16-4.36a.94.94 0 0 0-.08-1.19q-2.2-2.33-4.92-.53a1.18 1.18 0 0 0-.49 1.3l1.32 4.61a.57.57 0 0 0 1.01.17m-18.69-.58 2.06-2.86a1.07 1.07 0 0 0 .06-1.18q-.45-.78-1.97-1.99a.76.76 0 0 0-.89-.04q-1.31.85-1.66 1.49a2.01 2.01 0 0 0 .05 1.97l1.54 2.57a.49.48 47.6 0 0 .81.04m38.765-3.24a3.05 2.26-82 0 0-2.663 2.706 3.05 2.26-82 0 0 1.813 3.334 3.05 2.26-82 0 0 2.663-2.706 3.05 2.26-82 0 0-1.814-3.334"
          />
          <ellipse fill="#d1351f" rx="2.25" ry=".99" transform="rotate(-94.7 126.221 -54.048)" />
          <path
            fill="#d1351f"
            d="M65.17 71.43q-.14.04-.28.03a.2.17 64.3 0 1-.06-.03l-3.34-2.81a1.06 1.06 0 0 1 .15-1.73q.76-.44 2.01-.8t2.13-.38a1.06 1.06 0 0 1 1.04 1.4l-1.37 4.14a.2.17 84 0 1-.04.06q-.11.09-.24.12M82.12 67.71a.49.49 0 0 1 .05-.69l.14-.12a3.48 2.15-41.1 0 1 4.04-.67l.04.05a3.48 2.15-41.1 0 1-1.21 3.9l-.15.13a.49.49 0 0 1-.69-.05zM157.59 68.45a.66.66 0 0 1 .4-.85l.13-.04a2.45 1.84-19.4 0 1 2.92.92 2.45 1.84-19.4 0 1-1.7 2.55l-.12.04a.66.66 0 0 1-.85-.4zM176.59 69.19a.23.23 0 0 1 .11-.31l.14-.06a4.42 2.39-25.6 0 1 5.02.24l.01.04a4.42 2.39-25.6 0 1-2.95 4.07l-.14.06a.23.23 0 0 1-.3-.11z"
          />
          <path
            fill="#d7790c"
            d="M117.99 78.58a.89.88-64.5 0 1-.45-1.27l3.57-6.15a8.6.49-60.6 0 0 .6-1.05l.1-.13a1.02 1.02 0 0 1 1.73.21l3.21 7.03a1.3 1.3 0 0 1-.8 1.79q-3.79 1.18-7.96-.43"
          />
          <path
            fill="#d1351f"
            d="M45.9 77.1a.45.45 0 0 1-.57.29l-.12-.04a2.56 2.22 17.5 0 1-1.78-2.88l.02-.06a2.56 2.22 17.5 0 1 3.11-1.35l.12.04a.45.45 0 0 1 .3.57z"
          />
          <path
            fill="#873c26"
            d="m99.21 83.46-9.85 16.98a.74.73-56.1 0 0 .18.94q4.14 3.24 7.65 7.18c2.27 2.56 4.65 4.03 7.81 4.45 4 .52 8.07.09 11.97 2.55q3.85 2.44 7.82 4.43a3.99 3.67-24.2 0 0 1.02.34q6.04 1.12 10.69-3.11 5.18-4.71 7.76-6.96 2.97-2.59 9.29-4.12a.48.47 76.2 0 0 .35-.58q-1.1-4.42-1.3-4.89-3.46-8.3-7.79-15.81l1.15-5.69a1.49 1.48-15.4 0 1 .45-.78q.71-.64.87-1.38.43-2.08.89-2.82 8.15 3.34 10.13 5.24 2.95 2.83 9.56 8.69c5.88 5.21 12.41 3.96 19.21 1.5q3.12-1.13 6.21-1.6 6.19-.96 12.81-.96.39 2.42-.21 4.76-.32 1.26-2.04 5.4-2.99 7.17-9.03 13.07-3.77 2.75-6.57 4.23c-4.31 2.28-10.77 2.63-15.74 2.89q-.58.03-.94.56.13-.33.05-.6-.08-.26-.45-.36-2.64-.68-5.51-.78-5.44-3.38-9.77-8.03a.42.42 0 0 0-.7.44q1.66 4.16 1.79 8.16c.3 9.16-.25 16.38-9.52 21.09-7.85 3.98-16.36 4.93-25.08 6.46q-2.93-.74-6.26-.37c-9.39-2.05-17.44-3.59-25.49-9.16-7.67-5.3-7.94-16.64-5.22-24.64a.28.28 0 0 0-.42-.32l-7.43 5.05a.53.45-86.9 0 0-.15.16q-.4.56-.08.89l-.36-.22a1.18 1.15-32.1 0 0-.79-.17l-5.04.71q-12.95.61-22.15-5.89-8.3-7.08-11.13-16.87-.04-.14-.98-2.94-1.01-3-.06-5.51c5.67.26 11.33-.22 16.96 2.11 4.39 1.82 11.46 5.5 17.45 1.87 5.56-3.36 7.85-5.27 13.85-10.5q3.07-2.67 10.53-5.33 2.86 4.59 3.61 10.24"
          />
          <ellipse fill="#d1351f" rx="1.79" ry="1.47" transform="rotate(-48 123.096 -45.874)" />
          <path
            fill="#d1351f"
            d="M197.65 79.72a.29.29 0 0 1-.41-.01l-.1-.11a3.46 2.09 46.3 0 1-.88-3.95l.03-.02a3.46 2.09 46.3 0 1 3.9 1.05l.1.11a.29.29 0 0 1-.01.41zM167.16 77.07a.52.52 0 0 1 .41-.62l.3-.06a1.99 1.3-11.4 0 1 2.21.88l.05.24a1.99 1.3-11.4 0 1-1.7 1.67l-.3.06a.52.52 0 0 1-.61-.41zM58.67 81.33a.6.6 0 0 1-.84.08l-.28-.23a2.64 1.47 39.7 0 1-1.09-2.82l.23-.28a2.64 1.47 39.7 0 1 2.97.56l.28.23a.6.6 0 0 1 .08.84zM183.7 82.19q-.2-.49-.07-.93.14-.5.6-.65 1.45-.44 2.65.23a.94.94 0 0 1 .13 1.56q-.17.13-1.14.77a1.68 1.38 63.6 0 1-2.17-.98"
          />
          <path
            fill="#d7790c"
            d="M110.46 93.54a.21.21 0 0 1-.33.01l-4.4-5.13a.14.13-40.6 0 1 .02-.19l5.34-4.18a.85.82-47.7 0 1 .94-.06q2.16 1.32 1.62 3.55-.7 2.85-3.19 6M134.44 93.34a.89.89 0 0 1-1.48-.18q-1.63-3.32-.86-6.93a1.69 1.69 0 0 1 2.94-.74l2.94 3.43a1.1 1.09-35.8 0 1-.27 1.66q-1.92 1.14-3.27 2.76M120.71 106.04a.57.57 0 0 1-1.01-.17l-1.32-4.61a1.18 1.18 0 0 1 .49-1.3q2.72-1.8 4.92.53a.94.94 0 0 1 .08 1.19zM102.02 105.46a.49.48 47.6 0 1-.81-.04l-1.54-2.57a2.01 2.01 0 0 1-.05-1.97q.35-.64 1.66-1.49a.76.76 0 0 1 .89.04q1.52 1.21 1.97 1.99a1.07 1.07 0 0 1-.06 1.18z"
          />
          <ellipse fill="#d7790c" rx="3.05" ry="2.26" transform="rotate(-82 130.712 -28.113)" />
          <path
            fill="#f37a6e"
            d="M165.65 116.23q-2.85 13.27-7.15 25.74c-4.54 1.97-9.46 4.03-13.36 6.48-5.91 3.69-12.12 6.89-17.39 11.47q-2.45 2.13-5.22 4.13l-.16-19.7c8.72-1.53 17.23-2.48 25.08-6.46 9.27-4.71 9.82-11.93 9.52-21.09q-.13-4-1.79-8.16a.42.42 0 0 1 .7-.44q4.33 4.65 9.77 8.03M116.11 143.98l-.08 18.68q-15.01-12.09-19.52-15.43-4.94-3.65-12.21-6.54c-3.27-7.84-5.04-16.5-6.98-24.73q-.32-.33.08-.89a.53.45-86.9 0 1 .15-.16l7.43-5.05a.28.28 0 0 1 .42.32c-2.72 8-2.45 19.34 5.22 24.64 8.05 5.57 16.1 7.11 25.49 9.16M48.98 110.39q9.2 6.5 22.15 5.89l5.11 21.32c-.66-.18-1.27-.03-1.9-.25q-7.42-2.57-14.84-5.1-11.26-3.83-19.51-12.4-.41-.42-1.78.02.81-8.59 10.77-9.48M194.81 110.29q6.1 2.54 8.29 7.1.78 1.63.37 3.46-5.67 6.52-13.66 9.95-11.66 5-23.32 8.02l5.07-20.85q.36-.53.94-.56c4.97-.26 11.43-.61 15.74-2.89q2.8-1.48 6.57-4.23"
          />
          <path
            fill="#55885a"
            d="M77.32 115.96c1.94 8.23 3.71 16.89 6.98 24.73l-8.06-3.09-5.11-21.32 5.04-.71a1.18 1.15-32.1 0 1 .79.17zM171.56 117.97l-5.07 20.85q-1.48 1.1-3.96 1.92-2.24.75-4.03 1.23 4.3-12.47 7.15-25.74 2.87.1 5.51.78.37.1.45.36.08.27-.05.6"
          />
          <path
            fill="#fd9687"
            d="m76.24 137.6 8.06 3.09q7.27 2.89 12.21 6.54 4.51 3.34 19.52 15.43l3.33 6.25a.39.38-37.4 0 0 .62.08q2.24-2.38 2.55-4.94 2.77-2 5.22-4.13c5.27-4.58 11.48-7.78 17.39-11.47 3.9-2.45 8.82-4.51 13.36-6.48q1.79-.48 4.03-1.23 2.48-.82 3.96-1.92 11.66-3.02 23.32-8.02 7.99-3.43 13.66-9.95-.47 6.39-2.96 10.67-3.82 6.56-11.98 17-3.73 4.78-8.15 7.86-6.36 4.43-12.93 8-.13.07-.6.15a1.88 1.85-68.6 0 0-.83.37q-2.15 1.68-5.31 2.5-.54.14-.71.45-.16.32-.2.86-1.13 1.43-2.73.91a2.38 2.36-43.9 0 0-1.41-.02l-23.9 6.83a.75.73-45.8 0 1-.36.01q-7.5-1.72-9.86-1.81-3.7-.13-11.55 1.95a1.76 1.74-43.4 0 1-.97-.02l-22.39-6.87q.11-.67-.21-.79-8.9-3.48-15.75-7.81-3.03-1.91-4.07-2.42-6.48-3.15-11.96-9.77-8.38-10.1-12.33-16.71-2.51-4.2-4.1-12.32 1.37-.44 1.78-.02 8.25 8.57 19.51 12.4 7.42 2.53 14.84 5.1c.63.22 1.24.07 1.9.25"
          />
          <path
            fill="#55885a"
            d="m122.37 144.35.16 19.7q-.31 2.56-2.55 4.94a.39.38-37.4 0 1-.62-.08l-3.33-6.25.08-18.68q3.33-.37 6.26.37"
          />
          <path
            fill="#f64d2f"
            d="m86.63 169.69 22.39 6.87a1.76 1.74-43.4 0 0 .97.02q7.85-2.08 11.55-1.95 2.36.09 9.86 1.81a.75.73-45.8 0 0 .36-.01l23.9-6.83a2.38 2.36-43.9 0 1 1.41.02q1.6.52 2.73-.91 3.62.1 7.22-.52 7.45-1.28 9.79 5.41.71 2.02.77 6.4.13 8.95-7.6 12.28-2.56 1.11-7.07.46c-2.65-.38-4.7.18-7.55-.81q-1.47-.5-4.49-.79a2.62 2.54-27.5 0 1-.94-.28q-1.2-.6-2.55-.47a1.48 1.47-34.2 0 1-.85-.16q-2.5-1.27-5.88-1.41a.21.2-25.8 0 0-.13.37l10.42 7.54a6.3 6.26-89.8 0 1 1.47 1.49q1.29 1.84 3.49 3.72a2.47 2.35 8.4 0 1 .61.78q1.15 2.33 3.12 3.68a1.49 1.48 11.5 0 1 .62.93q.01.02.03.28a.17.12-80.8 0 0 .04.08l4.97 5.79a.55.55 0 0 1-.42.9h-6.1a.8.79-11.9 0 1-.73-.47c-.36-.83-1.43-1.2-2.3-1.04q-2.37.44-3.97-1.31a1.4 1.4 0 0 0-2.38.59l-2.11 8.03a1.63 1.3-29.1 0 1-.16.39l-2.54 4.48q-2.32-2.46-3.71-4.93-5.38-9.56-12.23-23.69-.91-1.88-5.64-8.39a1.27 1.26-12.7 0 0-.81-.51q-4.96-.93-6.6 1.96c-2.02 3.55-4.42 6.5-6.38 10.63q-6.74 14.17-7.63 15.96-2.29 4.56-5.81 9.69-1.96-4.66-3.8-9.01-.46-1.09-.83-5.19a.56.56 0 0 0-.58-.51c-2.07.11-3.42 1.91-5.46 1.84q-1.62-.05-2.23 1.13a.51.51 0 0 1-.42.28l-5.62.44a.98.98 0 0 1-.89-1.53q.64-.94 4.77-6.54.09-.13.37-.23a.72.71 8.4 0 0 .3-.22l7.42-8.96a2.15 1.6-79.8 0 1 .3-.28l9.37-6.7a.55.55 0 0 0-.32-1h-2.21a.97.97 0 0 0-.72.32q-.82.92-2.37.77c-.98-.1-1.33.26-2.07.6a1.19.83-50.7 0 1-.14.05l-7.92 1.56a1.29 1.15 36.9 0 1-.35.03q-3.08-.22-5.35.27c-2.17.46-3.6-.53-5.54-.32a1.5 1.49 58 0 1-.98-.23q-4-2.56-5.07-3.75-.49-.54-1.65-3.47c-1.33-3.35-.61-9.31.35-12.23q.61-1.85 2.81-3.73a2.25 2.24 18.6 0 1 .93-.46q4.09-.93 6.92-.49 3.39.53 5.46.42a1.4.95-29.2 0 1 .23.02z"
          />
          <path
            fill="#fd9687"
            d="M144.58 225.05q2.25 2.53-.06 4.22c-3.46 2.54-7.5 4.38-11.22 4.62a3.56 3.26-54.6 0 0-1.02.22q-12.29 4.52-25.2 0-.88-.31-1.57-.21a.95.86-35.2 0 1-.4-.05l-5.93-2.35a.88.65-8.3 0 1-.13-.07q-2.19-1.52-3.9-3.13-1.24-1.17.62-2.53 3.52-5.13 5.81-9.69.89-1.79 7.63-15.96c1.96-4.13 4.36-7.08 6.38-10.63q1.64-2.89 6.6-1.96a1.27 1.26-12.7 0 1 .81.51q4.73 6.51 5.64 8.39 6.85 14.13 12.23 23.69 1.39 2.47 3.71 4.93"
          />
        </svg>
      );
    case BAKED_GOODS:
      return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <g fill="none" stroke-width="2">
            <path
              stroke="#9d742c"
              d="M142.9 30.67q-8.5-14.91-23.29-16.73"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#ed9065" d="m145.6 41.86-.55 2.65" vector-effect="non-scaling-stroke" />
            <path
              stroke="#ed936d"
              d="M145.05 44.51c-3.81 15.48-15.73 20.32-30.72 24.1q-4.51 1.14-8.36.81c-8.77-.76-12.79-11.91-12.81-19.32q-.01-4.04.44-8.05"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffdda9"
              d="M151.92 85.36c-5.66 14.54-34.29 12.65-45.49 9.46q-1.23-.35-2.49-.97a.28.28 0 0 1 .15-.53c8.91 1.13 15.67-3.63 21.87-9.85q8.52-8.55 8.44-20a.51.51 0 0 0-.53-.51q-2.26.08-2.67 1.83c-1.61 6.94-5.97 12.89-11.03 17.61q-13.59 12.68-29.04 4.01"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffba97"
              d="M231.05 75.01q-1.26 5.37-5.19 8.62-10.72 8.88-24.82 13.78-21.1 7.33-44.01 9.72-8.71.91-25.91.78-6.38-.05-26.11-.04-28.32.01-55.58-7.05c-12.75-3.3-27.8-8.67-35.73-18.28q-3.6-4.37-2.89-11.25"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffe3b2"
              d="M91.75 42.28c.06 9.1.54 15.06 4.26 21.79a1.37 1.36 51.4 0 1-.17 1.57q-7.35 8.27-4.71 20.77"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffdaa1"
              d="M91.13 86.41q-.3 3.05 3.16 6.08c8.8 7.67 22.22 8.7 34.86 8.13q9.55-.43 16.67-5.02 5.71-3.69 6.1-10.24"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffe3b2"
              d="M151.92 85.36q.77-7.1-1.77-12.49-3.38-7.18-9.78-14.73a.72.71 39.6 0 1-.08-.81c2.39-4.27 4.99-7.62 4.76-12.82"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffdaa1"
              d="M205.67 65.08q.13 4.04-3.58 7.02c-7.66 6.15-19.95 5.93-30.89 4.77-6.23-.67-14.49-3.69-18.17-9.16q-1.2-1.78-.76-2.66M86.23 64.24q-1.39 8.4-10.98 11.07-13.18 3.68-27.62-.06c-4.14-1.07-9.37-3.83-11.98-6.4q-2.62-2.57-3.01-6.66"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffe3b2"
              d="M80.31 43.8c5.5 6.19 7.28 12.04 5.92 20.44"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffdda9"
              d="M86.23 64.24q-3.01 4.77-7.53 6.23-16.11 5.2-32.37.44a.42.42 0 0 1 .04-.82c5.65-1.05 9.49-3.97 14.36-7.88q8.04-6.44 8.77-16.17c.47-6.19 0-10.67-4.9-14.42q-.5-.38-1.39-.48a.52.52 0 0 0-.51.78l3.73 6.65a.23.22-70.3 0 1 .04.09c1.35 6.34-3.6 14.77-7.5 19.3q-7.62 8.87-19.03 7.84-4.4-.4-7.3-3.61"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffe3b2"
              d="m32.64 62.19.27-7.68M206.51 55.31l-.84 9.77"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffdda9"
              d="M205.67 65.08q-3.17 4.88-8.81 6.53-15.73 4.6-31.65.25a.35.35 0 0 1 0-.67q9.21-2.64 16.01-9.1c7.31-6.95 9.01-15.47 6.69-25.1q-.87-3.61-4.46-5.86a.46.45 10.4 0 0-.69.47q.23 1.12.99 2.14 4 5.32 2.16 11.36-2.98 9.82-11.05 16.74-10.79 9.25-22.59 3.21"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffe3b2"
              d="M152.27 65.05q-3.28-14.28 7.71-21.89"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffb48e"
              d="M229.81 150.65q-8.33 3.52-13.94-2.78-2.18-2.45-2.91-5.08c-1.78-6.44-4.33-15.13-11.43-15.41-8.91-.34-14.09 8.68-15.52 16.89-1.3 7.44-1.99 17.07-10.15 20.16-6.99 2.64-13.97-2.01-16.08-8.73-2.89-9.22-4.57-18.45-16.48-18.57q-11.83-.11-16.36 9.56-2.4 5.13-2.68 9.63-.58 9.2-1.97 15.95c-1.62 7.93-9.15 15.82-17.79 10.72-4.14-2.45-6.68-8.11-7.28-12.74-.92-7.25.73-29.73-12.44-29.5-10.44.19-9.78 10.21-12.96 15.82q-3.16 5.57-8.65 5.77c-7.17.26-11.55-5.63-11.85-12.11q-.36-7.54-.59-10.97c-.4-6.15-1.82-13.16-8.94-14.07-8.1-1.03-11.43 4.12-14.13 10.69-3.18 7.76-8.53 11.61-17.33 8.27M230.09 158.03l.05 2.7"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#eeae6e"
              d="M230.2 166.73q-4.15 6.9-10.92 10.82c-14.25 8.26-31.51 12.6-48.14 15.17q-53.96 8.32-107.59-1.11-20.38-3.59-38.75-12.18-9.58-4.48-14.98-13.05"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#e84627"
              d="M118.51 14.87q-2.96.85-4.04 4.65a1.51 1.51 0 0 0 .89 1.81l4.56 1.82a.9.9 0 0 0 .86-.11q1.45-1.09 2.62-3.22a1.8 1.8 0 0 0-.31-2.13l-2.2-2.2a2.43 2.42 59.5 0 0-2.38-.62M130.86 32.2c3.79.58 5.95-1.13 6.36-5.1a1.46 1.45-59.7 0 0-.26-1l-2.74-3.88a.59.59 0 0 0-.8-.15q-5.68 3.63-3.4 9.45a1.1 1.09 83.7 0 0 .84.68M102.72 35.22q2.9-.65 5.5-3.2a1.24 1.24 0 0 0-.25-1.97l-3.4-1.97a1.75 1.74-49 0 0-1.95.14q-3.65 2.85-1.39 6.38a1.41 1.41 0 0 0 1.49.62M112.88 31.81l.85 3.04a1.29 1.29 0 0 0 1.59.9l2.64-.74a4.74 2.14-15.6 0 0 3.99-3.34l-.39-1.4a4.74 2.14-15.6 0 0-5.14-.79l-2.65.74a1.29 1.29 0 0 0-.89 1.59M132.5 39.67c2.14 2.43 5.84 4.18 7.58.22q.57-1.31-.93-3.26a.81.8 59.2 0 0-.97-.25l-5.48 2.4a.57.57 0 0 0-.2.89M123.651 38.913a4.21 3.79-116.2 0 0-1.542 5.45 4.21 3.79-116.2 0 0 5.26 2.105 4.21 3.79-116.2 0 0 1.542-5.451 4.21 3.79-116.2 0 0-5.26-2.105M102.41 46.07a1.61 1.6 45.1 0 0 0-2.27l-4-4a1.41 1.41 0 0 0-1.57-.3l-1.61.71a.78.76 78.5 0 0-.46.71v5.05a1.22 1.22 0 0 0 .76 1.13l3.66 1.46a.87.86 33.2 0 0 .93-.19l2.29-2.3M113.52 43.25l-4.11-1.44a1.08 1.08 0 0 0-1.38.66l-.37 1.06a3.02 2.99-70.7 0 0 1.82 3.83l.51.18a3.02 2.99-70.7 0 0 3.82-1.86l.37-1.06a1.08 1.08 0 0 0-.66-1.37M129.44 51.77l2.28 3.09a1.33 1.33 0 0 0 1.86.28l2.26-1.67a2.82 2.74-36.4 0 0 .64-3.87l-.6-.83a2.82 2.74-36.4 0 0-3.9-.53l-2.26 1.67a1.33 1.33 0 0 0-.28 1.86M112.64 52.67q-.91 1.7.58 4.3a1.19 1.19 0 0 0 .84.58l5.29.9a1.36 1.35 29.1 0 0 1.13-.32q.33-.24.69-.91.36-.67.37-1.08a1.36 1.35 27 0 0-.36-1.11l-3.7-3.9a1.19 1.19 0 0 0-.95-.37q-2.99.21-3.89 1.91M106 57.65a3.1 2.22-27.9 0 0-3.779-.512 3.1 2.22-27.9 0 0-1.7 3.413 3.1 2.22-27.9 0 0 3.778.511 3.1 2.22-27.9 0 0 1.7-3.413"
              vector-effect="non-scaling-stroke"
            />
          </g>
          <path
            fill="#60a938"
            d="M142.9 30.67q-8.5-14.91-23.29-16.73-.36-2.24.86-5.22 1.45-3.54 4.48-1.95 4.66 2.43 4.79 7.45a.47.47 0 0 0 .88.21q2.56-4.87 7.55-5.54c7.75-1.05 3.79 9.37 1.56 12.38a.4.4 0 0 0 .42.62q4.45-1.17 7.52 1.55a1.54 1.53 17.1 0 1 .52.98c.4 3.48-2.44 4.97-5.29 6.25Z"
          />
          <path
            fill="#da3f1f"
            d="M119.61 13.94q14.79 1.82 23.29 16.73 2.74 5.06 2.7 11.19l-.55 2.65c-3.81 15.48-15.73 20.32-30.72 24.1q-4.51 1.14-8.36.81c-8.77-.76-12.79-11.91-12.81-19.32q-.01-4.04.44-8.05 2.32-11.83 9.42-20.51 5.74-7.02 16.59-7.6Zm-1.1.93q-2.96.85-4.04 4.65a1.51 1.51 0 0 0 .89 1.81l4.56 1.82a.9.9 0 0 0 .86-.11q1.45-1.09 2.62-3.22a1.8 1.8 0 0 0-.31-2.13l-2.2-2.2a2.43 2.42 59.5 0 0-2.38-.62Zm12.35 17.33c3.79.58 5.95-1.13 6.36-5.1a1.46 1.45-59.7 0 0-.26-1l-2.74-3.88a.59.59 0 0 0-.8-.15q-5.68 3.63-3.4 9.45a1.1 1.09 83.7 0 0 .84.68Zm-28.14 3.02q2.9-.65 5.5-3.2a1.24 1.24 0 0 0-.25-1.97l-3.4-1.97a1.75 1.74-49 0 0-1.95.14q-3.65 2.85-1.39 6.38a1.41 1.41 0 0 0 1.49.62Zm10.16-3.41.85 3.04a1.29 1.29 0 0 0 1.59.9l2.64-.74a4.74 2.14-15.6 0 0 3.99-3.34l-.39-1.4a4.74 2.14-15.6 0 0-5.14-.79l-2.65.74a1.29 1.29 0 0 0-.89 1.59Zm19.62 7.86c2.14 2.43 5.84 4.18 7.58.22q.57-1.31-.93-3.26a.81.8 59.2 0 0-.97-.25l-5.48 2.4a.57.57 0 0 0-.2.89Zm-8.849-.758a4.21 3.79-116.2 0 0-1.542 5.451 4.21 3.79-116.2 0 0 5.26 2.105 4.21 3.79-116.2 0 0 1.542-5.451 4.21 3.79-116.2 0 0-5.26-2.105ZM102.41 46.07a1.61 1.6 45.1 0 0 0-2.27l-4-4a1.41 1.41 0 0 0-1.57-.3l-1.61.71a.78.76 78.5 0 0-.46.71v5.05a1.22 1.22 0 0 0 .76 1.13l3.66 1.46a.87.86 33.2 0 0 .93-.19l2.29-2.3Zm11.11-2.82-4.11-1.44a1.08 1.08 0 0 0-1.38.66l-.37 1.06a3.02 2.99-70.7 0 0 1.82 3.83l.51.18a3.02 2.99-70.7 0 0 3.82-1.86l.37-1.06a1.08 1.08 0 0 0-.66-1.37Zm15.92 8.52 2.28 3.09a1.33 1.33 0 0 0 1.86.28l2.26-1.67a2.82 2.74-36.4 0 0 .64-3.87l-.6-.83a2.82 2.74-36.4 0 0-3.9-.53l-2.26 1.67a1.33 1.33 0 0 0-.28 1.86Zm-16.8.9q-.91 1.7.58 4.3a1.19 1.19 0 0 0 .84.58l5.29.9a1.36 1.35 29.1 0 0 1.13-.32q.33-.24.69-.91.36-.67.37-1.08a1.36 1.35 27 0 0-.36-1.11l-3.7-3.9a1.19 1.19 0 0 0-.95-.37q-2.99.21-3.89 1.91ZM106 57.65a3.1 2.22-27.9 0 0-3.779-.512 3.1 2.22-27.9 0 0-1.7 3.413 3.1 2.22-27.9 0 0 3.778.511 3.1 2.22-27.9 0 0 1.7-3.413Z"
          />
          <path
            fill="#f54d2f"
            d="M118.51 14.87a2.43 2.42 59.5 0 1 2.38.62l2.2 2.2a1.8 1.8 0 0 1 .31 2.13q-1.17 2.13-2.62 3.22a.9.9 0 0 1-.86.11l-4.56-1.82a1.51 1.51 0 0 1-.89-1.81q1.08-3.8 4.04-4.65ZM130.02 31.52q-2.28-5.82 3.4-9.45a.59.59 0 0 1 .8.15l2.74 3.88a1.46 1.45-59.7 0 1 .26 1c-.41 3.97-2.57 5.68-6.36 5.1a1.1 1.09 83.7 0 1-.84-.68Z"
          />
          <path
            fill="#ffe6ba"
            d="M80.31 43.8c5.5 6.19 7.28 12.04 5.92 20.44q-3.01 4.77-7.53 6.23-16.11 5.2-32.37.44a.42.42 0 0 1 .04-.82c5.65-1.05 9.49-3.97 14.36-7.88q8.04-6.44 8.77-16.17c.47-6.19 0-10.67-4.9-14.42q-.5-.38-1.39-.48a.52.52 0 0 0-.51.78l3.73 6.65a.23.22-70.3 0 1 .04.09c1.35 6.34-3.6 14.77-7.5 19.3q-7.62 8.87-19.03 7.84-4.4-.4-7.3-3.61l.27-7.68q3.31-8.59 11.32-13.23 2.97-1.72 11.6-7.2 2.24-1.42 1.27-3.38l-.57-1.15a2.2 2.19-86.1 0 1 2.85-2.49q4.43 1.46 8.82 4.75 6.94 5.22 12.11 11.99ZM206.51 55.31l-.84 9.77q-3.17 4.88-8.81 6.53-15.73 4.6-31.65.25a.35.35 0 0 1 0-.67q9.21-2.64 16.01-9.1c7.31-6.95 9.01-15.47 6.69-25.1q-.87-3.61-4.46-5.86a.46.45 10.4 0 0-.69.47q.23 1.12.99 2.14 4 5.32 2.16 11.36-2.98 9.82-11.05 16.74-10.79 9.25-22.59 3.21-3.28-14.28 7.71-21.89 8.17-4.06 15.68-9.24 2.65-1.82.98-4.03a1.66 1.65 78.2 0 1 1.7-2.61c7.32 1.74 14.85 8.6 19.32 14.56q4.83 6.45 8.85 13.47Z"
          />
          <path
            fill="#f54d2f"
            d="M102.72 35.22a1.41 1.41 0 0 1-1.49-.62q-2.26-3.53 1.39-6.38a1.75 1.74-49 0 1 1.95-.14l3.4 1.97a1.24 1.24 0 0 1 .25 1.97q-2.6 2.55-5.5 3.2ZM112.88 31.81a1.29 1.29 0 0 1 .89-1.59l2.65-.74a4.74 2.14-15.6 0 1 5.14.79l.39 1.4a4.74 2.14-15.6 0 1-3.99 3.34l-2.64.74a1.29 1.29 0 0 1-1.59-.9l-.85-3.04Z"
          />
          <path
            fill="#ffd498"
            d="M205.67 65.08q.13 4.04-3.58 7.02c-7.66 6.15-19.95 5.93-30.89 4.77-6.23-.67-14.49-3.69-18.17-9.16q-1.2-1.78-.76-2.66 11.8 6.04 22.59-3.21 8.07-6.92 11.05-16.74 1.84-6.04-2.16-11.36-.76-1.02-.99-2.14a.46.45 10.4 0 1 .69-.47q3.59 2.25 4.46 5.86c2.32 9.63.62 18.15-6.69 25.1q-6.8 6.46-16.01 9.1a.35.35 0 0 0 0 .67q15.92 4.35 31.65-.25 5.64-1.65 8.81-6.53ZM86.23 64.24q-1.39 8.4-10.98 11.07-13.18 3.68-27.62-.06c-4.14-1.07-9.37-3.83-11.98-6.4q-2.62-2.57-3.01-6.66 2.9 3.21 7.3 3.61 11.41 1.03 19.03-7.84c3.9-4.53 8.85-12.96 7.5-19.3a.23.22-70.3 0 0-.04-.09l-3.73-6.65a.52.52 0 0 1 .51-.78q.89.1 1.39.48c4.9 3.75 5.37 8.23 4.9 14.42q-.73 9.73-8.77 16.17c-4.87 3.91-8.71 6.83-14.36 7.88a.42.42 0 0 0-.04.82q16.26 4.76 32.37-.44 4.52-1.46 7.53-6.23Z"
          />
          <path
            fill="#f54d2f"
            d="M140.08 39.89c-1.74 3.96-5.44 2.21-7.58-.22a.57.57 0 0 1 .2-.89l5.48-2.4a.81.8 59.2 0 1 .97.25q1.5 1.95.93 3.26Z"
          />
          <ellipse fill="#f54d2f" rx="4.21" ry="3.79" transform="rotate(-116.2 76.041 -17.717)" />
          <path
            fill="#f54d2f"
            d="m102.41 46.07-2.29 2.3a.87.86 33.2 0 1-.93.19l-3.66-1.46a1.22 1.22 0 0 1-.76-1.13v-5.05a.78.76 78.5 0 1 .46-.71l1.61-.71a1.41 1.41 0 0 1 1.57.3l4 4a1.61 1.6 45.1 0 1 0 2.27ZM113.52 43.25a1.08 1.08 0 0 1 .66 1.37l-.37 1.06a3.02 2.99-70.7 0 1-3.82 1.86l-.51-.18a3.02 2.99-70.7 0 1-1.82-3.83l.37-1.06a1.08 1.08 0 0 1 1.38-.66l4.11 1.44Z"
          />
          <path
            fill="#ffe0aa"
            d="M159.98 43.16q-10.99 7.61-7.71 21.89-.44.88.76 2.66c3.68 5.47 11.94 8.49 18.17 9.16 10.94 1.16 23.23 1.38 30.89-4.77q3.71-2.98 3.58-7.02l.84-9.77q4.18 1.29 9.6 3.84 10.5 4.95 14.94 15.86-1.26 5.37-5.19 8.62-10.72 8.88-24.82 13.78-21.1 7.33-44.01 9.72-8.71.91-25.91.78-6.38-.05-26.11-.04-28.32.01-55.58-7.05c-12.75-3.3-27.8-8.67-35.73-18.28q-3.6-4.37-2.89-11.25 6.18-10.01 18.15-14.58 1.11-.42 3.95-2.2l-.27 7.68q.39 4.09 3.01 6.66c2.61 2.57 7.84 5.33 11.98 6.4q14.44 3.74 27.62.06 9.59-2.67 10.98-11.07c1.36-8.4-.42-14.25-5.92-20.44l11.44-1.52c.06 9.1.54 15.06 4.26 21.79a1.37 1.36 51.4 0 1-.17 1.57q-7.35 8.27-4.71 20.77-.3 3.05 3.16 6.08c8.8 7.67 22.22 8.7 34.86 8.13q9.55-.43 16.67-5.02 5.71-3.69 6.1-10.24.77-7.1-1.77-12.49-3.38-7.18-9.78-14.73a.72.71 39.6 0 1-.08-.81c2.39-4.27 4.99-7.62 4.76-12.82l.55-2.65 14.38 1.3Z"
          />
          <path
            fill="#ffe6ba"
            d="M93.6 42.05q-.45 4.01-.44 8.05c.02 7.41 4.04 18.56 12.81 19.32q3.85.33 8.36-.81c14.99-3.78 26.91-8.62 30.72-24.1.23 5.2-2.37 8.55-4.76 12.82a.72.71 39.6 0 0 .08.81q6.4 7.55 9.78 14.73 2.54 5.39 1.77 12.49c-5.66 14.54-34.29 12.65-45.49 9.46q-1.23-.35-2.49-.97a.28.28 0 0 1 .15-.53c8.91 1.13 15.67-3.63 21.87-9.85q8.52-8.55 8.44-20a.51.51 0 0 0-.53-.51q-2.26.08-2.67 1.83c-1.61 6.94-5.97 12.89-11.03 17.61q-13.59 12.68-29.04 4.01-2.64-12.5 4.71-20.77a1.37 1.36 51.4 0 0 .17-1.57c-3.72-6.73-4.2-12.69-4.26-21.79l1.85-.23Z"
          />
          <path
            fill="#f54d2f"
            d="M129.44 51.77a1.33 1.33 0 0 1 .28-1.86l2.26-1.67a2.82 2.74-36.4 0 1 3.9.53l.6.83a2.82 2.74-36.4 0 1-.64 3.87l-2.26 1.67a1.33 1.33 0 0 1-1.86-.28l-2.28-3.09ZM121.17 57.22q-.36.67-.69.91a1.36 1.35 29.1 0 1-1.13.32l-5.29-.9a1.19 1.19 0 0 1-.84-.58q-1.49-2.6-.58-4.3.9-1.7 3.89-1.91a1.19 1.19 0 0 1 .95.37l3.7 3.9a1.36 1.35 27 0 1 .36 1.11q-.01.41-.37 1.08Z"
          />
          <ellipse fill="#f54d2f" rx="3.1" ry="2.22" transform="rotate(-27.9 170.59 -178.3)" />
          <path
            fill="#ffd498"
            d="M151.92 85.36q-.39 6.55-6.1 10.24-7.12 4.59-16.67 5.02c-12.64.57-26.06-.46-34.86-8.13q-3.46-3.03-3.16-6.08 15.45 8.67 29.04-4.01c5.06-4.72 9.42-10.67 11.03-17.61q.41-1.75 2.67-1.83a.51.51 0 0 1 .53.51q.08 11.45-8.44 20c-6.2 6.22-12.96 10.98-21.87 9.85a.28.28 0 0 0-.15.53q1.26.62 2.49.97c11.2 3.19 39.83 5.08 45.49-9.46Z"
          />
          <path
            fill="#ff9384"
            d="M10.81 71.29q-.71 6.88 2.89 11.25c7.93 9.61 22.98 14.98 35.73 18.28q27.26 7.06 55.58 7.05 19.73-.01 26.11.04 17.2.13 25.91-.78 22.91-2.39 44.01-9.72 14.1-4.9 24.82-13.78 3.93-3.25 5.19-8.62 3.54 9.23 2.99 19.5-.79 14.55-.37 21.56.66 11.19.65 18.92-.01 4.51-1.6 10.25a6.04 5.57-24.2 0 1-.58 1.36l-2.33 4.05q-8.33 3.52-13.94-2.78-2.18-2.45-2.91-5.08c-1.78-6.44-4.33-15.13-11.43-15.41-8.91-.34-14.09 8.68-15.52 16.89-1.3 7.44-1.99 17.07-10.15 20.16-6.99 2.64-13.97-2.01-16.08-8.73-2.89-9.22-4.57-18.45-16.48-18.57q-11.83-.11-16.36 9.56-2.4 5.13-2.68 9.63-.58 9.2-1.97 15.95c-1.62 7.93-9.15 15.82-17.79 10.72-4.14-2.45-6.68-8.11-7.28-12.74-.92-7.25.73-29.73-12.44-29.5-10.44.19-9.78 10.21-12.96 15.82q-3.16 5.57-8.65 5.77c-7.17.26-11.55-5.63-11.85-12.11q-.36-7.54-.59-10.97c-.4-6.15-1.82-13.16-8.94-14.07-8.1-1.03-11.43 4.12-14.13 10.69-3.18 7.76-8.53 11.61-17.33 8.27q-2.82-3.21-3.7-6.54-1.48-5.63-.99-13.05 1.05-15.73 1.06-22.31.02-13.86.08-19.49.06-4.78 4.03-11.47Z"
          />
          <path
            fill="#ffd498"
            d="m229.81 150.65.28 7.38.05 2.7.06 6q-4.15 6.9-10.92 10.82c-14.25 8.26-31.51 12.6-48.14 15.17q-53.96 8.32-107.59-1.11-20.38-3.59-38.75-12.18-9.58-4.48-14.98-13.05l.51-22.23c8.8 3.34 14.15-.51 17.33-8.27 2.7-6.57 6.03-11.72 14.13-10.69 7.12.91 8.54 7.92 8.94 14.07q.23 3.43.59 10.97c.3 6.48 4.68 12.37 11.85 12.11q5.49-.2 8.65-5.77c3.18-5.61 2.52-15.63 12.96-15.82 13.17-.23 11.52 22.25 12.44 29.5.6 4.63 3.14 10.29 7.28 12.74 8.64 5.1 16.17-2.79 17.79-10.72q1.39-6.75 1.97-15.95.28-4.5 2.68-9.63 4.53-9.67 16.36-9.56c11.91.12 13.59 9.35 16.48 18.57 2.11 6.72 9.09 11.37 16.08 8.73 8.16-3.09 8.85-12.72 10.15-20.16 1.43-8.21 6.61-17.23 15.52-16.89 7.1.28 9.65 8.97 11.43 15.41q.73 2.63 2.91 5.08 5.61 6.3 13.94 2.78Z"
          />
          <path fill="#ff9384" d="m230.14 160.73-.05-2.7.05 2.7Z" />
          <path
            fill="#dd8743"
            d="M230.2 166.73q-.04 13.95-.1 27.71-.03 6.54-1.18 8.98c-5.1 10.89-22.01 17.02-32.68 20.08q-18.74 5.37-37.51 7.46c-15.95 1.78-32.65 2.9-49.08 2.15-22.13-1.01-43.03-3.48-63.92-9.28-10.68-2.97-23.19-7.54-30.94-15.34Q9.55 203.21 9.62 196q.14-14.85.2-29.62 5.4 8.57 14.98 13.05 18.37 8.59 38.75 12.18 53.63 9.43 107.59 1.11c16.63-2.57 33.89-6.91 48.14-15.17q6.77-3.92 10.92-10.82Z"
          />
        </svg>
      );
    case CANDY_AND_SWEETS:
      return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <g fill="none" stroke-width="2">
            <path
              stroke="#f06f2d"
              d="M183.07 102.21q6.29-21.15-.2-39.58c-14.3-40.6-65.96-58.45-99.02-27C70.1 48.72 64.43 68.67 69.48 86.76q3.9 13.95 13.74 22.57c16.35 14.31 40.6 16.02 57.92 2.55 13.47-10.48 18.88-30.07 10.92-45.02q-4.72-8.85-12.57-13.24c-7.81-4.37-18.79-5.43-26.92-.85-6.83 3.84-12.24 9.55-13.4 17.44q-1.82 12.33 7.61 19.01c6.64 4.71 16.85 2.97 18.21-5.97q.18-1.14-1.52-2.41a.97.96-35.8 0 0-.9-.14c-2.73.96-5.37 1.51-7.51-.87-2.77-3.07-3.03-7.89-.23-11.13q2.56-2.96 6.33-3.93c8.28-2.13 16.12 3.83 18.65 11.37 1.98 5.88.81 13.84-2.64 19.19-8.41 13.06-27.51 14.77-39.83 6.5-13.22-8.85-17.68-25.41-12.46-40.28q3.24-9.21 11.29-16.15 16.4-14.13 37.78-9.77c24.77 5.07 40.37 30.26 36.26 54.68-3.84 22.84-22.21 41.46-45.04 45.51-24.23 4.29-46.91-6.08-61.81-25.51q-4.16-5.42-6.62-11.6-.02-.06-.95-3.63-.61-2.33-2.39-3.57"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#e28f37" d="M125.64 144.18H114.7" vector-effect="non-scaling-stroke" />
          </g>
          <path
            fill="#ea4827"
            d="M183.07 102.21q6.29-21.15-.2-39.58c-14.3-40.6-65.96-58.45-99.02-27C70.1 48.72 64.43 68.67 69.48 86.76q3.9 13.95 13.74 22.57c16.35 14.31 40.6 16.02 57.92 2.55 13.47-10.48 18.88-30.07 10.92-45.02q-4.72-8.85-12.57-13.24c-7.81-4.37-18.79-5.43-26.92-.85-6.83 3.84-12.24 9.55-13.4 17.44q-1.82 12.33 7.61 19.01c6.64 4.71 16.85 2.97 18.21-5.97q.18-1.14-1.52-2.41a.97.96-35.8 0 0-.9-.14c-2.73.96-5.37 1.51-7.51-.87-2.77-3.07-3.03-7.89-.23-11.13q2.56-2.96 6.33-3.93c8.28-2.13 16.12 3.83 18.65 11.37 1.98 5.88.81 13.84-2.64 19.19-8.41 13.06-27.51 14.77-39.83 6.5-13.22-8.85-17.68-25.41-12.46-40.28q3.24-9.21 11.29-16.15 16.4-14.13 37.78-9.77c24.77 5.07 40.37 30.26 36.26 54.68-3.84 22.84-22.21 41.46-45.04 45.51-24.23 4.29-46.91-6.08-61.81-25.51q-4.16-5.42-6.62-11.6-.02-.06-.95-3.63-.61-2.33-2.39-3.57c-4.41-19.01-.94-38.62 10.23-54.52 10.24-14.57 25.15-24.17 42.88-28.12 5.96-1.33 13.99-.82 18.99-.87q5.17-.04 10.69 1.34 23.96 6.03 38.98 26 15.37 20.44 12.99 46.9-.95 10.59-5.09 19.97Z"
          />
          <path
            fill="#f69632"
            d="M183.07 102.21q-13.93 32.39-49.3 40.58-2.13.49-8.13 1.39H114.7q-2.88-.51-6-1.01-11.24-1.79-21.22-7.19-22.65-12.26-31.89-36.34-1.21-3.15-2.19-8.13 1.78 1.24 2.39 3.57.93 3.57.95 3.63 2.46 6.18 6.62 11.6c14.9 19.43 37.58 29.8 61.81 25.51 22.83-4.05 41.2-22.67 45.04-45.51 4.11-24.42-11.49-49.61-36.26-54.68q-21.38-4.36-37.78 9.77-8.05 6.94-11.29 16.15c-5.22 14.87-.76 31.43 12.46 40.28 12.32 8.27 31.42 6.56 39.83-6.5 3.45-5.35 4.62-13.31 2.64-19.19-2.53-7.54-10.37-13.5-18.65-11.37q-3.77.97-6.33 3.93c-2.8 3.24-2.54 8.06.23 11.13 2.14 2.38 4.78 1.83 7.51.87a.97.96-35.8 0 1 .9.14q1.7 1.27 1.52 2.41c-1.36 8.94-11.57 10.68-18.21 5.97q-9.43-6.68-7.61-19.01c1.16-7.89 6.57-13.6 13.4-17.44 8.13-4.58 19.11-3.52 26.92.85q7.85 4.39 12.57 13.24c7.96 14.95 2.55 34.54-10.92 45.02-17.32 13.47-41.57 11.76-57.92-2.55q-9.84-8.62-13.74-22.57c-5.05-18.09.62-38.04 14.37-51.13 33.06-31.45 84.72-13.6 99.02 27q6.49 18.43.2 39.58Z"
          />
          <path
            fill="#ce883b"
            d="m125.64 144.18-.02 78.33a.6.6 0 0 1-.6.6h-9.71a.6.6 0 0 1-.6-.6l-.01-78.33h10.94Z"
          />
        </svg>
      );
    case TEA_COFFEE:
      return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <g fill="none" stroke-width="2">
            <path
              stroke="#d59276"
              d="M186 53.11q-7.88 9.07-15.63 12.5-4.68 2.08-13.2 4.31c-2.58.67-5.93.86-8.88 1.75"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#db9a7e"
              d="M148.29 71.67q-17.28 3.77-35.14 4.45-20.01.77-32.24.28-3.2-.13-6.09-1.12a.66.65-63 0 1-.32-1l4.49-6.26"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ae755f"
              d="M78.99 68.02q35.84 2.38 69.5-4.75 7.77-1.65 17.26-5.53"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#d0896f"
              d="M165.75 57.74q6.07-2.15 10.04-6.71 2.29-2.63 1.66-5.61c-1.97-9.25-32.09-15.56-39.65-16.76-10.75-1.69-24.32-2.76-38.04-2.74q-16.99.02-18.51.1-20.24.98-40.12 5.64c-6.33 1.48-24.62 6.38-26.04 13.81-.86 4.54 3.86 8.41 7.52 10.19q6.37 3.08 6.77 3.23 15.53 5.83 34.74 7.44"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ae755f"
              d="M64.12 66.33q.19.73 3.76.65"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#e8ba9d" d="m67.88 66.98-3.21 7.92" vector-effect="non-scaling-stroke" />
            <path
              stroke="#db9a7e"
              d="M64.67 74.9c-5.13-.59-10.58-.87-15.44-1.83q-10.26-2.03-20.26-5.11-13.04-4.01-22.88-13.3"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#a05f4b"
              d="M165.75 57.74q-8.17-3.81-14.23-5.56-13.94-4.01-30.08-5.39-8.33-.71-23.39-.92-10.54-.15-23.42.74C59 47.7 43.33 50.6 30.18 56.97a.3.29-42.1 0 0-.03.52q3.19 2.01 5.1 2.57 12.09 3.54 28.87 6.27"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#d28c71"
              d="M51.25 200.44q5.38 1.91 10.43 4.05 7.57 3.21 10.48 3.85c12.86 2.81 26.25-.85 37.12-7.94 9.5-6.18 17.88-17.81 23.44-27.88 12.32-22.28 16.76-46.85 18.69-72.56.79-10.49.62-18.73-3.12-28.29"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#dfac90"
              d="M78.48 67.81c-6.93.14-8.78 8.01-8.88 13.67q-.3 16.06-.19 34.37a.76.75 2.5 0 0 .69.75q5.38.43 6.28.56c6.68.97 6.35 8.39 6.33 13.3q-.09 23.22-.2 30.79c-.08 4.95-1.5 9.62-7.26 9.19q-11.63-.87-18.28-1.59-3.86-.42-5.97-3.67"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#aa705a" d="m78.99 68.02-.39.18" vector-effect="non-scaling-stroke" />
            <path
              stroke="#a56851"
              d="M78.6 68.2q-.16-.25-.12-.39"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#b79079"
              d="M78.48 67.81q-.63-3.38-3.5-4.56a2.53 2.5-33.5 0 0-.96-.19q-1.97-.03-3.26.95-1.26.96-2.88 2.97"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#e4b498"
              d="m64.67 74.9-.49 40.54a.67.67 0 0 1-.71.66q-3.86-.25-7.18-.16c-5.15.15-6.37 4.82-6.39 9.06q-.02 3.82 0 35.5 0 1.67 1.1 4.68"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#d28c71"
              d="M51 165.18q3.23 7.36 11.42 8.86 7.21 1.32 13.49 1.23c7.2-.09 9.97-5.75 10.24-12.16q.48-10.99.26-28.12-.05-4.07-1.27-8.92c-1.72-6.84-6.18-9.88-11.46-13.6a1.3 1.27 17.5 0 1-.55-1.03q-.43-17.75-.17-21.01.54-6.84.53-12.49c-.01-4.61 1.13-7.55 5.11-9.74"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#aa705a" d="m234.1 90.21.44.08" vector-effect="non-scaling-stroke" />
            <path
              stroke="#d28c71"
              d="M198.3 156.37q-6.02-6.66-10.55-14.48M194.77 74.98q-.35-9.79-4.68-19.17"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#db9a7e"
              d="M37.69 150.74q3.05-4.65 1.96-10.45c-2.8-14.84-5.07-29.35-5.51-44.01q-.36-12.06-.92-16.11a1.41 1.37-80.3 0 0-.71-1.03q-6.95-3.78-13.24-1.19a1.76 1.76 0 0 0-1.08 1.65q.21 14.05 2.03 27.29c1.7 12.29 4.4 25.75 9.23 37.64q1.91 4.7 7.4 6.5a.73.72-63.9 0 0 .84-.29"
              vector-effect="non-scaling-stroke"
            />
          </g>
          <path
            fill="#de9f83"
            d="M186 53.11q-7.88 9.07-15.63 12.5-4.68 2.08-13.2 4.31c-2.58.67-5.93.86-8.88 1.75q-17.28 3.77-35.14 4.45-20.01.77-32.24.28-3.2-.13-6.09-1.12a.66.65-63 0 1-.32-1l4.49-6.26q35.84 2.38 69.5-4.75 7.77-1.65 17.26-5.53 6.07-2.15 10.04-6.71 2.29-2.63 1.66-5.61c-1.97-9.25-32.09-15.56-39.65-16.76-10.75-1.69-24.32-2.76-38.04-2.74q-16.99.02-18.51.1-20.24.98-40.12 5.64c-6.33 1.48-24.62 6.38-26.04 13.81-.86 4.54 3.86 8.41 7.52 10.19q6.37 3.08 6.77 3.23 15.53 5.83 34.74 7.44.19.73 3.76.65l-3.21 7.92c-5.13-.59-10.58-.87-15.44-1.83q-10.26-2.03-20.26-5.11-13.04-4.01-22.88-13.3l-.07-12.03a2.77 2.69-32.5 0 1 .29-1.22c1.95-3.82 7.29-7.5 10.87-9.52q4.12-2.32 10.54-4.46 16.59-5.53 39.78-7.45 30.66-2.55 54.93-.19 9.58.93 15.9 2.26 4.63.97 15.77 3.2c6.55 1.31 11.41 3.72 17.24 5.71 6.45 2.2 12.97 7.34 14.86 14.05q.57 2.03-.2 8.1Z"
          />
          <path
            fill="#c2735b"
            d="M165.75 57.74q-8.17-3.81-14.23-5.56-13.94-4.01-30.08-5.39-8.33-.71-23.39-.92-10.54-.15-23.42.74C59 47.7 43.33 50.6 30.18 56.97a.3.29-42.1 0 0-.03.52q3.19 2.01 5.1 2.57 12.09 3.54 28.87 6.27-19.21-1.61-34.74-7.44-.4-.15-6.77-3.23c-3.66-1.78-8.38-5.65-7.52-10.19 1.42-7.43 19.71-12.33 26.04-13.81Q61.01 27 81.25 26.02q1.52-.08 18.51-.1c13.72-.02 27.29 1.05 38.04 2.74 7.56 1.2 37.68 7.51 39.65 16.76q.63 2.98-1.66 5.61-3.97 4.56-10.04 6.71Z"
          />
          <path
            fill="#7d4b3a"
            d="M165.75 57.74q-9.49 3.88-17.26 5.53-33.66 7.13-69.5 4.75l-.39.18q-.16-.25-.12-.39-.63-3.38-3.5-4.56a2.53 2.5-33.5 0 0-.96-.19q-1.97-.03-3.26.95-1.26.96-2.88 2.97-3.57.08-3.76-.65-16.78-2.73-28.87-6.27-1.91-.56-5.1-2.57a.3.29-42.1 0 1 .03-.52C43.33 50.6 59 47.7 74.63 46.61q12.88-.89 23.42-.74 15.06.21 23.39.92 16.14 1.38 30.08 5.39 6.06 1.75 14.23 5.56Z"
          />
          <path
            fill="#d79479"
            d="m234.1 90.21.44.08-.18 8.27a.18.17 34.4 0 1-.33.05q-.04-.08-.08-.35a.06.06 0 0 0-.11 0l-2.34 14.46a4.46 4.39-28.2 0 1-.37 1.19q-7.2 15.23-8.71 17.26-8.07 10.86-10.99 14.01-4.45 4.79-13.13 11.19-6.02-6.66-10.55-14.48 13.83-9.07 22.73-23.15 7.28-11.51 7.16-24.21-.06-6.35-1.69-10.79-.83-2.28-2.81-4.96-1.58-2.15-4.11-3.65-2.24-1.33-5.25-1.42-4.73-.14-9.01 1.27-.35-9.79-4.68-19.17 7.38-3.04 15.13-2.33 6.92.64 11.95 4.35 5.29 3.89 8.93 9.29a5.25 5.03-74.7 0 1 .52.96c2.6 6.18 6 14.4 7.26 23.12a.02.02 0 0 0 .04 0l.18-.99Z"
          />
          <path
            fill="#cc8468"
            d="m186 53.11.34 4.69a.34.34 0 0 0 .53.26l3.22-2.25q4.33 9.38 4.68 19.17-6.1 3.71-10.14 9.85a6.03 5.94-26.1 0 0-.98 2.8l-1.87 21.27a2.59 2.52-32.9 0 1-.16.7c-.79 2.07-.68 4.02-1.14 6.78q-2.63 15.83-7.28 30.71a1.26 1.26 0 0 0 1.54 1.59q1.98-.55 5.04-2.55.54-.36 1.76-.82 1.3-.51 1.53-.87a.88.87 18.9 0 1 .84-.41q.77.09 1.11-.47a1.09 1.06-79.2 0 1 .71-.5q1.06-.21 2.02-1.17 4.53 7.82 10.55 14.48-5.47 3.54-11.7 5.96-.53.21-.8 1.07a1.36 1.34-3.7 0 1-.74.83q-7.45 3.24-16.29 7.03-1.32.56-5.09 1.14a1.06 1.05-80.1 0 0-.77.55q-1.29 2.46-10.91 19.55-.66 1.19-3.34 4.87a2.24 2.19-21.1 0 0-.34.74c-.75 2.95-7.01 7.41-9.31 9.15a5.96 5.8-88.3 0 0-.99.96l-2.56 3.12a2.04 1.79-1.5 0 1-.4.37q-8.73 5.92-15.26 7.05-7.72 1.35-19.78 2.18-10.91.76-19.84-.93-11.15-2.1-20.97-6.72-1.17-.55-3.04-2.23a2.43 2.23 11.1 0 1-.58-.79l-4.34-9.83q5.38 1.91 10.43 4.05 7.57 3.21 10.48 3.85c12.86 2.81 26.25-.85 37.12-7.94 9.5-6.18 17.88-17.81 23.44-27.88 12.32-22.28 16.76-46.85 18.69-72.56.79-10.49.62-18.73-3.12-28.29 2.95-.89 6.3-1.08 8.88-1.75q8.52-2.23 13.2-4.31 7.75-3.43 15.63-12.5Z"
          />
          <path
            fill="#d79479"
            d="m64.67 74.9-.49 40.54a.67.67 0 0 1-.71.66q-3.86-.25-7.18-.16c-5.15.15-6.37 4.82-6.39 9.06q-.02 3.82 0 35.5 0 1.67 1.1 4.68 3.23 7.36 11.42 8.86 7.21 1.32 13.49 1.23c7.2-.09 9.97-5.75 10.24-12.16q.48-10.99.26-28.12-.05-4.07-1.27-8.92c-1.72-6.84-6.18-9.88-11.46-13.6a1.3 1.27 17.5 0 1-.55-1.03q-.43-17.75-.17-21.01.54-6.84.53-12.49c-.01-4.61 1.13-7.55 5.11-9.74l.39-.18-4.49 6.26a.66.65-63 0 0 .32 1q2.89.99 6.09 1.12 12.23.49 32.24-.28 17.86-.68 35.14-4.45c3.74 9.56 3.91 17.8 3.12 28.29-1.93 25.71-6.37 50.28-18.69 72.56-5.56 10.07-13.94 21.7-23.44 27.88-10.87 7.09-24.26 10.75-37.12 7.94q-2.91-.64-10.48-3.85-5.05-2.14-10.43-4.05-7.81-6.54-12.83-12.86c-6.72-8.46-12.09-20.13-16.73-30.64q-2.68-6.05-3.75-10.13c-1.16-4.42-2.82-8.86-3.86-13.91-5.44-26.41-8.84-51.89-7.99-78.24q9.84 9.29 22.88 13.3 10 3.08 20.26 5.11c4.86.96 10.31 1.24 15.44 1.83Zm-26.98 75.84q3.05-4.65 1.96-10.45c-2.8-14.84-5.07-29.35-5.51-44.01q-.36-12.06-.92-16.11a1.41 1.37-80.3 0 0-.71-1.03q-6.95-3.78-13.24-1.19a1.76 1.76 0 0 0-1.08 1.65q.21 14.05 2.03 27.29c1.7 12.29 4.4 25.75 9.23 37.64q1.91 4.7 7.4 6.5a.73.72-63.9 0 0 .84-.29Z"
          />
          <path
            fill="#f1d4b7"
            d="M78.48 67.81c-6.93.14-8.78 8.01-8.88 13.67q-.3 16.06-.19 34.37a.76.75 2.5 0 0 .69.75q5.38.43 6.28.56c6.68.97 6.35 8.39 6.33 13.3q-.09 23.22-.2 30.79c-.08 4.95-1.5 9.62-7.26 9.19q-11.63-.87-18.28-1.59-3.86-.42-5.97-3.67-1.1-3.01-1.1-4.68-.02-31.68 0-35.5c.02-4.24 1.24-8.91 6.39-9.06q3.32-.09 7.18.16a.67.67 0 0 0 .71-.66l.49-40.54 3.21-7.92q1.62-2.01 2.88-2.97 1.29-.98 3.26-.95a2.53 2.5-33.5 0 1 .96.19q2.87 1.18 3.5 4.56Z"
          />
          <path
            fill="#cc8468"
            d="M78.48 67.81q-.04.14.12.39c-3.98 2.19-5.12 5.13-5.11 9.74q.01 5.65-.53 12.49-.26 3.26.17 21.01a1.3 1.27 17.5 0 0 .55 1.03c5.28 3.72 9.74 6.76 11.46 13.6q1.22 4.85 1.27 8.92.22 17.13-.26 28.12c-.27 6.41-3.04 12.07-10.24 12.16q-6.28.09-13.49-1.23-8.19-1.5-11.42-8.86 2.11 3.25 5.97 3.67 6.65.72 18.28 1.59c5.76.43 7.18-4.24 7.26-9.19q.11-7.57.2-30.79c.02-4.91.35-12.33-6.33-13.3q-.9-.13-6.28-.56a.76.75 2.5 0 1-.69-.75q-.11-18.31.19-34.37c.1-5.66 1.95-13.53 8.88-13.67Z"
          />
          <path
            fill="#de9f83"
            d="M36.85 151.03q-5.49-1.8-7.4-6.5c-4.83-11.89-7.53-25.35-9.23-37.64Q18.4 93.65 18.19 79.6a1.76 1.76 0 0 1 1.08-1.65q6.29-2.59 13.24 1.19a1.41 1.37-80.3 0 1 .71 1.03q.56 4.05.92 16.11c.44 14.66 2.71 29.17 5.51 44.01q1.09 5.8-1.96 10.45a.73.72-63.9 0 1-.84.29Z"
          />
          <path fill="#7d4b3a" d="m234.54 90.29-.44-.08q-.01-.39.18-.45.2-.05.3.16.08.17-.04.37Z" />
        </svg>
      );
    case BALLOONS:
      return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <g fill="none" stroke-width="2">
            <path stroke="#db5f33" d="m122.71 208.35-5.87-.75" vector-effect="non-scaling-stroke" />
            <path
              stroke="#fa6446"
              d="M94.75 32.77c-3.19-2.36-7.38-2.1-10.94-.65Q61.5 41.21 53.96 64.48c-1.46 4.5-4.11 20.66 4.91 19.41q4.36-.61 6.4-4.62 3.27-6.42 4.33-8.44 5.09-9.67 12.71-17.51 6.95-7.15 9.52-9.98c2.78-3.05 4.95-5.74 3.65-9.56a2.05 2.01 9.6 0 0-.73-1.01"
              vector-effect="non-scaling-stroke"
            />
          </g>
          <path
            fill="#f55333"
            d="m122.71 208.35-5.87-.75q-5.17 1.79-9.95.52-2.08-.56-4.05-2.29a.91.91 0 0 1-.29-.87c1.14-5.39 4.96-10.1 9.48-13.01a1.26 1.23 83.4 0 0 .49-.63l.34-.97a1.28 1.27-5.1 0 1 .61-.72q1.26-.68 1.21-1.22a2.75 2.49-89.1 0 0-2.13-2.43q-27.12-4.08-47.28-23.32c-13.77-13.14-23.89-28.92-29.12-45.49-7.3-23.14-5.1-48.68 7.49-69.1q13.77-22.32 39.28-33.99 23.64-10.82 51.45-6.39c23.56 3.75 44.58 16.67 58.48 36.03 14.25 19.84 18.77 46.21 11.81 69.99-7.45 25.48-23.93 47.68-45.93 61.78q-15.73 10.08-35.49 11.18a.66.65-86.6 0 0-.6.54c-.44 2.48 2.4 4.2 4.43 5.72 3.94 2.95 6.77 6.88 8.29 11.49a1.08 1.07 60.6 0 1-.32 1.16q-5.06 4.32-12.33 2.77ZM94.75 32.77c-3.19-2.36-7.38-2.1-10.94-.65Q61.5 41.21 53.96 64.48c-1.46 4.5-4.11 20.66 4.91 19.41q4.36-.61 6.4-4.62 3.27-6.42 4.33-8.44 5.09-9.67 12.71-17.51 6.95-7.15 9.52-9.98c2.78-3.05 4.95-5.74 3.65-9.56a2.05 2.01 9.6 0 0-.73-1.01Z"
          />
          <path
            fill="#fe7459"
            d="M95.48 33.78c1.3 3.82-.87 6.51-3.65 9.56q-2.57 2.83-9.52 9.98-7.62 7.84-12.71 17.51-1.06 2.02-4.33 8.44-2.04 4.01-6.4 4.62c-9.02 1.25-6.37-14.91-4.91-19.41q7.54-23.27 29.85-32.36c3.56-1.45 7.75-1.71 10.94.65a2.05 2.01 9.6 0 1 .73 1.01Z"
          />
          <path
            fill="#c06a33"
            d="M122.71 208.35c-1.17 4.44-3.1 9.53-3.35 13.51-.35 5.56.62 10.41 2.56 15.45a.4.4 0 0 1-.43.54l-5.08-.71a1.24 1.24 0 0 1-1-.8c-3.62-9.62-1.68-18.87 1.43-28.74l5.87.75Z"
          />
        </svg>
      );
    case INDOOR_PLANTS:
      return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <g fill="none" stroke-width="2">
            <path
              stroke="#49873f"
              d="M122.54 85.5q-.71-4.24-2.68-14.64c-3.17-16.73-8.7-33.65-19.35-46.27a1.4 1.4 0 0 0-1.75-.32q-1.94 1.08-2.5 2.25a1.21 1.18 46.8 0 0-.02 1c1.91 4.41 5.42 9.89 7.67 14.91q6.39 14.23 9.37 30.88 1.12 6.27 2.24 13.54M135.15 104.02q1.16-1.97 2.59-3.48 2.16-2.29 2.81-3.26 14.22-21.06 35.16-34.04 7-4.34 14.57-4.68a1.06 1.06 0 0 1 .9 1.69q-1.55 2.09-4.02 3.38-13.71 7.12-23.29 16.25-12.22 11.63-20.37 24.07-.89 1.35-1.55 4.62M138.68 141.93q4.01-.63 5.75-1.74c12.53-7.98 33.31-15.76 48.22-9.86a.94.94 0 0 1-.16 1.8q-1.68.35-4.19.28-25.37-.67-44.85 14.82-1.95 1.55-3.06 4.03"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#927039" d="m122.71 170.32-7.8-.15" vector-effect="non-scaling-stroke" />
            <path
              stroke="#49873f"
              d="M93.5 121.14Q71.34 94.35 38.79 81.46q-.91-.36-2.79-1.55a1.42 1.42 0 0 1-.56-1.69q.43-1.18 1.73-2.24a1.53 1.53 0 0 1 1.31-.3q6.9 1.67 15.02 5.59 15.47 7.47 28.46 19.19.33.3 7.65 7.56 3.91 3.88 8.33 7.41"
              vector-effect="non-scaling-stroke"
            />
          </g>
          <path
            fill="#4f9042"
            d="M122.54 85.5q-.71-4.24-2.68-14.64c-3.17-16.73-8.7-33.65-19.35-46.27a1.4 1.4 0 0 0-1.75-.32q-1.94 1.08-2.5 2.25a1.21 1.18 46.8 0 0-.02 1c1.91 4.41 5.42 9.89 7.67 14.91q6.39 14.23 9.37 30.88 1.12 6.27 2.24 13.54c-33.87-9.94-49.8-41.46-34.47-73.8q3.55-7.49 5.82-10.24a1.7 1.68-75.8 0 1 .96-.58q3.22-.62 5.27.17c16.5 6.35 32.26 18.61 39.08 35.17 5.77 14.03 1.98 28.41-5.07 42.05q-1.9 3.69-4.57 5.88Z"
          />
          <path
            fill="#437e3b"
            d="M122.54 85.5q1.65 19.74 1.01 40.03a.41.4 59.2 0 0 .77.2l10.83-21.71q1.16-1.97 2.59-3.48 2.16-2.29 2.81-3.26 14.22-21.06 35.16-34.04 7-4.34 14.57-4.68a1.06 1.06 0 0 1 .9 1.69q-1.55 2.09-4.02 3.38-13.71 7.12-23.29 16.25-12.22 11.63-20.37 24.07-.89 1.35-1.55 4.62-1.31-.28-1.85.52-9.8 14.57-14.48 31.57c-1.58 5.73-2.35 13.35-3.07 18.75a.47.46 67.6 0 0 .83.35q4.69-6.18 10.63-11.5 2.4-2.14 4.67-6.33 4.01-.63 5.75-1.74c12.53-7.98 33.31-15.76 48.22-9.86a.94.94 0 0 1-.16 1.8q-1.68.35-4.19.28-25.37-.67-44.85 14.82-1.95 1.55-3.06 4.03-2.53-.02-3.96 1.42-8.06 8.12-13.72 17.64l-7.8-.15q-3.8-27.54-21.41-49.03-22.16-26.79-54.71-39.68-.91-.36-2.79-1.55a1.42 1.42 0 0 1-.56-1.69q.43-1.18 1.73-2.24a1.53 1.53 0 0 1 1.31-.3q6.9 1.67 15.02 5.59 15.47 7.47 28.46 19.19.33.3 7.65 7.56 3.91 3.88 8.33 7.41 0 2.43 2.39 5.21 1.75 2.02 2.07 2.44 9.07 11.67 14.08 25.47a.4.39 67.3 0 0 .54.23q.31-.15.31-.7.09-10.97.57-30.58.39-16.24-2.38-30.65-1.12-7.27-2.24-13.54-2.98-16.65-9.37-30.88c-2.25-5.02-5.76-10.5-7.67-14.91a1.21 1.18 46.8 0 1 .02-1q.56-1.17 2.5-2.25a1.4 1.4 0 0 1 1.75.32c10.65 12.62 16.18 29.54 19.35 46.27q1.97 10.4 2.68 14.64Z"
          />
          <path
            fill="#4f9042"
            d="M141.95 108.57q.66-3.27 1.55-4.62 8.15-12.44 20.37-24.07 9.58-9.13 23.29-16.25 2.47-1.29 4.02-3.38a1.06 1.06 0 0 0-.9-1.69q-7.57.34-14.57 4.68-20.94 12.98-35.16 34.04-.65.97-2.81 3.26-1.43 1.51-2.59 3.48-1.58-16.04 4.58-29.55c10.02-21.98 35.8-31.3 58.29-32.88q6.26-.44 12.18.37a2.73 2.73 0 0 1 2.32 2.27q.29 1.83-.11 4.77c-1.86 13.69-5.17 27.51-14.01 38.31-14.16 17.28-34.74 22.3-56.45 21.26ZM97.94 115.43q-4.42-3.53-8.33-7.41-7.32-7.26-7.65-7.56Q68.97 88.74 53.5 81.27q-8.12-3.92-15.02-5.59a1.53 1.53 0 0 0-1.31.3q-1.3 1.06-1.73 2.24a1.42 1.42 0 0 0 .56 1.69q1.88 1.19 2.79 1.55 32.55 12.89 54.71 39.68c-32.14 5.79-62.12-6.59-77.59-35.81q-3.95-7.45-7.37-16.12-1.25-3.17-1.33-6.16a1.25 1.24 74.2 0 1 .61-1.11q2.13-1.28 4.01-1.63 20.49-3.89 40.71 1.12c15.27 3.79 28.91 10.69 37.11 24.43q7.56 12.67 8.29 29.57ZM140.39 151.26q1.11-2.48 3.06-4.03 19.48-15.49 44.85-14.82 2.51.07 4.19-.28a.94.94 0 0 0 .16-1.8c-14.91-5.9-35.69 1.88-48.22 9.86q-1.74 1.11-5.75 1.74c7.98-12.59 19.31-21.37 33.76-23.78 16.02-2.68 35.82 2.9 47.76 13.88q2.31 2.12 3.17 4.25a1.95 1.94-29.6 0 1-.63 2.27q-3.83 2.91-11.5 6.96-7.8 4.11-12.03 5.85-16.71 6.85-35.46 3.35-7.4-1.39-23.36-3.45Z"
          />
          <path
            fill="#e06137"
            d="M122.71 170.32q17.21.1 33.79.01 2.58-.01 5.02.44a.96.96 0 0 1 .78 1.02l-.99 12.15a1.5 1.49-88.3 0 1-1.45 1.38q-1.6.04-2.29.36a1.07 1.04-7.4 0 0-.6.76q-1.36 7.21-8.18 44.59c-.74 4.07-2.6 4.87-6.58 4.83q-2.22-.02-49.95-.03c-3.29 0-4.41-2.24-4.97-5.31q-4.19-23.16-8.04-44.04a1.11 1.11 0 0 0-.65-.83q-.81-.36-2.53-.39a1.17 1.17 0 0 1-1.14-1.07l-1.03-12.6a.73.73 0 0 1 .72-.79l40.29-.63 7.8.15Z"
          />
        </svg>
      );

      return (
        <svg
          className={classes}
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          viewBox="0.00 0.00 100.00 100.00"
        >
          <path
            d="
  M 14.02 2.62
  Q 16.10 2.63 15.91 5.41
  A 1.20 1.18 -65.9 0 0 16.25 6.33
  L 20.14 10.21
  A 1.14 1.12 -22.3 0 0 20.94 10.54
  L 23.15 10.54
  A 0.76 0.76 0.0 0 1 23.91 11.31
  L 23.86 28.63
  A 0.79 0.78 87.9 0 1 23.14 29.41
  Q 22.90 29.43 13.95 29.41
  Q 5.00 29.39 4.76 29.37
  A 0.79 0.78 -87.6 0 1 4.04 28.58
  L 4.08 11.26
  A 0.76 0.76 0.0 0 1 4.84 10.49
  L 7.05 10.50
  A 1.14 1.12 22.6 0 0 7.85 10.18
  L 11.76 6.32
  A 1.20 1.18 66.2 0 0 12.11 5.40
  Q 11.93 2.62 14.02 2.62
  Z
  M 14.71 4.74
  A 0.71 0.44 0.0 0 0 14.00 4.30
  A 0.71 0.44 0.0 0 0 13.29 4.74
  A 0.71 0.44 0.0 0 0 14.00 5.18
  A 0.71 0.44 0.0 0 0 14.71 4.74
  Z
  M 13.99 10.57
  Q 15.92 10.56 17.78 10.56
  A 0.30 0.30 0.0 0 0 18.00 10.06
  Q 16.45 8.32 14.75 6.78
  Q 14.53 6.58 13.98 6.58
  Q 13.42 6.58 13.21 6.78
  Q 11.52 8.34 9.98 10.09
  A 0.30 0.30 0.0 0 0 10.20 10.59
  Q 12.06 10.57 13.99 10.57
  Z
  M 5.91 23.77
  Q 6.73 23.15 8.99 20.51
  Q 9.87 19.48 10.39 19.46
  Q 11.16 19.42 11.86 20.45
  A 0.56 0.56 0.0 0 0 12.72 20.53
  L 17.10 16.15
  A 0.64 0.63 44.7 0 1 17.99 16.15
  L 22.04 20.21
  A 0.24 0.24 0.0 0 0 22.45 20.04
  L 22.45 12.53
  A 0.58 0.58 0.0 0 0 21.87 11.95
  L 6.17 11.95
  A 0.71 0.71 0.0 0 0 5.46 12.66
  L 5.46 23.55
  A 0.28 0.28 0.0 0 0 5.91 23.77
  Z
  M 13.94 22.83
  L 16.68 25.57
  A 0.51 0.50 45.4 0 1 16.68 26.28
  L 16.47 26.49
  A 0.52 0.52 0.0 0 1 15.73 26.49
  L 10.79 21.55
  A 0.50 0.49 44.6 0 0 10.10 21.55
  L 5.55 26.10
  A 1.13 1.13 0.0 0 0 6.34 28.03
  L 21.85 28.03
  A 0.60 0.60 0.0 0 0 22.45 27.43
  L 22.45 23.12
  A 1.27 1.22 23.2 0 0 22.08 22.24
  L 18.16 18.32
  A 0.89 0.88 -44.8 0 0 16.91 18.32
  L 13.94 21.30
  A 1.08 1.07 45.2 0 0 13.94 22.83
  Z"
          />
          <path
            d="
  M 94.60 13.40
  A 1.23 1.23 0.0 0 1 95.83 14.63
  L 95.83 49.52
  A 0.90 0.90 0.0 0 1 94.93 50.42
  L 73.45 50.42
  A 0.81 0.81 0.0 0 0 72.64 51.23
  L 72.64 51.58
  A 0.91 0.90 -2.9 0 0 73.64 52.48
  Q 75.51 52.29 76.71 52.62
  A 0.73 0.73 0.0 0 1 76.52 54.06
  L 60.22 54.06
  A 0.72 0.72 0.0 0 1 59.50 53.34
  L 59.50 53.03
  A 0.59 0.59 0.0 0 1 60.09 52.44
  L 63.06 52.44
  A 0.96 0.95 90.0 0 0 64.01 51.48
  L 64.01 51.08
  A 0.69 0.68 0.4 0 0 63.33 50.40
  L 54.39 50.38
  A 0.69 0.68 -81.7 0 1 53.74 49.50
  L 53.75 49.48
  A 1.03 1.02 -83.7 0 1 54.75 48.67
  L 93.61 48.64
  A 0.58 0.58 0.0 0 0 94.19 48.06
  L 94.19 16.54
  A 0.67 0.67 0.0 0 0 93.52 15.87
  L 43.12 15.87
  A 0.63 0.63 0.0 0 0 42.49 16.50
  L 42.49 24.46
  A 0.94 0.93 0.0 0 1 41.55 25.39
  L 41.25 25.39
  A 0.64 0.64 0.0 0 1 40.61 24.75
  L 40.61 14.50
  A 1.10 1.10 0.0 0 1 41.71 13.40
  L 94.60 13.40
  Z
  M 71.1083 51.1407
  A 0.79 0.79 0.0 0 0 70.3128 50.3562
  L 66.3529 50.3838
  A 0.79 0.79 0.0 0 0 65.5684 51.1793
  L 65.5717 51.6593
  A 0.79 0.79 0.0 0 0 66.3672 52.4438
  L 70.3271 52.4162
  A 0.79 0.79 0.0 0 0 71.1116 51.6207
  L 71.1083 51.1407
  Z"
          />
          <path
            d="
  M 44.49 26.83
  L 44.49 18.23
  A 0.34 0.34 0.0 0 1 44.83 17.89
  L 92.01 17.89
  A 0.34 0.34 0.0 0 1 92.35 18.23
  L 92.35 46.36
  A 0.34 0.34 0.0 0 1 92.01 46.70
  L 56.23 46.70
  A 0.34 0.34 0.0 0 1 55.90 46.29
  L 56.15 45.07
  A 0.34 0.34 0.0 0 1 56.49 44.80
  L 90.11 44.80
  A 0.34 0.34 0.0 0 0 90.45 44.46
  L 90.45 19.96
  A 0.34 0.34 0.0 0 0 90.11 19.62
  L 46.59 19.62
  A 0.34 0.34 0.0 0 0 46.25 19.96
  L 46.25 27.06
  A 0.34 0.34 0.0 0 1 45.84 27.39
  L 44.76 27.17
  A 0.34 0.34 0.0 0 1 44.49 26.83
  Z"
          />
          <path
            d="
  M 62.15 96.39
  A 0.53 0.53 0.0 0 1 61.62 96.92
  L 60.95 96.92
  A 0.59 0.59 0.0 0 1 60.36 96.35
  Q 60.04 85.98 59.34 83.38
  C 57.35 75.98 50.35 74.62 45.04 72.03
  A 0.67 0.67 0.0 0 0 44.11 72.42
  C 40.91 82.49 28.87 76.79 24.72 71.28
  A 0.82 0.82 0.0 0 0 23.75 71.01
  C 15.94 74.08 7.78 76.55 6.99 86.50
  Q 6.59 91.58 6.61 95.93
  A 1.03 1.03 0.0 0 1 5.58 96.97
  L 5.28 96.97
  A 0.71 0.70 -89.2 0 1 4.58 96.24
  C 4.81 86.16 4.46 77.27 15.35 72.59
  Q 22.02 69.73 23.04 69.22
  A 3.24 3.22 -7.1 0 0 24.76 67.02
  Q 25.80 62.36 25.11 58.00
  A 1.22 1.21 10.1 0 0 24.48 57.11
  Q 17.50 53.35 20.14 46.19
  A 1.88 1.85 51.6 0 0 20.24 45.26
  Q 18.30 31.74 30.68 27.69
  Q 32.46 27.11 32.96 26.75
  C 34.15 25.91 34.95 25.55 36.02 26.23
  Q 37.11 26.92 40.53 27.93
  Q 46.98 29.82 48.93 36.84
  A 0.94 0.94 0.0 0 0 49.56 37.48
  C 52.76 38.45 55.19 38.94 56.81 41.06
  A 1.30 1.30 0.0 0 1 56.23 43.07
  Q 54.04 43.88 51.56 43.36
  A 1.21 1.21 0.0 0 0 50.10 44.49
  Q 49.97 47.66 50.27 51.44
  C 50.61 55.66 48.56 63.63 44.50 67.14
  A 1.83 1.82 35.7 0 0 45.01 70.21
  Q 47.68 71.31 52.08 73.19
  C 62.68 77.71 62.20 86.66 62.15 96.39
  Z
  M 21.66 42.92
  A 0.44 0.44 0.0 0 0 22.14 43.36
  Q 27.63 42.95 32.08 40.76
  C 37.18 38.24 41.33 36.87 46.19 37.12
  A 0.72 0.71 -8.7 0 0 46.90 36.16
  C 43.64 27.30 30.40 26.70 24.74 33.34
  Q 21.61 37.03 21.66 42.92
  Z
  M 53.97 41.42
  A 0.55 0.55 0.0 0 0 53.66 40.69
  Q 42.42 36.56 32.97 42.53
  A 0.49 0.49 0.0 0 0 33.14 43.42
  C 36.53 44.06 39.22 44.11 43.40 42.57
  Q 47.90 40.89 53.06 41.91
  A 0.82 0.82 0.0 0 0 53.96 41.45
  L 53.97 41.42
  Z
  M 21.59 47.44
  Q 20.35 53.68 25.58 55.41
  A 1.57 1.54 0.6 0 1 26.57 56.40
  Q 29.53 65.55 39.53 66.37
  Q 40.95 66.48 43.28 65.69
  A 2.09 1.99 -75.2 0 0 44.09 65.19
  C 47.63 61.66 48.85 52.88 48.28 48.55
  C 48.03 46.71 48.26 46.17 48.44 44.35
  A 1.01 1.01 0.0 0 0 47.08 43.31
  C 40.99 45.57 36.12 46.97 30.09 44.02
  A 1.45 1.45 0.0 0 0 28.01 45.32
  L 28.01 48.40
  A 1.45 1.45 0.0 0 1 25.53 49.43
  L 23.09 46.98
  A 0.89 0.89 0.0 0 0 21.59 47.44
  Z
  M 24.4658 44.8184
  A 1.15 0.96 -136.5 0 0 24.6392 46.3064
  A 1.15 0.96 -136.5 0 0 26.1342 46.4016
  A 1.15 0.96 -136.5 0 0 25.9608 44.9136
  A 1.15 0.96 -136.5 0 0 24.4658 44.8184
  Z
  M 27.14 62.56
  Q 27.28 66.31 25.90 68.87
  A 1.24 1.23 -51.1 0 0 26.04 70.23
  Q 29.95 74.95 35.96 75.96
  C 40.62 76.74 43.46 72.67 42.11 68.66
  A 0.82 0.80 77.4 0 0 41.26 68.11
  Q 33.74 68.83 27.58 62.38
  A 0.26 0.25 22.2 0 0 27.14 62.56
  Z"
          />
          <path
            d="
  M 78.55 82.42
  L 80.26 82.42
  A 2.55 2.55 0.0 0 1 82.81 84.97
  L 82.81 88.55
  A 2.27 2.27 0.0 0 1 80.60 90.82
  Q 76.13 90.95 70.20 90.83
  C 66.84 90.77 67.66 86.88 67.72 84.54
  C 67.76 83.28 68.07 82.86 69.14 82.46
  A 0.96 0.95 -4.1 0 0 69.76 81.76
  L 71.63 72.88
  A 0.86 0.86 0.0 0 0 70.83 71.85
  Q 67.78 71.70 66.31 69.21
  A 1.79 1.73 30.5 0 1 66.06 68.31
  L 66.04 64.22
  A 0.53 0.48 -42.1 0 1 66.05 64.12
  Q 67.15 61.00 70.03 61.00
  Q 84.48 60.97 84.75 60.94
  A 1.94 1.92 -30.4 0 1 86.11 61.29
  C 88.03 62.66 90.50 61.31 92.13 62.67
  Q 93.49 63.80 93.55 64.55
  A 0.77 0.77 0.0 0 0 94.31 65.20
  L 98.69 65.20
  A 0.71 0.70 -0.0 0 1 99.40 65.90
  L 99.40 66.27
  A 0.42 0.42 0.0 0 1 98.98 66.69
  L 94.05 66.70
  A 0.49 0.49 0.0 0 0 93.56 67.21
  C 93.68 69.68 89.87 70.38 88.07 70.11
  A 1.15 1.15 0.0 0 0 87.05 70.45
  Q 85.95 71.61 84.25 71.42
  A 0.91 0.91 0.0 0 0 83.25 72.14
  L 82.66 74.91
  A 1.36 1.35 86.6 0 1 81.78 75.91
  Q 80.95 76.20 79.94 76.11
  A 0.87 0.87 0.0 0 0 79.01 76.80
  L 77.97 81.71
  A 0.59 0.59 0.0 0 0 78.55 82.42
  Z
  M 75.86 82.35
  A 0.69 0.69 0.0 0 0 76.54 81.79
  Q 77.18 78.33 78.52 72.49
  C 79.13 69.86 83.02 69.62 84.82 70.01
  A 1.01 1.01 0.0 0 0 86.05 69.02
  L 86.05 63.55
  A 1.15 1.15 0.0 0 0 84.90 62.40
  L 69.82 62.40
  A 2.22 2.22 0.0 0 0 67.62 64.30
  Q 67.28 66.60 67.58 68.11
  A 2.61 2.60 -89.9 0 0 69.60 70.15
  L 71.41 70.53
  A 2.14 2.13 -78.1 0 1 73.05 73.06
  L 71.21 81.82
  A 0.44 0.44 0.0 0 0 71.64 82.35
  L 75.86 82.35
  Z
  M 87.52 64.01
  L 87.50 68.11
  A 0.54 0.54 0.0 0 0 88.03 68.66
  L 90.08 68.67
  A 2.09 1.83 0.4 0 0 92.18 66.86
  L 92.20 65.34
  A 2.09 1.83 0.4 0 0 90.12 63.49
  L 88.07 63.48
  A 0.54 0.54 0.0 0 0 87.52 64.01
  Z
  M 81.5531 71.5478
  A 1.77 0.91 -64.1 0 0 79.9614 72.7425
  A 1.77 0.91 -64.1 0 0 80.0069 74.7322
  A 1.77 0.91 -64.1 0 0 81.5986 73.5375
  A 1.77 0.91 -64.1 0 0 81.5531 71.5478
  Z
  M 81.3897 84.7921
  A 0.98 0.98 0.0 0 0 80.4148 83.8070
  L 70.1149 83.7531
  A 0.98 0.98 0.0 0 0 69.1298 84.7279
  L 69.1103 88.4479
  A 0.98 0.98 0.0 0 0 70.0852 89.4330
  L 80.3851 89.4869
  A 0.98 0.98 0.0 0 0 81.3702 88.5121
  L 81.3897 84.7921
  Z"
          />
          <rect x="69.99" y="65.20" width="5.82" height="1.46" rx="0.70" />
          <rect
            x="-0.92"
            y="-5.47"
            transform="translate(18.65,91.55) rotate(0.5)"
            width="1.84"
            height="10.94"
            rx="0.87"
          />
          <rect
            x="-0.99"
            y="-5.24"
            transform="translate(54.59,91.70) rotate(-0.2)"
            width="1.98"
            height="10.48"
            rx="0.71"
          />
        </svg>
      );
    case PARTY_DECOR:
      return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <g fill="none" stroke="#ed7537" stroke-width="2">
            <path
              d="M156.88 56.96q-10.03 7.28-18.19 11.72-32.94 17.92-71.71 24.81M170.08 84.51q-1.89 1.67-3.66 3.12-18.9 15.32-41.01 25.47-36.2 16.63-76.41 20.41M185.61 120.4q-14.62 12.07-22.99 17.72-20.15 13.6-46.08 23.71-29 11.31-59.51 17.48-13.78 2.79-28.1 2.82M198.26 149.88q-13.64 13.79-27.16 23.19-28.69 19.94-64.25 31.47c-5.24 1.7-10.75 2.93-17.25 4.7q-5.65 1.54-13.07 2.87-22.03 3.92-45.24 4.71"
              vector-effect="non-scaling-stroke"
            />
          </g>
          <path
            fill="#e45b36"
            d="M156.88 56.96q-10.03 7.28-18.19 11.72-32.94 17.92-71.71 24.81 1.04-2.96 1.62-4.42 13.7-34.31 31.1-72.64 5.38-11.86 17-13.54a1.52 1.13 34.8 0 1 .29-.01l5.82.5a1.81 1.74 57.4 0 1 .58.14q4.67 1.95 6.21 3.59c2.55 2.72 4.65 5.44 6.96 9.62q10.93 19.75 20.32 40.23Z"
          />
          <path
            fill="#f68f38"
            d="m156.88 56.96 13.2 27.55q-1.89 1.67-3.66 3.12-18.9 15.32-41.01 25.47-36.2 16.63-76.41 20.41l17.98-40.02q38.77-6.89 71.71-24.81 8.16-4.44 18.19-11.72Z"
          />
          <path
            fill="#e45b36"
            d="M185.61 120.4q-14.62 12.07-22.99 17.72-20.15 13.6-46.08 23.71-29 11.31-59.51 17.48-13.78 2.79-28.1 2.82L49 133.51q40.21-3.78 76.41-20.41 22.11-10.15 41.01-25.47 1.77-1.45 3.66-3.12l15.53 35.89Z"
          />
          <path
            fill="#f68f38"
            d="m185.61 120.4 12.65 29.48q-13.64 13.79-27.16 23.19-28.69 19.94-64.25 31.47c-5.24 1.7-10.75 2.93-17.25 4.7q-5.65 1.54-13.07 2.87-22.03 3.92-45.24 4.71-2.68-1.57-5.98-5.12c-2.59-2.79-2.53-5.32-2.41-9.48q.16-5.58 1.26-9.03 1.41-4.39 4.77-11.06 14.32-.03 28.1-2.82 30.51-6.17 59.51-17.48 25.93-10.11 46.08-23.71 8.37-5.65 22.99-17.72Z"
          />
          <path
            fill="#e45b36"
            d="M198.26 149.88q8.09 19.76 15.27 39.61.51 1.41 1.91 6.99c.43 1.74-.15 3.13.55 4.84a1.64 1.62 33.3 0 1 .12.56c.31 5.53-2.97 10.58-6.82 14.14-8.64 8-17.6 12.41-29.64 15.25-18.48 4.37-38.38 6.03-56.78 6.26q-4.31.06-5.33.27-1.52.32-7.32-.43c-6.97-.9-14.06-1.3-20.47-1.99q-2.63-.29-5.81-1.24c-2.28-.69-5.02-.46-7.87-1.04-13.83-2.77-26.39-5.58-39-12.11q-2.65-1.37-5.78-4.17 23.21-.79 45.24-4.71 7.42-1.33 13.07-2.87c6.5-1.77 12.01-3 17.25-4.7q35.56-11.53 64.25-31.47 13.52-9.4 27.16-23.19Z"
          />
        </svg>
      );
    case BEAUTY:
      return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <g fill="none" stroke-width="2">
            <path
              stroke="#d45e3a"
              d="m135.86 29.85-.01 7.76M127.81 46.45l-30.8.07"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#cf5633" d="M127.85 54.91 97 55.02" vector-effect="non-scaling-stroke" />
            <path stroke="#b84e31" d="m143.75 73.54-.2.62" vector-effect="non-scaling-stroke" />
            <path stroke="#f08969" d="m143.55 74.16-62.07.02" vector-effect="non-scaling-stroke" />
            <path stroke="#cf5633" d="m85.73 54.93 4.28-.02" vector-effect="non-scaling-stroke" />
            <path stroke="#a73f23" d="m150.25 37.67-1-7.67" vector-effect="non-scaling-stroke" />
            <path
              stroke="#c87259"
              d="M143.72 74.33q-.17-.55-.17-.17"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#bd5638"
              d="M118.89 23.43a6.27 6.27 0 0 0-6.27-6.27 6.27 6.27 0 0 0-6.27 6.27 6.27 6.27 0 0 0 6.27 6.27 6.27 6.27 0 0 0 6.27-6.27"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffcdb1"
              d="M117.829 106.831a42.94 42.8-83.1 0 0-47.649 37.487 42.94 42.8-83.1 0 0 37.331 47.771 42.94 42.8-83.1 0 0 47.649-37.487 42.94 42.8-83.1 0 0-37.331-47.771"
              vector-effect="non-scaling-stroke"
            />
          </g>
          <path
            fill="#ea744f"
            d="m135.86 29.85-.01 7.76q.05 3.03-.06 6.25c-.07 2.02-1.19 2.7-3.06 2.59q-1.3-.08-4.92 0l-30.8.07-5.44-.07a2.39 2.39 0 0 1-2.36-2.38q-.05-14.79-.02-32.74c.01-2.26.57-3 2.82-3.1q5.51-.25 40.98-.07c2.36.01 2.84 1.11 2.84 3.37q.03 9.11.03 18.32Zm-16.97-6.42a6.27 6.27 0 0 0-6.27-6.27 6.27 6.27 0 0 0-6.27 6.27 6.27 6.27 0 0 0 6.27 6.27 6.27 6.27 0 0 0 6.27-6.27Z"
          />
          <path
            fill="#903721"
            d="m150.25 37.67-1-7.67q5.08-6.13 8.13-8.62c13.46-10.96 32.69-15.8 49.55-10.58 10.85 3.35 19.74 12.78 18.92 24.73-.71 10.35-8.74 18.37-18.38 21.44-19.89 6.34-45.31-2.02-57.22-19.3Z"
          />
          <circle cx="112.62" cy="23.43" r="6.27" fill="#903721" />
          <path
            fill="#bd4724"
            d="m149.25 30 1 7.67-14.4-.06.01-7.76 13.39.15ZM127.81 46.45l.04 8.46-30.85.11.01-8.5 30.8-.07Z"
          />
          <path
            fill="#e06541"
            d="m143.75 73.54-.2.62-62.07.02q-.5-11.89-.05-15.93.34-3.11 4.3-3.32l4.28-.02 6.99.11 30.85-.11 11.9-.08q2.36-.02 3.37 1.94.61 1.18.63 4.03.04 6.38 0 12.74Z"
          />
          <path fill="#bd4724" d="m90.01 54.91-4.28.02 4.28-.02Z" />
          <path fill="#903721" d="M143.75 73.54q-.12.19-.03.79-.17-.55-.17-.17l.2-.62Z" />
          <path
            fill="#ffad90"
            d="m81.48 74.18 62.07-.02q0-.38.17.17 1.94.42 4.02.8 15.16 2.8 25.7 12.94 12.75 12.27 15.47 28.45 1.19 7.13-.21 23.5-1.15 13.4-4.69 63.34-.7 9.91-2.18 13.68c-2.88 7.38-9.05 13.62-16.68 16.15q-2.64.88-9.89.87-65.16-.1-89.76-.1c-9.84 0-18.38-7.46-22.18-16.01q-2.08-4.67-2.77-17.68-.28-5.34-4.68-65.28-.76-10.26-.34-14.5c1.04-10.56 4.89-19.95 11.86-28.15q13.02-15.35 34.09-18.16Zm36.349 32.651a42.94 42.8-83.1 0 0-47.649 37.487 42.94 42.8-83.1 0 0 37.331 47.771 42.94 42.8-83.1 0 0 47.649-37.487 42.94 42.8-83.1 0 0-37.331-47.771Z"
          />
          <ellipse fill="#ffecd2" rx="42.94" ry="42.8" transform="rotate(-83.1 140.654 11.167)" />
        </svg>
      );
    case GOURMET_SETS:
      return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <g fill="none" stroke-width="2">
            <path
              stroke="#8b6026"
              d="M116.39 99.34c-3.83-.06-3.25 4.91-3.46 7.49-.23 2.94.7 4.3 3.39 5.14"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#7e4a23"
              d="M116.32 111.97q-1.41 4-2.35 4.97-3.11 3.22-3.35 6.55-.66 9.38-.67 30.26"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#7f6531"
              d="m109.95 153.75-12.22-.03"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#967b31" d="m97.73 153.72-.09-10.99" vector-effect="non-scaling-stroke" />
            <path
              stroke="#998237"
              d="M97.64 142.73q-3.84-5.97-10.09-11.97"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#999d77"
              d="M87.55 130.76q8.83-.31 16.19-.07c2.15.07 3.23-.46 3.31-2.69q.66-18.67.66-42.16a1.39 1.38-90 0 0-1.38-1.39q-16.46-.02-34.6-.02-2.06.01-2.06 2.57-.03 13.75.03 27.97"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#998237" d="m69.7 114.97-8.01-6.41" vector-effect="non-scaling-stroke" />
            <path
              stroke="#ffcc80"
              d="M87.55 130.76 69.7 114.97"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#7f6531" d="m205 153.89.46.01" vector-effect="non-scaling-stroke" />
            <path stroke="#d2833e" d="m217.01 167-197.42-.26" vector-effect="non-scaling-stroke" />
            <path
              stroke="#fcaa3a"
              d="M97.64 142.73q-5.59.23-10.14-1.26c-11.33-3.71-24.96-9.01-33.28-12.04q-1.92-.7-30.51-10.83-2.83-1-6.55-3.94"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#ca5d26" d="m172.6 153.86-12.04-.06" vector-effect="non-scaling-stroke" />
            <path
              stroke="#e4946c"
              d="M160.56 153.8q.47-11.72.4-23.32c-.02-3.66-1.89-3.33-4.72-3.33q-7.82.01-29.99.02-2.35 0-3.27.38a1.95 1.87-12.4 0 0-1.2 1.79l.45 24.51"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#ca5d26" d="m122.23 153.85-12.28-.1" vector-effect="non-scaling-stroke" />
            <path stroke="#e28e33" d="m97.73 153.72-80.93.09" vector-effect="non-scaling-stroke" />
            <path stroke="#d6581b" d="m165.06 111.42-48.74.55" vector-effect="non-scaling-stroke" />
            <path stroke="#e5b079" d="m160.56 153.8-38.33.05" vector-effect="non-scaling-stroke" />
            <path stroke="#6e4727" d="m205.46 153.54-.46.35" vector-effect="non-scaling-stroke" />
            <path stroke="#b95a29" d="m205 153.89-32.4-.03" vector-effect="non-scaling-stroke" />
            <path
              stroke="#b93f1c"
              d="M172.6 153.86q-.61-11.63-.56-23.36.02-3.59 1.21-6.94"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#be4324"
              d="M173.25 123.56q.92-2.18 1.64-4.35 3.59-10.79 6.99-21.65c.35-1.1 1.63-2.59 1.13-4.07"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ce4520"
              d="m173.25 123.56-8.19-12.14"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#db5c23"
              d="m165.06 111.42 3.01-.54a2.21 2.2 82.4 0 0 1.81-2.38l-.72-7.59a1.17 1.15-73.8 0 0-.42-.78q-1.17-.91-2.66-1.04"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#e99874"
              d="M166.08 99.09q3.53-6.93 1.75-12.89c-3.12-10.39-15.02-14.53-23.84-7.94q-9.36 7-4.25 20.11"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#db5c23"
              d="M139.74 98.37q-.17.93-1.43.96-8.23.22-16.63.01"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#f1ab6e"
              d="M166.08 99.09q-17.06.31-24.97.32-.7 0-1.37-1.04"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#b95a29"
              d="M225.08 44.23q-.09.72.1 1.66M218.02 53.86q-3.06-1.64-6.42-1.69"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#fcaa3a"
              d="M43.2 116.095a6.3 4.73-174.4 0 0 5.808 5.322 6.3 4.73-174.4 0 0 6.732-4.092 6.3 4.73-174.4 0 0-5.808-5.322 6.3 4.73-174.4 0 0-6.732 4.092M68.54 130.23a3.78 2.16-179.4 0 0 3.757 2.2 3.78 2.16-179.4 0 0 3.803-2.12 3.78 2.16-179.4 0 0-3.757-2.2 3.78 2.16-179.4 0 0-3.803 2.12"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#d2833e"
              d="M68.99 181.84a2.69 2.69 0 0 0-2.7-2.681l-18.08.063a2.69 2.69 0 0 0-2.68 2.699v.16a2.69 2.69 0 0 0 2.7 2.68l18.08-.063A2.69 2.69 0 0 0 68.99 182v-.16M111.5 181.87a2.69 2.69 0 0 0-2.695-2.686l-18.28.032a2.69 2.69 0 0 0-2.685 2.695v.16a2.69 2.69 0 0 0 2.695 2.685l18.28-.032a2.69 2.69 0 0 0 2.685-2.695v-.16M154.04 181.921a2.68 2.68 0 0 0-2.675-2.685l-18.68-.032a2.68 2.68 0 0 0-2.685 2.675v.16a2.68 2.68 0 0 0 2.675 2.685l18.68.032a2.68 2.68 0 0 0 2.685-2.675v-.16M195.4 181.86a2.68 2.68 0 0 0-2.69-2.67l-17.26.06a2.68 2.68 0 0 0-2.67 2.69v.18a2.68 2.68 0 0 0 2.69 2.67l17.26-.06a2.68 2.68 0 0 0 2.67-2.69v-.18M89.36 199.533a2.86 2.86 0 0 0-2.85-2.87l-19.04-.066a2.86 2.86 0 0 0-2.87 2.85v.18a2.86 2.86 0 0 0 2.85 2.87l19.04.066a2.86 2.86 0 0 0 2.87-2.85v-.18M132.91 199.49a2.87 2.87 0 0 0-2.87-2.87H110.7a2.87 2.87 0 0 0-2.87 2.87v.18a2.87 2.87 0 0 0 2.87 2.87h19.34a2.87 2.87 0 0 0 2.87-2.87v-.18M176.43 199.512a2.85 2.85 0 0 0-2.845-2.855l-19.32-.034a2.85 2.85 0 0 0-2.855 2.845v.16a2.85 2.85 0 0 0 2.845 2.855l19.32.034a2.85 2.85 0 0 0 2.855-2.845v-.16M72.76 216.78a2.66 2.66 0 0 0-2.66-2.66H52.22a2.66 2.66 0 0 0-2.66 2.66v.16a2.66 2.66 0 0 0 2.66 2.66H70.1a2.66 2.66 0 0 0 2.66-2.66v-.16M111.3 216.77a2.65 2.65 0 0 0-2.65-2.65h-19a2.65 2.65 0 0 0-2.65 2.65v.14a2.65 2.65 0 0 0 2.65 2.65h19a2.65 2.65 0 0 0 2.65-2.65v-.14M153.95 216.769a2.66 2.66 0 0 0-2.665-2.655l-18.76.032a2.66 2.66 0 0 0-2.655 2.665v.16a2.66 2.66 0 0 0 2.665 2.655l18.76-.032a2.66 2.66 0 0 0 2.655-2.665v-.16M189.79 216.8a2.68 2.68 0 0 0-2.675-2.685l-16.96-.03a2.68 2.68 0 0 0-2.685 2.675v.16a2.68 2.68 0 0 0 2.675 2.685l16.96.03a2.68 2.68 0 0 0 2.685-2.675v-.16"
              vector-effect="non-scaling-stroke"
            />
          </g>
          <path
            fill="#33522e"
            d="M116.39 99.34c-3.83-.06-3.25 4.91-3.46 7.49-.23 2.94.7 4.3 3.39 5.14q-1.41 4-2.35 4.97-3.11 3.22-3.35 6.55-.66 9.38-.67 30.26l-12.22-.03-.09-10.99q-3.84-5.97-10.09-11.97 8.83-.31 16.19-.07c2.15.07 3.23-.46 3.31-2.69q.66-18.67.66-42.16a1.39 1.38-90 0 0-1.38-1.39q-16.46-.02-34.6-.02-2.06.01-2.06 2.57-.03 13.75.03 27.97l-8.01-6.41q-.33-14.77-.35-29.21-.02-7.03.98-9.73c2.28-6.19 6.87-9.73 12.41-14.64 2.77-2.45 3.59-5.28 3.73-9.3q.96-27.03.98-27.14a1.1 1.08 20.2 0 0-.48-1.02q-.46-.3-.77-.72a1.79 1.77 26.2 0 1-.34-.98c-.16-4.53-1.19-10.7 4.14-10.69q12.59.03 14.08-.01 2.68-.07 3.9 2.33a1.99 1.99 0 0 1 .21.89v7a2.29 2.26 63 0 1-.42 1.32l-1.24 1.74a1.04.99 63.7 0 0-.2.64q.23 12.52.79 27.71.18 5.02 3.38 7.91c4.7 4.25 8.46 6.86 10.76 10.87q3.1 5.42 3.11 10.65.04 11.52.03 23.16Z"
          />
          <path
            fill="#ca7833"
            d="M225.08 44.23q-.09.72.1 1.66-2.01 4.43-7.16 7.97-3.06-1.64-6.42-1.69c-.73-3.6-1.48-9.47.99-12.36a2.48 2.44-60 0 1 2.68-.74c2.34.81 2.06 2.62 2.45 4.6a.52.52 0 0 0 .78.34c.73-.45 1.42-1.17 2.2-1.48q3-1.22 4.38 1.7Z"
          />
          <path
            fill="#a83c1f"
            d="M225.18 45.89q-.19-.94-.1-1.66l.1 1.66ZM218.02 53.86q4.48 2.55 6.97 6.63 4.32 7.06 3.64 15c-.33 3.89-1.88 8.06-3.16 12.41q-9.68 32.92-20.01 65.64l-.46.35-32.4-.03q-.61-11.63-.56-23.36.02-3.59 1.21-6.94.92-2.18 1.64-4.35 3.59-10.79 6.99-21.65c.35-1.1 1.63-2.59 1.13-4.07q.74-1.08.84-1.44 2.1-7.4 4.56-15.19c2.88-9.12 4.53-14.81 10.44-20q5.09-4.46 12.75-4.69 3.36.05 6.42 1.69Z"
          />
          <path
            fill="#d34928"
            d="M183.01 93.49c.5 1.48-.78 2.97-1.13 4.07q-3.4 10.86-6.99 21.65-.72 2.17-1.64 4.35l-8.19-12.14 3.01-.54a2.21 2.2 82.4 0 0 1.81-2.38l-.72-7.59a1.17 1.15-73.8 0 0-.42-.78q-1.17-.91-2.66-1.04 3.53-6.93 1.75-12.89c-3.12-10.39-15.02-14.53-23.84-7.94q-9.36 7-4.25 20.11-.17.93-1.43.96-8.23.22-16.63.01l5.5-45.29a1.7 1.69-89.4 0 1 1.52-1.49q2.1-.22 5.05 0 15.39 1.15 41.75 3.01 4.49.31 8.99.98a1.86 1.85 6.5 0 1 1.57 1.97q-1.38 17.08-3.48 33.72-.09.69.43 1.25Z"
          />
          <path
            fill="#ffe7bf"
            d="M166.08 99.09q-17.06.31-24.97.32-.7 0-1.37-1.04-5.11-13.11 4.25-20.11c8.82-6.59 20.72-2.45 23.84 7.94q1.78 5.96-1.75 12.89ZM87.55 130.76 69.7 114.97q-.06-14.22-.03-27.97 0-2.56 2.06-2.57 18.14 0 34.6.02a1.39 1.38-90 0 1 1.38 1.39q0 23.49-.66 42.16c-.08 2.23-1.16 2.76-3.31 2.69q-7.36-.24-16.19.07Z"
          />
          <path
            fill="#feb140"
            d="m61.69 108.56 8.01 6.41 17.85 15.79q6.25 6 10.09 11.97-5.59.23-10.14-1.26c-11.33-3.71-24.96-9.01-33.28-12.04q-1.92-.7-30.51-10.83-2.83-1-6.55-3.94 6.48-5.01 13.76-9c5.38-2.94 9.92-5.53 15.07-7.69a2.79 2.78-37.2 0 1 2.81.38l12.89 10.21Zm-18.49 7.535a6.3 4.73-174.4 0 0 5.808 5.322 6.3 4.73-174.4 0 0 6.732-4.092 6.3 4.73-174.4 0 0-5.808-5.322 6.3 4.73-174.4 0 0-6.732 4.092Zm25.34 14.135a3.78 2.16-179.4 0 0 3.757 2.2 3.78 2.16-179.4 0 0 3.803-2.12 3.78 2.16-179.4 0 0-3.757-2.2 3.78 2.16-179.4 0 0-3.803 2.12Z"
          />
          <path
            fill="#e36e1d"
            d="M166.08 99.09q1.49.13 2.66 1.04a1.17 1.15-73.8 0 1 .42.78l.72 7.59a2.21 2.2 82.4 0 1-1.81 2.38l-3.01.54-48.74.55c-2.69-.84-3.62-2.2-3.39-5.14.21-2.58-.37-7.55 3.46-7.49h5.29q8.4.21 16.63-.01 1.26-.03 1.43-.96.67 1.04 1.37 1.04 7.91-.01 24.97-.32Z"
          />
          <path
            fill="#c94118"
            d="m165.06 111.42 8.19 12.14q-1.19 3.35-1.21 6.94-.05 11.73.56 23.36l-12.04-.06q.47-11.72.4-23.32c-.02-3.66-1.89-3.33-4.72-3.33q-7.82.01-29.99.02-2.35 0-3.27.38a1.95 1.87-12.4 0 0-1.2 1.79l.45 24.51-12.28-.1q.01-20.88.67-30.26.24-3.33 3.35-6.55.94-.97 2.35-4.97l48.74-.55Z"
          />
          <ellipse fill="#f9a333" rx="6.3" ry="4.73" transform="rotate(-174.4 27.589 57.145)" />
          <path
            fill="#f9a333"
            d="M17.16 114.66q3.72 2.94 6.55 3.94 28.59 10.13 30.51 10.83c8.32 3.03 21.95 8.33 33.28 12.04q4.55 1.49 10.14 1.26l.09 10.99-80.93.09q-2.21-17.55-.95-34.63a5.63 5.51 56.9 0 1 .28-1.4l1.03-3.12Z"
          />
          <path
            fill="#ffe7bf"
            d="m160.56 153.8-38.33.05-.45-24.51a1.95 1.87-12.4 0 1 1.2-1.79q.92-.38 3.27-.38 22.17-.01 29.99-.02c2.83 0 4.7-.33 4.72 3.33q.07 11.6-.4 23.32Z"
          />
          <ellipse fill="#f9a333" rx="3.78" ry="2.16" transform="rotate(-179.4 36.501 64.946)" />
          <path
            fill="#ca7833"
            d="m97.73 153.72 12.22.03 12.28.1 38.33-.05 12.04.06 32.4.03.46.01q6.49-.04 12.96 0c3.56.02 6.51.71 6.77 4.57.27 4.09-1.78 7.52-5.86 8.14q-1.18.17-2.32.39l-197.42-.26q-9.87-.06-8.2-9.82a1.99 1.85 71.5 0 1 .4-.88q1.89-2.32 5.01-2.23l80.93-.09Z"
          />
          <path fill="#33522e" d="M205.46 153.54v.36l-.46-.01.46-.35Z" />
          <path
            fill="#d98e48"
            d="M217.01 167q.29.58.21 1.03-.91 5.15-5.02 27.94-2.82 15.61-5.25 20.15c-5.85 10.9-17.61 19-30.69 18.92q-30.24-.17-118.74-.04-2.34 0-7.05-1.68-19.62-7.01-23.83-27.55-1.63-7.92-7.05-39.03l197.42.26ZM68.99 181.84a2.69 2.69 0 0 0-2.7-2.681l-18.08.063a2.69 2.69 0 0 0-2.68 2.699v.16a2.69 2.69 0 0 0 2.7 2.68l18.08-.063A2.69 2.69 0 0 0 68.99 182v-.16Zm42.51.03a2.69 2.69 0 0 0-2.695-2.686l-18.28.032a2.69 2.69 0 0 0-2.685 2.695v.16a2.69 2.69 0 0 0 2.695 2.685l18.28-.032a2.69 2.69 0 0 0 2.685-2.695v-.16Zm42.54.051a2.68 2.68 0 0 0-2.675-2.685l-18.68-.032a2.68 2.68 0 0 0-2.685 2.675v.16a2.68 2.68 0 0 0 2.675 2.685l18.68.032a2.68 2.68 0 0 0 2.685-2.675v-.16Zm41.36-.06a2.68 2.68 0 0 0-2.69-2.671l-17.26.06a2.68 2.68 0 0 0-2.67 2.69v.18a2.68 2.68 0 0 0 2.69 2.67l17.26-.06a2.68 2.68 0 0 0 2.67-2.69v-.18ZM89.36 199.532a2.86 2.86 0 0 0-2.85-2.87l-19.04-.066a2.86 2.86 0 0 0-2.87 2.85v.18a2.86 2.86 0 0 0 2.85 2.87l19.04.066a2.86 2.86 0 0 0 2.87-2.85v-.18Zm43.55-.043a2.87 2.87 0 0 0-2.87-2.87H110.7a2.87 2.87 0 0 0-2.87 2.87v.18a2.87 2.87 0 0 0 2.87 2.87h19.34a2.87 2.87 0 0 0 2.87-2.87v-.18Zm43.52.022a2.85 2.85 0 0 0-2.845-2.855l-19.32-.034a2.85 2.85 0 0 0-2.855 2.845v.16a2.85 2.85 0 0 0 2.845 2.855l19.32.034a2.85 2.85 0 0 0 2.855-2.845v-.16ZM72.76 216.78a2.66 2.66 0 0 0-2.66-2.66H52.22a2.66 2.66 0 0 0-2.66 2.66v.16a2.66 2.66 0 0 0 2.66 2.66H70.1a2.66 2.66 0 0 0 2.66-2.66v-.16Zm38.54-.01a2.65 2.65 0 0 0-2.65-2.65h-19a2.65 2.65 0 0 0-2.65 2.65v.14a2.65 2.65 0 0 0 2.65 2.65h19a2.65 2.65 0 0 0 2.65-2.65v-.14Zm42.65-.001a2.66 2.66 0 0 0-2.665-2.655l-18.76.032a2.66 2.66 0 0 0-2.655 2.665v.16a2.66 2.66 0 0 0 2.665 2.655l18.76-.032a2.66 2.66 0 0 0 2.655-2.665v-.16Zm35.84.03a2.68 2.68 0 0 0-2.675-2.684l-16.96-.03a2.68 2.68 0 0 0-2.685 2.675v.16a2.68 2.68 0 0 0 2.675 2.685l16.96.03a2.68 2.68 0 0 0 2.685-2.675v-.16Z"
          />
          <rect
            width="23.46"
            height="5.54"
            x="-11.73"
            y="-2.77"
            fill="#ca7833"
            rx="2.69"
            transform="rotate(-.2 52156.277 -16312.785)"
          />
          <rect
            width="23.66"
            height="5.54"
            x="-11.83"
            y="-2.77"
            fill="#ca7833"
            rx="2.69"
            transform="rotate(-.1 104310.939 -57015.704)"
          />
          <rect
            width="24.04"
            height="5.52"
            x="-12.02"
            y="-2.76"
            fill="#ca7833"
            rx="2.68"
            transform="rotate(.1 -104195.823 81462.435)"
          />
          <rect
            width="22.62"
            height="5.54"
            x="-11.31"
            y="-2.77"
            fill="#ca7833"
            rx="2.68"
            transform="rotate(-.2 52228.287 -52646.852)"
          />
          <rect
            width="24.76"
            height="5.9"
            x="-12.38"
            y="-2.95"
            fill="#ca7833"
            rx="2.86"
            transform="rotate(.2 -57136.91 22152.913)"
          />
          <rect width="25.08" height="5.92" x="107.83" y="196.62" fill="#ca7833" rx="2.87" />
          <rect
            width="25.02"
            height="5.86"
            x="-12.51"
            y="-2.93"
            fill="#ca7833"
            rx="2.85"
            transform="rotate(.1 -114263.198 94019.003)"
          />
          <rect width="23.2" height="5.48" x="49.56" y="214.12" fill="#ca7833" rx="2.66" />
          <rect width="24.3" height="5.44" x="87" y="214.12" fill="#ca7833" rx="2.65" />
          <rect
            width="24.08"
            height="5.48"
            x="-12.04"
            y="-2.74"
            fill="#ca7833"
            rx="2.66"
            transform="rotate(-.1 124328.28 -81199.985)"
          />
          <rect
            width="22.32"
            height="5.52"
            x="-11.16"
            y="-2.76"
            fill="#ca7833"
            rx="2.68"
            transform="rotate(.1 -124162.28 102455.855)"
          />
        </svg>
      );
    case HOME_DECOR:
      return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <g fill="none" stroke-width="2">
            <path
              stroke="#cc7d18"
              d="m124.62 70.02-.21-9.36a4.35 4.15 89.1 0 0-4.18-4.25H120a4.35 4.12-89.9 0 0-4.09 4.31l-.09 9.39"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#cc7222"
              d="m124.45 74.98.11 6.73a4.31 4.25 89.3 0 1-4.22 4.38h-.1a4.28 4.24-89.9 0 1-4.27-4.32l.06-6.85"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ffa038"
              d="M182.65 81.64q-5.49 2.61-14.85 5.14-19.31 5.22-36.27 5.74-19.26.59-38.38-1.99-16.93-2.28-32.6-10.22"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#fa9b37"
              d="M182.4 107.49c-4.2 1.57-6.97.21-10.68-1.98-6.17-3.64-11.85-3.3-16.13 3.14-3.09 4.65-4.56 10.88-12.2 11.6-5.74.54-10-6.6-15.46-8.03-9.74-2.55-11.35 6.41-13.36 13.33-2.28 7.81-9.97 8.66-16.92 7.01-7.97-1.89-8.35-9.16-9.39-16.46q-.23-1.62-2.35-5a1.32 1.29 73.3 0 0-1.1-.61h-3.68a1.27 1.25-74.3 0 0-1.08.62c-4.73 7.92-14 11.12-23.01 7.97"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#dd7b27"
              d="M182.14 132.5v1.22M181.97 146.82l-.02 5.26"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#c76d21" d="m181.95 152.08-.2 9.67" vector-effect="non-scaling-stroke" />
            <path
              stroke="#dd7b27"
              d="M181.75 161.75q-.51.66-1.75.78-60.8 5.48-121.53-.22"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#c76d21" d="m58.47 162.31.02-10.03" vector-effect="non-scaling-stroke" />
            <path
              stroke="#dd7b27"
              d="m58.49 152.28.06-5.48M58.41 139.02q.69-2.32-.33-2.53"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#b05818"
              d="M58.49 152.28c-5.84.79-13.43 1.19-18.44 4.06a1.25 1.24 49.6 0 0-.16 2.05q1.17.94 2.99 1.49 7.68 2.33 15.59 2.43M181.75 161.75q.61.82 2.01.59c7.38-1.23 11.76-1.31 16.36-3.8a1.35 1.34 56.3 0 0 .4-2.04q-.55-.69-2.1-1.1-8-2.15-16.47-3.32"
              vector-effect="non-scaling-stroke"
            />
          </g>
          <path
            fill="#ffb01d"
            d="m124.62 70.02-.21-9.36a4.35 4.15 89.1 0 0-4.18-4.25H120a4.35 4.12-89.9 0 0-4.09 4.31l-.09 9.39q-2.55-1.08-9.87-3.48-6.8-2.22-11.21-8.26c-5.52-7.54-3.75-16.52.53-24.32q8.45-15.44 22.09-27.25a2.37 2.27-70.9 0 1 .97-.5q1.53-.36 3.22.01a1.89 1.84-18 0 1 .83.41q14.18 12.01 22.9 27.99c4.25 7.78 5.61 17.1-.54 24.44q-4.47 5.34-9.54 7.02-5.39 1.77-10.58 3.85Z"
          />
          <path
            fill="#994a12"
            d="M124.62 70.02q-.65 2.71-.17 4.96l.11 6.73a4.31 4.25 89.3 0 1-4.22 4.38h-.1a4.28 4.24-89.9 0 1-4.27-4.32l.06-6.85q.45-2.09-.21-4.81l.09-9.39a4.35 4.12-89.9 0 1 4.09-4.31h.23a4.35 4.15 89.1 0 1 4.18 4.25l.21 9.36Z"
          />
          <path
            fill="#fe9a32"
            d="m116.03 74.92-.06 6.85a4.28 4.24-89.9 0 0 4.27 4.32h.1a4.31 4.25 89.3 0 0 4.22-4.38l-.11-6.73q21.81.03 45.55 2.78 7.02.81 12.65 3.88-5.49 2.61-14.85 5.14-19.31 5.22-36.27 5.74-19.26.59-38.38-1.99-16.93-2.28-32.6-10.22 7.36-2.7 15.7-3.36 23.29-1.82 39.78-2.03Z"
          />
          <path
            fill="#ffa53e"
            d="M60.55 80.31q15.67 7.94 32.6 10.22 19.12 2.58 38.38 1.99 16.96-.52 36.27-5.74 9.36-2.53 14.85-5.14 2.31 2.3 2.54 5.62.29 4.12.06 13.73-.1 4.41-2.85 6.5c-4.2 1.57-6.97.21-10.68-1.98-6.17-3.64-11.85-3.3-16.13 3.14-3.09 4.65-4.56 10.88-12.2 11.6-5.74.54-10-6.6-15.46-8.03-9.74-2.55-11.35 6.41-13.36 13.33-2.28 7.81-9.97 8.66-16.92 7.01-7.97-1.89-8.35-9.16-9.39-16.46q-.23-1.62-2.35-5a1.32 1.29 73.3 0 0-1.1-.61h-3.68a1.27 1.25-74.3 0 0-1.08.62c-4.73 7.92-14 11.12-23.01 7.97q-3.36-15.75-1.79-31.82.58-5.96 5.3-6.95Z"
          />
          <path
            fill="#f49030"
            d="m182.4 107.49-.26 25.01v1.22l-.17 13.1-.02 5.26-.2 9.67q-.51.66-1.75.78-60.8 5.48-121.53-.22l.02-10.03.06-5.48-.14-7.78q.69-2.32-.33-2.53 1.25-9.25-1.04-17.41c9.01 3.15 18.28-.05 23.01-7.97a1.27 1.25-74.3 0 1 1.08-.62h3.68a1.32 1.29 73.3 0 1 1.1.61q2.12 3.38 2.35 5c1.04 7.3 1.42 14.57 9.39 16.46 6.95 1.65 14.64.8 16.92-7.01 2.01-6.92 3.62-15.88 13.36-13.33 5.46 1.43 9.72 8.57 15.46 8.03 7.64-.72 9.11-6.95 12.2-11.6 4.28-6.44 9.96-6.78 16.13-3.14 3.71 2.19 6.48 3.55 10.68 1.98Z"
          />
          <path
            fill="#c6661e"
            d="M182.14 132.5v1.22-1.22ZM58.41 139.02q.12-1.55-.33-2.53 1.02.21.33 2.53ZM58.55 146.8l-.06 5.48c-5.84.79-13.43 1.19-18.44 4.06a1.25 1.24 49.6 0 0-.16 2.05q1.17.94 2.99 1.49 7.68 2.33 15.59 2.43 60.73 5.7 121.53.22 1.24-.12 1.75-.78.61.82 2.01.59c7.38-1.23 11.76-1.31 16.36-3.8a1.35 1.34 56.3 0 0 .4-2.04q-.55-.69-2.1-1.1-8-2.15-16.47-3.32l.02-5.26c5.82.35 29.5 2.18 29.74 10.67.49 17.03.06 31.05-3.26 47.23q-2.59 12.63-13.38 19.89c-10.52 7.07-21.47 7.82-35.48 8.48q-32.18 1.5-75.02.24-12.1-.36-21.28-1.69c-11.8-1.71-23.86-8.56-29.08-19.75q-2.44-5.22-4.33-18.03-2.01-13.64-1.7-29.47c.13-6.5-.51-9.94 4.98-12.5 7.73-3.61 16.96-4.53 25.39-5.09Z"
          />
          <path
            fill="#994a12"
            d="m181.75 161.75.2-9.67q8.47 1.17 16.47 3.32 1.55.41 2.1 1.1a1.35 1.34 56.3 0 1-.4 2.04c-4.6 2.49-8.98 2.57-16.36 3.8q-1.4.23-2.01-.59ZM58.49 152.28l-.02 10.03q-7.91-.1-15.59-2.43-1.82-.55-2.99-1.49a1.25 1.24 49.6 0 1 .16-2.05c5.01-2.87 12.6-3.27 18.44-4.06Z"
          />
        </svg>
      );
    case TABLEWARE:
      return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <g fill="none" stroke-width="2">
            <path
              stroke="#999080"
              d="M16.86 33.99q5.42.45 11.24 2.44 10.04 3.44 17.38 5.08c18.57 4.15 35.74.85 54.6-6.38q1.37-.53 3.49-1.81a.47.47 0 0 0-.03-.82c-4.23-2.14-10.64-1.51-15.29-.49q-9.11 2.02-15.3 2.63c-17.76 1.76-37.94-8.6-56.16-1.12a.25.24-53.7 0 0 .07.47"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#999080"
              d="M101.58 38.94c-20.8 8.31-42.65 11.38-64.39 4.56-7.15-2.25-14.63-4.88-21.53-5.67a.26.26 0 0 0-.22.44c7.98 8.5 11.62 18.78 7.81 30.56q-2.3 7.13-7.4 17.48-5.56 11.31-7.71 26.77c-3.04 21.95 5.15 42.95 21.77 57.77C41.88 181.53 60.9 182.9 76 180.04a.24.24 0 0 0 .19-.29q-1.81-7.52-2.45-13.98-.71-7.2 4.19-11.59c7.65-6.85 20.53-10.18 30.65-11.47a1.57 1.56-86.1 0 0 1.32-1.16q2.11-8.01 2.71-16.44c.88-12.38-2.07-25.47-6.38-37.11q-4.94-13.33-6.42-19.05-3.87-15.01 2.2-29.58a.33.33 0 0 0-.43-.43"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#999080"
              d="M117.03 124.68q8.19-11.08 13.26-23.4 1.54-3.73 1.54-7.03.01-8.93-.23-24.92-.01-.58.48-2.34a1.58 1.58 0 0 0-.06-.98c-5.22-13.05-19.62-16.48-29.38-5.81a2.29 2.28-31 0 0-.53 2.1l2.24 8.87a.34.34 0 0 0 .66-.03q.99-5.72 5.84-8.54c7.09-4.14 14.03 1.43 16.36 8.21 2.8 8.16.46 19.79-2.63 27.49q-3.4 8.47-8.14 15.35a1.54 1.5-30.3 0 0-.26.94l.46 9.97a.22.21 61.8 0 0 .39.12"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#6c4936"
              d="M135.5 69.4c-.01 2.27 5.34 4.82 7.15 5.41 8.56 2.79 17.33 3.91 26.55 3.95 9.21.04 18-1 26.58-3.72 1.81-.57 7.18-3.07 7.19-5.34.01-2.26-5.34-4.81-7.14-5.4-8.56-2.79-17.33-3.91-26.55-3.95-9.22-.04-18 1-26.58 3.72-1.81.57-7.19 3.07-7.2 5.33"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#7d543f"
              d="M135.31 76.06q.01 3.76.6 33.58.31 15.65 2.77 30.46a1.19 1.19 0 0 0 1.15 1q16.69.43 32.57 4.75c7.21 1.97 15.23 5.49 19.47 11.92a.68.68 0 0 0 1.08.08q4.03-4.6 5.67-11.04c3.57-14.05 3.85-26.62 4.31-44.16q.33-12.6.56-26.78a.23.23 0 0 0-.37-.19c-5.55 4.28-13.61 5.57-20.39 6.27q-16.87 1.73-33.39-1.26-8.42-1.53-13.48-4.93a.36.35-73.2 0 0-.55.3M206.95 92.89c9.26-8.04 21.25-6.9 22.68 7.22 1.63 16.18-9.66 29.81-24.71 34.9a.37.37 0 0 0-.24.28l-1.59 7.26a.18.17-2.2 0 0 .22.2q19.09-5.83 27.26-22.2c5.15-10.34 7.06-27.91-2.9-36.25-5.95-4.97-14.59-3.46-20.61.64a.61.57 74 0 0-.25.49l-.01 7.39a.09.09 0 0 0 .15.07"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#586358"
              d="M77.25 162.21c0 4.53 7.26 8.55 11.09 10.06 14.25 5.65 29.73 7.46 45.01 7.46 15.29 0 30.77-1.8 45.02-7.45 3.83-1.52 11.08-5.54 11.08-10.07.01-4.53-7.25-8.54-11.08-10.06-14.25-5.65-29.73-7.46-45.01-7.46-15.29 0-30.77 1.81-45.02 7.46-3.83 1.51-11.09 5.53-11.09 10.06"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#8b7350"
              d="m78.03 171.96 1.61 6.38a2.47 2.46 7.6 0 0 1.19 1.55q10.11 5.65 22.16 8.39c22.52 5.12 48.46 5.05 70.37-1.66q7-2.15 12.82-6.56a3.07 3.03 77.8 0 0 1.14-1.79l1.37-6.25a.59.58 76.5 0 0-.94-.58q-3.57 2.92-7.2 4.38-12.19 4.89-27.06 6.64-27.75 3.26-52.8-2.07-13.54-2.88-21.87-8.96a.51.51 0 0 0-.79.53"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#586358"
              d="M184.13 186.03q-4.97 2.83-10.97 4.62c-21.5 6.42-46 6.42-68.4 2.09q-11.61-2.24-22.38-7.47a.35.34.8 0 0-.47.45q8.58 18.27 27.51 25.89c27.88 11.24 61.45 3.68 75.08-25.23a.27.27 0 0 0-.37-.35"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#4f564d"
              d="M133.47 223.82c9.19.11 20.02-.89 26.68-7.92a.18.18 0 0 0-.19-.29q-12.56 5-26.45 4.84-13.89-.16-26.33-5.44a.18.18 0 0 0-.2.29c6.49 7.18 17.3 8.42 26.49 8.52"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#b7bba4"
              d="M55.42 138.17q6.15-9.39 13.64-16.57a4.29 4.28 11.4 0 1 1.3-.86c4.94-2.1 9.12-4.84 12.13-9.5q7.4-11.46 7.39-25.16a.57.57 0 0 0-.84-.5q-10.35 5.48-16.46 15c-3.82 5.97-4.5 12.3-5.69 19.43a1.25 1.24-19.8 0 1-.27.57l-7.78 9a.19.19 0 0 1-.33-.19q2.36-6.35 2.94-12.64c.88-9.46-2.04-17.53-7.65-24.79a.59.59 0 0 0-1 .12c-6.17 13.66-6.52 28.77 3.64 40.36a.44.43-51.1 0 1 .05.5l-8.15 14.1a.16.16 0 0 1-.3-.1q2.82-18.47-10.69-30.63a.39.39 0 0 0-.64.18q-6.1 20.28 10.06 32.6a.75.74-61.6 0 1 .25.85l-3.93 10.89a.94.93 25.5 0 0 .41 1.13l.34.19a.71.71 0 0 0 1.04-.41q3.18-10.54 9.23-19.74a.79.78 22.1 0 1 .82-.34c14.39 3.1 30.31-3.22 38.07-16.03a.57.57 0 0 0-.3-.83c-15.48-5.37-26.55 2.87-37.06 13.55a.14.14 0 0 1-.22-.18"
              vector-effect="non-scaling-stroke"
            />
          </g>
          <path
            fill="#3a3834"
            d="M101.88 55.35a.25.25 0 0 0 .42.2c8.14-7.61 20.82-7.59 28.18 1.26q3.14 3.77 4.12 6.66a.52.52 0 0 0 .76.27c7.06-4.38 15.56-6.17 24.63-6.91q16.36-1.34 31.69 2.23c6.62 1.54 16.29 5.03 15.11 12.92q-.1.7-.14 8.26a.42.42 0 0 0 .62.37c14.47-7.69 27.84-.11 30.23 15.11q2.6 16.58-6.4 30.61-10.29 16.05-28.67 20.49a.91.91 0 0 0-.67.67q-2.06 9.06-8.57 15.01a1.19 1.16 71.5 0 0-.39.81q-.61 11.95-3.52 20.19-6.57 18.56-23.95 29.28a1.17 1.14 82.2 0 0-.51.69c-3.71 13.67-24.74 14.92-36.1 14.17-10.17-.68-23.38-3.72-26.48-14.7a1.25 1.24-83.4 0 0-.58-.74q-17.18-9.81-23.96-28.21a.32.32 0 0 0-.36-.21q-15.57 3-30.74-.53c-10.78-2.5-17.04-6.86-24.46-15.12Q7.55 151.9 4.65 130.34c-1.88-13.98 1.4-30.23 7-43.46q1.25-2.94 7.56-16.95.94-2.07 1.89-8.19c1.5-9.67-4.74-16.51-10.77-23.63a3.44 3.31 38.5 0 1-.49-3.69c2.38-4.79 12.16-6.84 17.17-7.17q9.67-.66 17.39.65c11.97 2.01 21.47 3.91 31.39 2.42q3.52-.53 14.46-2.49 5.86-1.06 11.61.05c3.76.73 8.13 2.8 5.79 7.38q-4.85 9.51-5.77 20.09ZM16.86 33.99q5.42.45 11.24 2.44 10.04 3.44 17.38 5.08c18.57 4.15 35.74.85 54.6-6.38q1.37-.53 3.49-1.81a.47.47 0 0 0-.03-.82c-4.23-2.14-10.64-1.51-15.29-.49q-9.11 2.02-15.3 2.63c-17.76 1.76-37.94-8.6-56.16-1.12a.25.24-53.7 0 0 .07.47Zm84.72 4.95c-20.8 8.31-42.65 11.38-64.39 4.56-7.15-2.25-14.63-4.88-21.53-5.67a.26.26 0 0 0-.22.44c7.98 8.5 11.62 18.78 7.81 30.56q-2.3 7.13-7.4 17.48-5.56 11.31-7.71 26.77c-3.04 21.95 5.15 42.95 21.77 57.77C41.88 181.53 60.9 182.9 76 180.04a.24.24 0 0 0 .19-.29q-1.81-7.52-2.45-13.98-.71-7.2 4.19-11.59c7.65-6.85 20.53-10.18 30.65-11.47a1.57 1.56-86.1 0 0 1.32-1.16q2.11-8.01 2.71-16.44c.88-12.38-2.07-25.47-6.38-37.11q-4.94-13.33-6.42-19.05-3.87-15.01 2.2-29.58a.33.33 0 0 0-.43-.43Zm15.45 85.74q8.19-11.08 13.26-23.4 1.54-3.73 1.54-7.03.01-8.93-.23-24.92-.01-.58.48-2.34a1.58 1.58 0 0 0-.06-.98c-5.22-13.05-19.62-16.48-29.38-5.81a2.29 2.28-31 0 0-.53 2.1l2.24 8.87a.34.34 0 0 0 .66-.03q.99-5.72 5.84-8.54c7.09-4.14 14.03 1.43 16.36 8.21 2.8 8.16.46 19.79-2.63 27.49q-3.4 8.47-8.14 15.35a1.54 1.5-30.3 0 0-.26.94l.46 9.97a.22.21 61.8 0 0 .39.12ZM135.5 69.4c-.01 2.27 5.34 4.82 7.15 5.41 8.56 2.79 17.33 3.91 26.55 3.95 9.21.04 18-1 26.58-3.72 1.81-.57 7.18-3.07 7.19-5.34.01-2.26-5.34-4.81-7.14-5.4-8.56-2.79-17.33-3.91-26.55-3.95-9.22-.04-18 1-26.58 3.72-1.81.57-7.19 3.07-7.2 5.33Zm-19.66 39c5.91-9.57 10.39-21.88 8.94-33.12q-.72-5.64-4.31-8.47-4.07-3.21-8.12-.83c-6.18 3.63-5.15 14.64-2.97 20.5q4 10.73 5.98 21.83a.26.26 0 0 0 .48.09Zm19.47-32.34q.01 3.76.6 33.58.31 15.65 2.77 30.46a1.19 1.19 0 0 0 1.15 1q16.69.43 32.57 4.75c7.21 1.97 15.23 5.49 19.47 11.92a.68.68 0 0 0 1.08.08q4.03-4.6 5.67-11.04c3.57-14.05 3.85-26.62 4.31-44.16q.33-12.6.56-26.78a.23.23 0 0 0-.37-.19c-5.55 4.28-13.61 5.57-20.39 6.27q-16.87 1.73-33.39-1.26-8.42-1.53-13.48-4.93a.36.35-73.2 0 0-.55.3Zm71.64 16.83c9.26-8.04 21.25-6.9 22.68 7.22 1.63 16.18-9.66 29.81-24.71 34.9a.37.37 0 0 0-.24.28l-1.59 7.26a.18.17-2.2 0 0 .22.2q19.09-5.83 27.26-22.2c5.15-10.34 7.06-27.91-2.9-36.25-5.95-4.97-14.59-3.46-20.61.64a.61.57 74 0 0-.25.49l-.01 7.39a.09.09 0 0 0 .15.07Zm-1.51 38.23c11.24-4.43 19.69-14.46 20.71-26.63.52-6.28-1.66-15.12-10.27-12.56q-5.47 1.63-9.06 5.83a1.09 1.08 67 0 0-.26.65l-1.39 32.52a.2.19-8.9 0 0 .27.19Zm-73.41-25.59q-6.15 14.69-16.34 26.59a1.73 1.7-19.2 0 0-.37.75l-1.87 8.54a.27.27 0 0 0 .28.32l21.17-.98a.41.41 0 0 0 .39-.47q-2.92-17.29-2.78-34.65a.25.25 0 0 0-.48-.1Zm-54.78 56.68c0 4.53 7.26 8.55 11.09 10.06 14.25 5.65 29.73 7.46 45.01 7.46 15.29 0 30.77-1.8 45.02-7.45 3.83-1.52 11.08-5.54 11.08-10.07.01-4.53-7.25-8.54-11.08-10.06-14.25-5.65-29.73-7.46-45.01-7.46-15.29 0-30.77 1.81-45.02 7.46-3.83 1.51-11.09 5.53-11.09 10.06Zm.78 9.75 1.61 6.38a2.47 2.46 7.6 0 0 1.19 1.55q10.11 5.65 22.16 8.39c22.52 5.12 48.46 5.05 70.37-1.66q7-2.15 12.82-6.56a3.07 3.03 77.8 0 0 1.14-1.79l1.37-6.25a.59.58 76.5 0 0-.94-.58q-3.57 2.92-7.2 4.38-12.19 4.89-27.06 6.64-27.75 3.26-52.8-2.07-13.54-2.88-21.87-8.96a.51.51 0 0 0-.79.53Zm106.1 14.07q-4.97 2.83-10.97 4.62c-21.5 6.42-46 6.42-68.4 2.09q-11.61-2.24-22.38-7.47a.35.34.8 0 0-.47.45q8.58 18.27 27.51 25.89c27.88 11.24 61.45 3.68 75.08-25.23a.27.27 0 0 0-.37-.35Zm-50.66 37.79c9.19.11 20.02-.89 26.68-7.92a.18.18 0 0 0-.19-.29q-12.56 5-26.45 4.84-13.89-.16-26.33-5.44a.18.18 0 0 0-.2.29c6.49 7.18 17.3 8.42 26.49 8.52Z"
          />
          <path
            fill="#f8e8cb"
            d="M16.86 33.99a.25.24-53.7 0 1-.07-.47c18.22-7.48 38.4 2.88 56.16 1.12q6.19-.61 15.3-2.63c4.65-1.02 11.06-1.65 15.29.49a.47.47 0 0 1 .03.82q-2.12 1.28-3.49 1.81c-18.86 7.23-36.03 10.53-54.6 6.38q-7.34-1.64-17.38-5.08-5.82-1.99-11.24-2.44Z"
          />
          <path
            fill="#f8e8cb"
            d="M101.58 38.94a.33.33 0 0 1 .43.43q-6.07 14.57-2.2 29.58 1.48 5.72 6.42 19.05c4.31 11.64 7.26 24.73 6.38 37.11q-.6 8.43-2.71 16.44a1.57 1.56-86.1 0 1-1.32 1.16c-10.12 1.29-23 4.62-30.65 11.47q-4.9 4.39-4.19 11.59.64 6.46 2.45 13.98a.24.24 0 0 1-.19.29c-15.1 2.86-34.12 1.49-46.09-9.19-16.62-14.82-24.81-35.82-21.77-57.77q2.15-15.46 7.71-26.77 5.1-10.35 7.4-17.48c3.81-11.78.17-22.06-7.81-30.56a.26.26 0 0 1 .22-.44c6.9.79 14.38 3.42 21.53 5.67 21.74 6.82 43.59 3.75 64.39-4.56Zm-46.16 99.23q6.15-9.39 13.64-16.57a4.29 4.28 11.4 0 1 1.3-.86c4.94-2.1 9.12-4.84 12.13-9.5q7.4-11.46 7.39-25.16a.57.57 0 0 0-.84-.5q-10.35 5.48-16.46 15c-3.82 5.97-4.5 12.3-5.69 19.43a1.25 1.24-19.8 0 1-.27.57l-7.78 9a.19.19 0 0 1-.33-.19q2.36-6.35 2.94-12.64c.88-9.46-2.04-17.53-7.65-24.79a.59.59 0 0 0-1 .12c-6.17 13.66-6.52 28.77 3.64 40.36a.44.43-51.1 0 1 .05.5l-8.15 14.1a.16.16 0 0 1-.3-.1q2.82-18.47-10.69-30.63a.39.39 0 0 0-.64.18q-6.1 20.28 10.06 32.6a.75.74-61.6 0 1 .25.85l-3.93 10.89a.94.93 25.5 0 0 .41 1.13l.34.19a.71.71 0 0 0 1.04-.41q3.18-10.54 9.23-19.74a.79.78 22.1 0 1 .82-.34c14.39 3.1 30.31-3.22 38.07-16.03a.57.57 0 0 0-.3-.83c-15.48-5.37-26.55 2.87-37.06 13.55a.14.14 0 0 1-.22-.18Z"
          />
          <path
            fill="#f8e8cb"
            d="m116.64 124.56-.46-9.97a1.54 1.5-30.3 0 1 .26-.94q4.74-6.88 8.14-15.35c3.09-7.7 5.43-19.33 2.63-27.49-2.33-6.78-9.27-12.35-16.36-8.21q-4.85 2.82-5.84 8.54a.34.34 0 0 1-.66.03l-2.24-8.87a2.29 2.28-31 0 1 .53-2.1c9.76-10.67 24.16-7.24 29.38 5.81a1.58 1.58 0 0 1 .06.98q-.49 1.76-.48 2.34.24 15.99.23 24.92 0 3.3-1.54 7.03-5.07 12.32-13.26 23.4a.22.21 61.8 0 1-.39-.12Z"
          />
          <path
            fill="#9e5a38"
            d="M169.28 60.35c9.22.04 17.99 1.16 26.55 3.95 1.8.59 7.15 3.14 7.14 5.4-.01 2.27-5.38 4.77-7.19 5.34-8.58 2.72-17.37 3.76-26.58 3.72-9.22-.04-17.99-1.16-26.55-3.95-1.81-.59-7.16-3.14-7.15-5.41.01-2.26 5.39-4.76 7.2-5.33 8.58-2.72 17.36-3.76 26.58-3.72Z"
          />
          <path
            fill="#bf6f4a"
            d="M135.86 75.76q5.06 3.4 13.48 4.93 16.52 2.99 33.39 1.26c6.78-.7 14.84-1.99 20.39-6.27a.23.23 0 0 1 .37.19q-.23 14.18-.56 26.78c-.46 17.54-.74 30.11-4.31 44.16q-1.64 6.44-5.67 11.04a.68.68 0 0 1-1.08-.08c-4.24-6.43-12.26-9.95-19.47-11.92q-15.88-4.32-32.57-4.75a1.19 1.19 0 0 1-1.15-1q-2.46-14.81-2.77-30.46-.59-29.82-.6-33.58a.36.35-73.2 0 1 .55-.3ZM206.95 92.89a.09.09 0 0 1-.15-.07l.01-7.39a.61.57 74 0 1 .25-.49c6.02-4.1 14.66-5.61 20.61-.64 9.96 8.34 8.05 25.91 2.9 36.25q-8.17 16.37-27.26 22.2a.18.17-2.2 0 1-.22-.2l1.59-7.26a.37.37 0 0 1 .24-.28c15.05-5.09 26.34-18.72 24.71-34.9-1.43-14.12-13.42-15.26-22.68-7.22Z"
          />
          <path
            fill="#768e7c"
            d="M55.64 138.35c10.51-10.68 21.58-18.92 37.06-13.55a.57.57 0 0 1 .3.83c-7.76 12.81-23.68 19.13-38.07 16.03a.79.78 22.1 0 0-.82.34q-6.05 9.2-9.23 19.74a.71.71 0 0 1-1.04.41l-.34-.19a.94.93 25.5 0 1-.41-1.13l3.93-10.89a.75.74-61.6 0 0-.25-.85q-16.16-12.32-10.06-32.6a.39.39 0 0 1 .64-.18q13.51 12.16 10.69 30.63a.16.16 0 0 0 .3.1l8.15-14.1a.44.43-51.1 0 0-.05-.5c-10.16-11.59-9.81-26.7-3.64-40.36a.59.59 0 0 1 1-.12c5.61 7.26 8.53 15.33 7.65 24.79q-.58 6.29-2.94 12.64a.19.19 0 0 0 .33.19l7.78-9a1.25 1.24-19.8 0 0 .27-.57c1.19-7.13 1.87-13.46 5.69-19.43q6.11-9.52 16.46-15a.57.57 0 0 1 .84.5q.01 13.7-7.39 25.16c-3.01 4.66-7.19 7.4-12.13 9.5a4.29 4.28 11.4 0 0-1.3.86q-7.49 7.18-13.64 16.57a.14.14 0 0 0 .22.18ZM133.36 144.69c15.28 0 30.76 1.81 45.01 7.46 3.83 1.52 11.09 5.53 11.08 10.06 0 4.53-7.25 8.55-11.08 10.07-14.25 5.65-29.73 7.45-45.02 7.45-15.28 0-30.76-1.81-45.01-7.46-3.83-1.51-11.09-5.53-11.09-10.06s7.26-8.55 11.09-10.06c14.25-5.65 29.73-7.46 45.02-7.46Z"
          />
          <path
            fill="#dcae6c"
            d="M78.82 171.43q8.33 6.08 21.87 8.96 25.05 5.33 52.8 2.07 14.87-1.75 27.06-6.64 3.63-1.46 7.2-4.38a.59.58 76.5 0 1 .94.58l-1.37 6.25a3.07 3.03 77.8 0 1-1.14 1.79q-5.82 4.41-12.82 6.56c-21.91 6.71-47.85 6.78-70.37 1.66q-12.05-2.74-22.16-8.39a2.47 2.46 7.6 0 1-1.19-1.55l-1.61-6.38a.51.51 0 0 1 .79-.53Z"
          />
          <path
            fill="#768e7c"
            d="M184.13 186.03a.27.27 0 0 1 .37.35c-13.63 28.91-47.2 36.47-75.08 25.23q-18.93-7.62-27.51-25.89a.35.34.8 0 1 .47-.45q10.77 5.23 22.38 7.47c22.4 4.33 46.9 4.33 68.4-2.09q6-1.79 10.97-4.62Z"
          />
          <path
            fill="#637466"
            d="M133.51 220.45q13.89.16 26.45-4.84a.18.18 0 0 1 .19.29c-6.66 7.03-17.49 8.03-26.68 7.92-9.19-.1-20-1.34-26.49-8.52a.18.18 0 0 1 .2-.29q12.44 5.28 26.33 5.44Z"
          />
        </svg>
      );
    case CUSTOM_GIFTS:
      return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
          <g fill="none" stroke-width="2">
            <path
              stroke="#e29132"
              d="M233.21 131.74q-1.37 2.63-2.82 2.92c-9.34 1.86-16.22 2.91-22.76 4.65-4.25 1.13-9.07 1.71-12.96 2.53q-30.73 6.43-58.44 11.71c-9.03 1.71-21.02 4.37-32.51 6.51-3.75.7-7.53 1.83-11.36 2.35q-3.25.43-8.57 1.53-9.25 1.91-21.39 3.88-2.07.34-4.61.68"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#dc8b2e"
              d="M57.79 168.5q-4.49-7.22-8.24-14.79l-6-12.11Q23.86 103.61 4.91 64.23"
              vector-effect="non-scaling-stroke"
            />
            <path stroke="#d18025" d="m57.79 168.5-.25 23.49" vector-effect="non-scaling-stroke" />
            <path
              stroke="#c4741d"
              d="M57.54 191.99q-3.09-2.83-4.7-6.06c-3.9-7.83-7.74-14.32-10.71-20.58q-4.49-9.46-12.43-24.39c-1.97-3.71-3.85-7.93-6.27-12.34-4.89-8.88-10.05-19.5-14.09-26.75a2.28 2.05-66.7 0 1-.25-.74l-.55-3.74a2.33 1.94-66.3 0 0-.12-.42L5.18 89.5a.6.6 0 0 0-1.1 0q-.13.32-.09 1.43"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#ca7a21"
              d="M57.54 191.99q1 1.42 2.62 1.11 20.27-3.95 27.49-5.57c3.86-.87 7.25-.95 11.42-2.02q1.65-.43 7.34-1.48 2.57-.48 17.78-3.53c3.14-.62 6.3-1.68 9.41-1.91q2.23-.17 7.08-1.3 8.78-2.03 24.03-4.64c2.04-.35 4.69-1.53 6.31-1.66q3.36-.25 14.28-2.61 6.45-1.39 18.45-3.59c4.75-.87 9.03-2.3 13.69-2.83q2.52-.28 6.09-1.22 2.98-.79 6.01-1.58"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#c4741d"
              d="M229.24 165.21q-3.26.05-4.12.21c-15.5 2.85-32.91 6.53-46.4 9.09q-22.3 4.24-45.76 8.96-5.87 1.19-24.18 4.7-37.31 7.15-42.94 8.08-3.99.67-6.66.6a.51.51 0 0 0-.52.52c.12 4.16.28 10.81-.06 16.15-.35 5.4-.95 10.08.69 13.85a.9.9 0 0 0 .81.54l4.68.04"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#d4852a"
              d="M200.88 124.29a.85.85 0 0 0 .63-1.06c-.75-2.71-1.95-5.55.98-7.21q.36-.2 2.15-1.34a1.59 1.59 0 0 0 .53-2.12l-33.28-59.13a2.9 2.89-14.9 0 0-2.56-1.48q-2.16.03-4.71-1.28c-1.46-.75-2.67-3.15-3.59-4.3a1.45 1.45 0 0 0-1.41-.51L35.02 70.87a.87.87 0 0 0-.6 1.25l1.14 2.26a3.32 3.31-28.2 0 1-1.33 4.39l-2.84 1.6a1.89 1.89 0 0 0-.76 2.51l30.49 60.02a1.46 1.46 0 0 0 1.41.8q7.05-.45 11.14 4.81a1.69 1.65-12.3 0 0 .97.61q1.93.41 3.54.08 22.34-4.62 27.08-5.31 1.1-.16 7.12-1.59c6.63-1.58 11.08-1.98 18.55-3.73q3.63-.85 11.38-2.19 8.35-1.45 13.81-2.54 20.78-4.16 44.76-9.55"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#d4852a"
              d="M201.16 112.7a.56.55 59.4 0 0 .19-.75q-14.3-25.26-30.18-53.62c-.7-1.25-1.43-2.98-2.93-3.15q-5.49-.64-8.53-5.17a1.55 1.54-22.5 0 0-1.58-.65L39.54 73.16a.85.85 0 0 0-.68.83q0 .57.19 1.64c.55 3.04-1.93 4.87-4.09 6.84a1.15 1.15 0 0 0-.24 1.37l28.44 55.98a1.04 1.04 0 0 0 .78.57l5.75.93a2.65 2.59 67.4 0 1 1.18.5l4.85 3.69a1.77 1.77 0 0 0 1.17.35c4.28-.31 7.9-1.25 11.97-2.06q43.39-8.7 43.82-8.76c2.94-.44 5.77-1.5 8.05-1.78q3.37-.41 6.09-1.02 11.74-2.61 26.51-5.37c3.62-.67 6.27-1.65 9.4-2.01 4.87-.56 8.01-1.56 14.14-3.07a.64.63 76.3 0 0 .46-.77q-1.26-5.16 3.83-8.32"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#d4852a"
              d="M112.97 83.05a.62.62 0 0 1-.93.24c-7.15-5.35-14.14-9.38-23.3-8.04q-9.46 1.39-12.52 9.28-1.77 4.57-.18 9.03c2.87 8.06 9.87 13.27 17.44 17.47q6.95 3.86 15.62 7.35 13.16 5.3 14.94 5.81 1.97.57 3.9.77a2.83 2.82 22.5 0 0 2.51-1.03c6.74-8.36 13.5-18.32 17.12-28.4 2.19-6.1 3.25-11.23 1.27-17.38-3.76-11.65-18.45-14.51-27.54-7.26-4.11 3.28-6.25 7.56-8.33 12.16"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#d4852a"
              d="M113.61 88.28q-.94-.24-1.4-.66c-3.68-3.33-10.27-7.98-15.7-8.88-3.03-.51-9.33-.63-12.4 1.52-7.31 5.09-6.37 12.55-.99 18.61q4.59 5.17 10.77 8.5 15.46 8.33 32.95 14.02a1.34 1.33 28.4 0 0 1.43-.42c7.13-8.75 13.73-18.92 16.9-29.78 1.49-5.11 1.66-12.77-2.37-16.67q-3.51-3.41-7.3-3.95-9.42-1.35-15.13 6.34-3.56 4.8-5.52 10.69a1.05 1.04 16 0 1-1.24.68"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#d18025"
              d="m134.1 165.83.18.83a.22.22 0 0 0 .27.16l6.13-1.35a11.8.52-12.4 0 0 11.41-3.04l-.05-.23a11.8.52-12.4 0 0-11.64 2.02l-6.13 1.35a.22.22 0 0 0-.17.26"
              vector-effect="non-scaling-stroke"
            />
            <path
              stroke="#c4741d"
              d="M167.67 186.58q11.57-1.19 25.64-4.2c4.86-1.04 9.45-1.87 14.03-3.8a.38.38 0 0 0-.23-.73q-14.11 3.12-30.73 6.02-4.63.81-8.76 2.55a.09.08 29.5 0 0 .05.16M102.75 199.31q10.76-2.06 21.41-4.15 5.38-1.05 10.98-3.29a.37.36-60.5 0 0-.19-.7q-12.96 2.25-24.11 4.93-4.11.99-8.31 2.55a.21.21 0 0 0-.11.3l.16.27a.16.16 0 0 0 .17.09M136.01 203.07c7.28-.68 14.52-2.33 20.76-3.32q4.62-.73 9.47-2.79a.45.44-20.6 0 0 .25-.55l-.04-.11a.4.38-15.6 0 0-.46-.25q-12.14 2.81-24.45 4.78-3.53.57-5.71 1.55a.36.36 0 0 0 .18.69"
              vector-effect="non-scaling-stroke"
            />
          </g>
          <path
            fill="#ec9c3b"
            d="M233.21 131.74q-1.37 2.63-2.82 2.92c-9.34 1.86-16.22 2.91-22.76 4.65-4.25 1.13-9.07 1.71-12.96 2.53q-30.73 6.43-58.44 11.71c-9.03 1.71-21.02 4.37-32.51 6.51-3.75.7-7.53 1.83-11.36 2.35q-3.25.43-8.57 1.53-9.25 1.91-21.39 3.88-2.07.34-4.61.68-4.49-7.22-8.24-14.79l-6-12.11Q23.86 103.61 4.91 64.23q1.16-.36 2.09-1.21a2.29 2.25 17.3 0 1 1.05-.54c4.86-1.05 9.57-2.44 14.65-3.37q12.45-2.28 19.67-4.02c5.16-1.25 8.83-1.46 14.96-2.84 6.75-1.53 17.38-3.2 27.98-5.87 2.51-.63 4.74-.72 7.82-1.4q22.7-5.02 41.81-8.33c1.64-.28 3.06-.85 4.46-1.1q18.38-3.29 29.1-5.75 2.59-.6 4.63.13a1.8 1.73 79.8 0 1 .8.58c1.29 1.64 2.84 3.13 4.1 5.28q14.34 24.42 29.87 51.81 13.31 23.47 24.88 42.85.48.8.43 1.29m-32.33-7.45a.85.85 0 0 0 .63-1.06c-.75-2.71-1.95-5.55.98-7.21q.36-.2 2.15-1.34a1.59 1.59 0 0 0 .53-2.12l-33.28-59.13a2.9 2.89-14.9 0 0-2.56-1.48q-2.16.03-4.71-1.28c-1.46-.75-2.67-3.15-3.59-4.3a1.45 1.45 0 0 0-1.41-.51L35.02 70.87a.87.87 0 0 0-.6 1.25l1.14 2.26a3.32 3.31-28.2 0 1-1.33 4.39l-2.84 1.6a1.89 1.89 0 0 0-.76 2.51l30.49 60.02a1.46 1.46 0 0 0 1.41.8q7.05-.45 11.14 4.81a1.69 1.65-12.3 0 0 .97.61q1.93.41 3.54.08 22.34-4.62 27.08-5.31 1.1-.16 7.12-1.59c6.63-1.58 11.08-1.98 18.55-3.73q3.63-.85 11.38-2.19 8.35-1.45 13.81-2.54 20.78-4.16 44.76-9.55"
          />
          <path
            fill="#bc6e19"
            d="M200.88 124.29q-23.98 5.39-44.76 9.55-5.46 1.09-13.81 2.54-7.75 1.34-11.38 2.19c-7.47 1.75-11.92 2.15-18.55 3.73q-6.02 1.43-7.12 1.59-4.74.69-27.08 5.31-1.61.33-3.54-.08a1.69 1.65-12.3 0 1-.97-.61q-4.09-5.26-11.14-4.81a1.46 1.46 0 0 1-1.41-.8L30.63 82.88a1.89 1.89 0 0 1 .76-2.51l2.84-1.6a3.32 3.31-28.2 0 0 1.33-4.39l-1.14-2.26a.87.87 0 0 1 .6-1.25l124.6-25.01a1.45 1.45 0 0 1 1.41.51c.92 1.15 2.13 3.55 3.59 4.3q2.55 1.31 4.71 1.28a2.9 2.89-14.9 0 1 2.56 1.48l33.28 59.13a1.59 1.59 0 0 1-.53 2.12q-1.79 1.14-2.15 1.34c-2.93 1.66-1.73 4.5-.98 7.21a.85.85 0 0 1-.63 1.06m.28-11.59a.56.55 59.4 0 0 .19-.75q-14.3-25.26-30.18-53.62c-.7-1.25-1.43-2.98-2.93-3.15q-5.49-.64-8.53-5.17a1.55 1.54-22.5 0 0-1.58-.65L39.54 73.16a.85.85 0 0 0-.68.83q0 .57.19 1.64c.55 3.04-1.93 4.87-4.09 6.84a1.15 1.15 0 0 0-.24 1.37l28.44 55.98a1.04 1.04 0 0 0 .78.57l5.75.93a2.65 2.59 67.4 0 1 1.18.5l4.85 3.69a1.77 1.77 0 0 0 1.17.35c4.28-.31 7.9-1.25 11.97-2.06q43.39-8.7 43.82-8.76c2.94-.44 5.77-1.5 8.05-1.78q3.37-.41 6.09-1.02 11.74-2.61 26.51-5.37c3.62-.67 6.27-1.65 9.4-2.01 4.87-.56 8.01-1.56 14.14-3.07a.64.63 76.3 0 0 .46-.77q-1.26-5.16 3.83-8.32"
          />
          <path
            fill="#ec9c3b"
            d="M201.16 112.7q-5.09 3.16-3.83 8.32a.64.63 76.3 0 1-.46.77c-6.13 1.51-9.27 2.51-14.14 3.07-3.13.36-5.78 1.34-9.4 2.01q-14.77 2.76-26.51 5.37-2.72.61-6.09 1.02c-2.28.28-5.11 1.34-8.05 1.78q-.43.06-43.82 8.76c-4.07.81-7.69 1.75-11.97 2.06a1.77 1.77 0 0 1-1.17-.35l-4.85-3.69a2.65 2.59 67.4 0 0-1.18-.5l-5.75-.93a1.04 1.04 0 0 1-.78-.57L34.72 83.84a1.15 1.15 0 0 1 .24-1.37c2.16-1.97 4.64-3.8 4.09-6.84q-.19-1.07-.19-1.64a.85.85 0 0 1 .68-.83l118.59-23.8a1.55 1.54-22.5 0 1 1.58.65q3.04 4.53 8.53 5.17c1.5.17 2.23 1.9 2.93 3.15q15.88 28.36 30.18 53.62a.56.55 59.4 0 1-.19.75m-88.19-29.65a.62.62 0 0 1-.93.24c-7.15-5.35-14.14-9.38-23.3-8.04q-9.46 1.39-12.52 9.28-1.77 4.57-.18 9.03c2.87 8.06 9.87 13.27 17.44 17.47q6.95 3.86 15.62 7.35 13.16 5.3 14.94 5.81 1.97.57 3.9.77a2.83 2.82 22.5 0 0 2.51-1.03c6.74-8.36 13.5-18.32 17.12-28.4 2.19-6.1 3.25-11.23 1.27-17.38-3.76-11.65-18.45-14.51-27.54-7.26-4.11 3.28-6.25 7.56-8.33 12.16"
          />
          <path
            fill="#cb7a21"
            d="M4.91 64.23q18.95 39.38 38.64 77.37l6 12.11q3.75 7.57 8.24 14.79l-.25 23.49q-3.09-2.83-4.7-6.06c-3.9-7.83-7.74-14.32-10.71-20.58q-4.49-9.46-12.43-24.39c-1.97-3.71-3.85-7.93-6.27-12.34-4.89-8.88-10.05-19.5-14.09-26.75a2.28 2.05-66.7 0 1-.25-.74l-.55-3.74a2.33 1.94-66.3 0 0-.12-.42L5.18 89.5a.6.6 0 0 0-1.1 0q-.13.32-.09 1.43-1.38-13.73.92-26.7"
          />
          <path
            fill="#bc6e19"
            d="M112.97 83.05c2.08-4.6 4.22-8.88 8.33-12.16 9.09-7.25 23.78-4.39 27.54 7.26 1.98 6.15.92 11.28-1.27 17.38-3.62 10.08-10.38 20.04-17.12 28.4a2.83 2.82 22.5 0 1-2.51 1.03q-1.93-.2-3.9-.77-1.78-.51-14.94-5.81-8.67-3.49-15.62-7.35c-7.57-4.2-14.57-9.41-17.44-17.47q-1.59-4.46.18-9.03 3.06-7.89 12.52-9.28c9.16-1.34 16.15 2.69 23.3 8.04a.62.62 0 0 0 .93-.24m.64 5.23q-.94-.24-1.4-.66c-3.68-3.33-10.27-7.98-15.7-8.88-3.03-.51-9.33-.63-12.4 1.52-7.31 5.09-6.37 12.55-.99 18.61q4.59 5.17 10.77 8.5 15.46 8.33 32.95 14.02a1.34 1.33 28.4 0 0 1.43-.42c7.13-8.75 13.73-18.92 16.9-29.78 1.49-5.11 1.66-12.77-2.37-16.67q-3.51-3.41-7.3-3.95-9.42-1.35-15.13 6.34-3.56 4.8-5.52 10.69a1.05 1.04 16 0 1-1.24.68"
          />
          <path
            fill="#ec9c3b"
            d="M113.61 88.28a1.05 1.04 16 0 0 1.24-.68q1.96-5.89 5.52-10.69 5.71-7.69 15.13-6.34 3.79.54 7.3 3.95c4.03 3.9 3.86 11.56 2.37 16.67-3.17 10.86-9.77 21.03-16.9 29.78a1.34 1.33 28.4 0 1-1.43.42q-17.49-5.69-32.95-14.02-6.18-3.33-10.77-8.5c-5.38-6.06-6.32-13.52.99-18.61 3.07-2.15 9.37-2.03 12.4-1.52 5.43.9 12.02 5.55 15.7 8.88q.46.42 1.4.66"
          />
          <path
            fill="#bc6e19"
            d="M57.54 191.99q1 1.42 2.62 1.11 20.27-3.95 27.49-5.57c3.86-.87 7.25-.95 11.42-2.02q1.65-.43 7.34-1.48 2.57-.48 17.78-3.53c3.14-.62 6.3-1.68 9.41-1.91q2.23-.17 7.08-1.3 8.78-2.03 24.03-4.64c2.04-.35 4.69-1.53 6.31-1.66q3.36-.25 14.28-2.61 6.45-1.39 18.45-3.59c4.75-.87 9.03-2.3 13.69-2.83q2.52-.28 6.09-1.22 2.98-.79 6.01-1.58l-.3 6.05q-3.26.05-4.12.21c-15.5 2.85-32.91 6.53-46.4 9.09q-22.3 4.24-45.76 8.96-5.87 1.19-24.18 4.7-37.31 7.15-42.94 8.08-3.99.67-6.66.6a.51.51 0 0 0-.52.52c.12 4.16.28 10.81-.06 16.15-.35 5.4-.95 10.08.69 13.85a.9.9 0 0 0 .81.54l4.68.04q-2.68.91-5.64.48a.57.56-4.9 0 1-.46-.38q-.03-.06-.06-.19a.63.59 13.9 0 0-.19-.29q-2.59-2.2-4.56-5.45-5.75-9.5-11.08-19.18-10.38-18.88-19.94-37.68-1.49-2.93-1.63-3.11c-1.08-1.44-1.37-2.89-2.25-4.59q-5-9.58-5.55-10.48-1.01-1.66-2.35-4.94a5 4.89-73.4 0 0-.47-.89q-3.31-5.09-3.32-9.21Q7.27 115 7.25 98.3a2.27 2.24 32.3 0 0-.23-.99l-3.03-6.38q-.04-1.11.09-1.43a.6.6 0 0 1 1.1 0l3.24 7.47a2.33 1.94-66.3 0 1 .12.42l.55 3.74a2.28 2.05-66.7 0 0 .25.74c4.04 7.25 9.2 17.87 14.09 26.75 2.42 4.41 4.3 8.63 6.27 12.34q7.94 14.93 12.43 24.39c2.97 6.26 6.81 12.75 10.71 20.58q1.61 3.23 4.7 6.06"
          />
          <path
            fill="#d78629"
            d="M233.21 131.74q.39 2.07.4 3.01.15 15.05-.17 20.52-.17 3.01-3.9 3.89-3.03.79-6.01 1.58-3.57.94-6.09 1.22c-4.66.53-8.94 1.96-13.69 2.83q-12 2.2-18.45 3.59-10.92 2.36-14.28 2.61c-1.62.13-4.27 1.31-6.31 1.66q-15.25 2.61-24.03 4.64-4.85 1.13-7.08 1.3c-3.11.23-6.27 1.29-9.41 1.91q-15.21 3.05-17.78 3.53-5.69 1.05-7.34 1.48c-4.17 1.07-7.56 1.15-11.42 2.02q-7.22 1.62-27.49 5.57-1.62.31-2.62-1.11l.25-23.49q2.54-.34 4.61-.68 12.14-1.97 21.39-3.88 5.32-1.1 8.57-1.53c3.83-.52 7.61-1.65 11.36-2.35 11.49-2.14 23.48-4.8 32.51-6.51q27.71-5.28 58.44-11.71c3.89-.82 8.71-1.4 12.96-2.53 6.54-1.74 13.42-2.79 22.76-4.65q1.45-.29 2.82-2.92m-99.11 34.09.18.83a.22.22 0 0 0 .27.16l6.13-1.35a11.8.52-12.4 0 0 11.41-3.04l-.05-.23a11.8.52-12.4 0 0-11.64 2.02l-6.13 1.35a.22.22 0 0 0-.17.26"
          />
          <path
            fill="#cb7a21"
            d="M134.1 165.83a.22.22 0 0 1 .17-.26l6.13-1.35a11.8.52-12.4 0 1 11.64-2.02l.05.23a11.8.52-12.4 0 1-11.41 3.04l-6.13 1.35a.22.22 0 0 1-.27-.16zM229.24 165.21q-.1 6.74-.66 25.32c-.1 3.03-1.49 3.82-4.36 4.55-8.77 2.24-20.4 4.09-30.47 6.71-4.74 1.24-9.03 1.29-13.58 2.58q-1.75.49-18.87 3.82c-4.11.8-9.99 2.46-15.35 3.22q-1.96.28-6.13 1.2-10.49 2.32-16.43 3.33-4.91.83-7.57 1.47-6.07 1.46-7.53 1.7-6.26.99-13.98 2.76-1.11.25-14.8 2.84-7.4 1.4-14.73 3.24l-4.68-.04a.9.9 0 0 1-.81-.54c-1.64-3.77-1.04-8.45-.69-13.85.34-5.34.18-11.99.06-16.15a.51.51 0 0 1 .52-.52q2.67.07 6.66-.6 5.63-.93 42.94-8.08 18.31-3.51 24.18-4.7 23.46-4.72 45.76-8.96c13.49-2.56 30.9-6.24 46.4-9.09q.86-.16 4.12-.21m-61.57 21.37q11.57-1.19 25.64-4.2c4.86-1.04 9.45-1.87 14.03-3.8a.38.38 0 0 0-.23-.73q-14.11 3.12-30.73 6.02-4.63.81-8.76 2.55a.09.08 29.5 0 0 .05.16m-64.92 12.73q10.76-2.06 21.41-4.15 5.38-1.05 10.98-3.29a.37.36-60.5 0 0-.19-.7q-12.96 2.25-24.11 4.93-4.11.99-8.31 2.55a.21.21 0 0 0-.11.3l.16.27a.16.16 0 0 0 .17.09m33.26 3.76c7.28-.68 14.52-2.33 20.76-3.32q4.62-.73 9.47-2.79a.45.44-20.6 0 0 .25-.55l-.04-.11a.4.38-15.6 0 0-.46-.25q-12.14 2.81-24.45 4.78-3.53.57-5.71 1.55a.36.36 0 0 0 .18.69"
          />
          <path
            fill="#bc6e19"
            d="M167.62 186.42q4.13-1.74 8.76-2.55 16.62-2.9 30.73-6.02a.38.38 0 0 1 .23.73c-4.58 1.93-9.17 2.76-14.03 3.8q-14.07 3.01-25.64 4.2a.09.08 29.5 0 1-.05-.16M102.75 199.31a.16.16 0 0 1-.17-.09l-.16-.27a.21.21 0 0 1 .11-.3q4.2-1.56 8.31-2.55 11.15-2.68 24.11-4.93a.37.36-60.5 0 1 .19.7q-5.6 2.24-10.98 3.29-10.65 2.09-21.41 4.15M136.01 203.07a.36.36 0 0 1-.18-.69q2.18-.98 5.71-1.55 12.31-1.97 24.45-4.78a.4.38-15.6 0 1 .46.25l.04.11a.45.44-20.6 0 1-.25.55q-4.85 2.06-9.47 2.79c-6.24.99-13.48 2.64-20.76 3.32"
          />
        </svg>
      );
    case ALL_CATEGORIES:
      return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
          <rect
            width="35.96"
            height="35.96"
            x="-17.98"
            y="-17.98"
            fill="#2ecc71"
            rx="2.96"
            transform="rotate(.1 -16023.095 16045.35)"
          />
          <rect
            width="35.96"
            height="35.96"
            x="-17.98"
            y="-17.98"
            fill="#2ecc71"
            rx="2.97"
            transform="rotate(.1 -16007.31 40699.723)"
          />
          <rect width="35.94" height="35.94" x="10.01" y="54.05" fill="#2ecc71" rx="2.93" />
          <rect
            width="35.96"
            height="35.96"
            x="-17.98"
            y="-17.98"
            fill="#2ecc71"
            rx="2.95"
            transform="rotate(.1 -41228.905 40721.733)"
          />
        </svg>
      );
      return (
        <svg
          className={classes}
          width="48px"
          height="48px"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M13 2a9 9 0 0 1 9 9" />
          <path d="M13 6a5 5 0 0 1 5 5" />
          <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
        </svg>
      );

    default:
      return null;
  }
};

export default ExtraIcons;
